// UI strings: Norwegian Bokmål (loaded as i18n resources `nb` and `no` in src/i18n.js).
export const no = {
    translation: {
        "project_selector.favorites": "Favoritter",
        "project_selector.suggested": "Foreslåtte prosjekter",
        "project_selector.search_results": "Søkeresultater",
        "project_selector.projects": "Prosjekter",
        "project_selector.no_projects_found": "Ingen prosjekter funnet",
        "project_selector.no_projects_to_show": "Ingen prosjekter å vise",
        "project_selector.offer": "Tilbud",
        "project_selector.sub_of": "Under",
        "project_list.scope.projects": "Prosjekter",
        "project_list.scope.offers": "Tilbud",
        "project_list.scope.all": "Alle",
        "project_list.badge.offer": "Tilbud",
        "project_list.badge.subproject": "Underprosjekt",
        "project_list.sub_of": "Hører til",
        "project.parent_project": "Overordnet prosjekt",
        "project.parent_project.none": "Ingen overordnet",
        "Case guide": "Case guide",
        "Guider": "Guider",
        "Guider tilgjengelig": "Guider tilgjengelig",
        "guider": "guider",
        "Velg hvilken guide du vil bruke for etterspurt info.": "Velg hvilken guide du vil bruke for etterspurt info.",
        "Velg hvilken guide du vil starte for denne saken.": "Velg hvilken guide du vil starte for denne saken.",
        "Dupliser guide": "Dupliser guide",
        "kopi": "kopi",
        "Uten navn": "Uten navn",
        "Rapportguide": "Rapportguide",
        "Rapportguider": "Rapportguider",
        "Opprett og rediger guidede flyter for rapportarbeid.": "Opprett og rediger guidede flyter for rapportarbeid.",
        "Guideomfang": "Guideomfang",
        "Velg om du vil redigere generelle rapportguider eller guider for en spesifikk rapporttype.": "Velg om du vil redigere generelle rapportguider eller guider for en spesifikk rapporttype.",
        "Tilbake til serviceinnstillinger": "Tilbake til serviceinnstillinger",
        "Generelle rapportguider": "Generelle rapportguider",
        "Opprett og rediger guidede flyter for rapportarbeid på egen side.": "Opprett og rediger guidede flyter for rapportarbeid på egen side.",
        "Åpne rapportguider": "Åpne rapportguider",
        "Caseguider": "Caseguider",
        "Opprett og rediger guidede flyter for saker.": "Opprett og rediger guidede flyter for saker.",
        "Guideomfang case": "Guideomfang (case type)",
        "Velg case type for å redigere guideflyten.": "Velg case type for å redigere guideflyten.",
        "Case guides scope intro":
          "Velg om du vil redigere generelle caseguider (alle typer) eller guider som gjelder én bestemt case type — samme mønster som rapportguider.",
        "Generelle caseguider": "Generelle caseguider",
        "Generell caseguide": "Generell",
        "Case guide scope general hint": "Guider som gjelder alle case typer.",
        "Case guide scope type hint":
          "Viser guider for denne case typen pluss eventuelle generelle guider. Type-spesifikke guider listes først.",
        "Tilbake til caseinnstillinger": "Tilbake til caseinnstillinger",
        "Åpne caseguider": "Åpne caseguider",
        "Opprett og rediger guidede flyter for saker på egen side.": "Opprett og rediger guidede flyter for saker på egen side.",
        "Ingen case typer er opprettet ennå.": "Ingen case typer er opprettet ennå.",
        "Caseguide-bygger på egen side": "Caseguide-bygger åpner på egen side.",
        "Åpne guidebygger": "Åpne guidebygger",
        "Case guide options connect to effect nodes":
          "Svarvalg har kun tekst og verdi. Bruk Koble på et valg og pek til en effekt-node på lerretet (etiketter, prioritet, frist osv.).",
        "Velg rapportguide": "Velg rapportguide",
        "Velg guiden som passer best med oppdraget.": "Velg guiden som passer best med oppdraget.",
        "Velg guide": "Velg guide",
        "Ny rapportguide": "Ny rapportguide",
        "Ny guide": "Ny guide",
        "Inaktiv": "Inaktiv",
        "Generell": "Generell",
        "Generell rapportguide": "Generell rapportguide",
        "Kan brukes på alle rapporttyper": "Kan brukes på alle rapporttyper",
        "spørsmål": "spørsmål",
        "Avslutt etter dette svaret": "Avslutt etter dette svaret",
        "Guide builder": "Guidebygger",
        "Effekter": "Effekter",
        "Effekt": "Effekt",
        "Effect-node": "Effect-node",
        "Guide flow palette effect id line": "Oppretter node på lerretet med effekt-id:",
        "Guide flow effect editor palette link": "Samme blokk i paletten / effekt-id",
        "Guide flow option connection": "Dette svaret går til",
        "Rapporttekst": "Rapporttekst",
        "Intern tekst": "Intern tekst",
        "Case oppfølging": "Case oppfølging",
        "Sjekkliste": "Sjekkliste",
        "Videre": "Videre",
        "Avslutt etter denne effekten": "Avslutt etter denne effekten",
        "Rediger effekt": "Rediger effekt",
        "Opprett spørsmål som noder og koble svar til neste spørsmål.": "Opprett spørsmål som noder og koble svar til neste spørsmål.",
        "Dra inn eller klikk for å opprette.": "Dra inn eller klikk for å opprette.",
        "Guide flow": "Guideflyt",
        "guide.flow.json_dialog_title": "Guideflyt — JSON og AI-instruks",
        "guide.flow.json_tab": "JSON",
        "guide.flow.ai_guide_tab": "Instruks til AI",
        "guide.flow.json_hint":
          "Kanter bygges automatisk fra `next_node_id` på svar og effekter. Lim inn eller rediger JSON og trykk Bruk på lerretet.",
        "guide.flow.copy_json": "Kopier JSON",
        "guide.flow.apply_json": "Bruk på lerret",
        "guide.flow.reload_from_canvas": "Last inn fra lerret",
        "guide.flow.reload_from_canvas_success": "Tekstfeltet er oppdatert fra lerretet.",
        "guide.flow.copy_json_success": "JSON er kopiert til utklippstavlen.",
        "guide.flow.clipboard_failed": "Klarte ikke å bruke utklippstavlen.",
        "guide.flow.json_invalid": "Ugyldig JSON eller flyt: {{message}}",
        "guide.flow.json_applied": "Guideflyten er oppdatert.",
        "guide.flow.copy_ai_guide": "Kopier AI-instruks",
        "guide.flow.ai_guide_copied": "AI-instruks kopiert.",
        "guide.flow.ai_empty": "AI returnerte tom flyt-JSON.",
        "guide.flow.ai_applied": "Guideflyt oppdatert fra AI.",
        "guide.flow.open_json": "JSON",
        "guide.flow.open_json_tooltip": "Vis, kopier, lim inn eller rediger guideflyten som JSON",
        "guide.flow.generate_with_ai": "Generer med AI",
        "guide.flow.ai_guide_intro":
          "Lim inn i eksterne AI-verktøy eller bruk Promangs innebygde generator. Tekniske nøkler samsvarer med `settings.flow` i API-et.",

        "Velg neste spørsmål for valgt svar.": "Velg neste spørsmål for valgt svar.",
        "Koble svar til neste spørsmål ved å bruke Koble-knappen på et svar.": "Koble svar til neste spørsmål ved å bruke Koble-knappen på et svar.",
        "Nytt spørsmål": "Nytt spørsmål",
        "Koble": "Koble",
        "Koble om": "Koble om",
        "Slett kobling": "Slett kobling",
        "Sett som start": "Sett som start",
        "Rediger spørsmål": "Rediger spørsmål",
        "Svarvalg": "Svarvalg",
        "Velg en node for å redigere.": "Velg en node for å redigere.",
        "Dato": "Dato",
        "Tid": "Tid",
        "Guidet rapport": "Guidet rapport",
        "Ingen rapportguide er tilgjengelig": "Ingen rapportguide er tilgjengelig",
        "Rapportguide lagret": "Rapportguide lagret",
        "Guiden kan fylle rapporttekst og lagrer svar for administrasjon.": "Guiden kan fylle rapporttekst og lagrer svar for administrasjon.",
        "Lagre rapporttypen før du konfigurerer guide.": "Lagre rapporttypen før du konfigurerer guide.",
        "Konfigurer spørsmål som kan fylle rapporttekst og lagre svar for administrasjon.": "Konfigurer spørsmål som kan fylle rapporttekst og lagre svar for administrasjon.",
        "Ta med svar i rapporttekst": "Ta med svar i rapporttekst",
        "Rapporttekst ved valg": "Rapporttekst ved valg",
        "Intern tekst ved valg": "Intern tekst ved valg",
        "Case oppfølging tittel": "Case oppfølging tittel",
        "Case oppfølging tekst": "Case oppfølging tekst",
        "Krever tiltak": "Krever tiltak",
        "Reklamasjon": "Reklamasjon",
        "Ingen sjekkliste": "Ingen sjekkliste",
        "Opprett sjekkliste": "Opprett sjekkliste",
        "Opprett oppfølger": "Opprett oppfølger",
        "Oppfølger beskrivelse": "Oppfølger beskrivelse",
        "Oppfølger intern beskrivelse": "Oppfølger intern beskrivelse",
        "Ingen sjekkliste på oppfølger": "Ingen sjekkliste på oppfølger",
        "Opprett avtale på oppfølger": "Opprett avtale på oppfølger",
        "Bruk samme avtaledato og tid som nåværende rapport": "Bruk samme avtaledato og tid som nåværende rapport",
        "Guidet case-opprettelse": "Guidet case-opprettelse",
        "Etterspørre info": "Etterspørre info",
        "Etterspurt info": "Etterspurt info",
        "Guidet opprettelse": "Guidet opprettelse",
        "Spørsmål": "Spørsmål",
        "Steg": "Steg",
        "Oppsummering": "Oppsummering",
        "guide.case_view_summary": "Se oppsummering",
        "guide.case_summary_review_intro": "Kontroller svarene før du bruker guiden.",
        "guide.case_chain_effect_title": "Start en annen caseguide",
        "guide.case_chain_effect_help":
          "Når denne guiden er brukt på saken, åpnes den valgte guiden automatisk (denne guiden fullføres først).",
        "guide.case_chain_pick_guide": "Neste guide",
        "guide.case_chain_none": "— ingen —",
        "guide.case_chain_started": "Åpner neste guide…",
        "guide.case_chain_summary_hint":
          "Etter at du bruker guiden, startes en annen guide automatisk på samme sak.",
        "Ingen guide-spørsmål er konfigurert.": "Ingen guide-spørsmål er konfigurert.",
        "Guiden foreslår": "Guiden foreslår",
        "etiketter": "etiketter",
        "Bruk guide": "Bruk guide",
        "Åpne guide": "Åpne guide",
        "Tilbake": "Tilbake",
        "Neste": "Neste",
        "Besvart": "Besvart",
        "Automatiske etiketter brukt": "Automatiske etiketter brukt",
        "Automatiske etiketter lagt til": "Automatiske etiketter lagt til",
        "Antall": "Antall",
        "Denne case typen krever guide før opprettelse": "Denne case typen krever guide før opprettelse",
        "Fyll ut guide": "Fyll ut guide",
        "Fyll ut guiden før saken opprettes": "Fyll ut guiden før saken opprettes",
        "besvarte etterspurt info": "besvarte etterspurt info",
        "fullførte guide": "fullførte guide",
        "Konfigurer spørsmål, valg og automatiske etiketter for denne case typen.": "Konfigurer spørsmål, valg og automatiske etiketter for denne case typen.",
        "Lagre case type før du konfigurerer guide.": "Lagre case type før du konfigurerer guide.",
        "Guide title": "Guide-tittel",
        "Guide description": "Guide-beskrivelse",
        "Aktiv": "Aktiv",
        "Legg til spørsmål": "Legg til spørsmål",
        "Lagre guide": "Lagre guide",
        "Spørsmålstekst": "Spørsmålstekst",
        "Påkrevd": "Påkrevd",
        "Valg": "Valg",
        "Valg 1": "Valg 1",
        "Valg label": "Valgtekst",
        "Verdi": "Verdi",
        "Fjern valg": "Fjern valg",
        "Automatiske etiketter": "Automatiske etiketter",
        "Legg til valg": "Legg til valg",
        "Select case type": "Velg case type",
        "Case Type": "Case type",
        "No results": "Ingen treff",
        "Select case type first": "Velg case type først",
        "No guide configured for this case type": "Ingen guide er konfigurert for denne case typen",
        "Ny case": "Ny case",
        "Velg case type først. Guiden hjelper deg å stille riktige spørsmål og foreslår etiketter automatisk.": "Velg case type først. Guiden hjelper deg å stille riktige spørsmål og foreslår etiketter automatisk.",
        "Title and case type are required": "Tittel og case type er påkrevd",
        "Case type is required": "Case type er påkrevd",
        "Velg case type først. Tittel genereres automatisk med AI etter opprettelse.": "Velg case type først. Tittel genereres automatisk med AI etter opprettelse.",
        "Guide åpnes etter opprettelse": "Guide åpnes etter opprettelse",
        "Etter opprettelse": "Etter opprettelse",
        "Velg case type først. Hvis typen har en guide kan du besvare den før saken opprettes.": "Velg case type først. Hvis typen har en guide kan du besvare den før saken opprettes.",
        "Valgfri guide for denne case typen": "Valgfri guide for denne case typen",
        "Type": "Type",
        "Detaljer": "Detaljer",
        "Velg type": "Velg type",
        "Saksdetaljer": "Saksdetaljer",
        "Guide besvart": "Guide besvart",
        "Klar til opprettelse": "Klar til opprettelse",
        "Se guide igjen": "Se guide igjen",
        "Start guide": "Start guide",
        "Hva slags case oppretter du?": "Hva slags case oppretter du?",
        "Case typen styrer hvilke spørsmål og automatiske forslag som vises.": "Case typen styrer hvilke spørsmål og automatiske forslag som vises.",
        "Guide": "Guide",
        "Ikke brukt": "Ikke brukt",
        "Ja": "Ja",
        "Nei": "Nei",
        "templates.title": "Maler",
        "templates.new": "Ny mal",
        "templates.edit": "Rediger mal",
        "templates.empty": "Ingen maler funnet.",
        "templates.search_placeholder": "Søk i maler...",
        "templates.editor_placeholder": "Skriv innholdet i malen...",
        "templates.editor_hint": "Lag gjenbrukbart rich text-innhold og knytt det til en kategori.",
        "templates.form.title": "Maldetaljer",
        "templates.form.subtitle": "Gi malen en tydelig tittel, kategori og rich text-innhold.",
        "templates.insert.append": "Lim inn sammen med eksisterende tekst",
        "templates.insert.replace": "Bytt ut hele teksten",
        "templates.insert.use": "Bruk mal",
        "templates.hero.kicker": "Innholdsbibliotek",
        "templates.hero.subtitle": "Organiser gjenbrukbare tekstmaler i kategorier og sett dem inn fra rich text-editorer.",
        "templates.filters.heading": "Søk og filter",
        "templates.filters.description": "Søk i maler eller filtrer på kategori.",
        "templates.categories.title": "Kategorier",
        "templates.categories.all": "Alle maler",
        "templates.categories.new": "Ny kategori",
        "templates.categories.edit": "Rediger kategori",
        "templates.categories.name": "Navn",
        "templates.categories.parent": "Overordnet kategori",
        "templates.categories.no_parent": "Ingen overordnet kategori",
        "templates.categories.description": "Beskrivelse",
        "templates.categories.uncategorized": "Ikke kategorisert",
        "templates.section.kicker": "Maler",
        "templates.section.title": "Alle maler",
        "templates.section.subtitle": "Velg en kategori for å se malene som er knyttet til den.",
        "templates.section.category_title": "Maler i kategorien",
        "templates.section.category_subtitle": "Maler som er knyttet til valgt kategori.",
        "company.settings.tabs.company": "Firma",
        "company.settings.tabs.employment_agreement": "Arbeidsavtale",
        "company.employment_agreement.title": "Standard avtaletekst",
        "company.employment_agreement.description": "Denne teksten legges inn som felles avtaletekst i arbeidsavtale-PDF-en for ansatte.",
        "company.employment_agreement.placeholder": "Skriv standard avtaletekst for arbeidsavtaler...",
        "pagination.previous": "Forrige",
        "pagination.next": "Neste",
        "pagination.showing": "Viser {{current}} av {{total}}",
        "pagination.loadMore": "Last inn flere",
        "payslips.kicker": "Tripletex lønn",
        "payslips.title": "Lønn",
        "payslips.mine_title": "Mine lønnslipper",
        "payslips.admin_title": "Lønnslipper",
        "payslips.stats_title": "Statistikk",
        "payslips.description": "Se lønnslipper som er gjort tilgjengelig fra Tripletex uten å logge inn i Tripletex.",
        "payslips.admin_description": "Administrer og filtrer lønnslipper for ansatte. Krever rollen Lønn Admin (bedriftsadministratorar ser berre eigne lønnslippar utan denne rolla).",
        "payslips.stats_description": "Oversikt over lønnslippene som inngår i summene under (eigne med mindre du har Lønn Admin).",
        "payslips.admin_forbidden": "Du trenger rollen Lønn Admin for å administrere alle lønnslipper i selskapet. Be en administrator tildele Lønn Admin for dette selskapet.",
        "payslips.role_view_override_warning":
          "Rollevisning er aktiv — den endrer bare menyer/UI. API-et bruker fortsatt dine ekte roller. Slå av rollevisning (DevOps-menyen) for å samsvare med tilganger.",
        "payslips.loading": "Laster lønnslipper...",
        "payslips.empty": "Ingen lønnslipper er tilgjengelig ennå.",
        "payslips.error": "Kunne ikke hente lønnslipper.",
        "payslips.period": "Periode",
        "payslips.employee": "Ansatt",
        "payslips.voucher_date": "Bilagsdato",
        "payslips.available_date": "Tilgjengelig",
        "payslips.gross_amount": "Brutto",
        "payslips.amount": "Netto",
        "payslips.actions": "Handlinger",
        "payslips.open": "Åpne",
        "payslips.opening": "Åpner...",
        "payslips.sync_now": "Synkroniser nå",
        "payslips.syncing": "Synkroniserer...",
        "payslips.employee_filter": "Ansatt",
        "payslips.stats_count": "Antall lønnslipper",
        "payslips.stats_gross": "Brutto totalt",
        "payslips.stats_net": "Netto totalt",
        "payslips.stats_average_net": "Snitt netto",
        "listbox.none": "Ikke valgt",
        "user_info.address": "Adresse",
        "user_info.address_hint": "Lagres på brukerprofilen og brukes som adressegrunnlag i ansettelsesflyten.",
        "user_employment.option_not_selected": "Ikke valgt",
        "user_employment.section_basic": "Ansettelsesgrunnlag",
        "user_employment.section_basic_hint": "Grunnleggende data for arbeidsforholdet og arbeidsavtalen.",
        "user_employment.employee_number": "Ansattnummer",
        "user_employment.employment_starts": "Ansettelse starter",
        "user_employment.social_security": "Fødselsnummer",
        "user_employment.working_posistion": "Stilling",
        "user_employment.workplace": "Arbeidssted",
        "user_employment.agreement_type": "Avtaletype",
        "user_employment.agreement_type_permanent": "Fast",
        "user_employment.agreement_type_temporary": "Midlertidig",
        "user_employment.agreement_type_hourly": "Tilkalling/timebasert",
        "user_employment.agreement_type_seasonal": "Sesong",
        "user_employment.agreement_type_other": "Annet",
        "user_employment.section_worktime": "Arbeidstid",
        "user_employment.section_worktime_hint": "Tidsrom som kan brukes i arbeidsavtalen.",
        "user_employment.worktime_regular_from": "Ordinær fra",
        "user_employment.worktime_regular_too": "Ordinær til",
        "user_employment.worktime_weekend_from": "Helg fra",
        "user_employment.worktime_weekend_too": "Helg til",
        "user_employment.worktime_regular_range": "Ordinær arbeidstid",
        "user_employment.worktime_weekend_range": "Helgearbeid",
        "user_employment.section_wages": "Lønn og tillegg",
        "user_employment.section_wages_hint": "Avtalte lønnsbetingelser. Lønnstabellen under beholdes for historikk og timeberegninger.",
        "user_employment.wages": "Lønn",
        "user_employment.wages_unit": "Lønn per",
        "user_employment.wage_unit_hour": "Time",
        "user_employment.wage_unit_month": "Måned",
        "user_employment.wage_unit_year": "År",
        "user_employment.wage_unit_fixed": "Fast avtalt",
        "user_employment.overtime_pay": "Overtidsgodtgjørelse",
        "user_employment.dismissal": "Oppsigelsestid",
        "user_employment.wage_other_addition": "Andre tillegg",
        "user_employment.wage_weekend_and_night_addition": "Helg-/nattillegg",
        "user_employment.collective_agreement": "Tariffavtale",
        "user_employment.section_contract_text": "Avtaletekst",
        "user_employment.section_contract_text_hint": "Tekstfelter som danner grunnlag for arbeidsavtale og intern dokumentasjon.",
        "user_employment.employment_instructions": "Stillingsinstruks",
        "user_employment.employment_allowance": "Godtgjørelse",
        "user_employment.notes": "Notater",
        "user_employment.other": "Annet",
        "user_employment.section_signature": "Signatur og betaling",
        "user_employment.section_signature_hint": "Signerings- og betalingsgrunnlag for arbeidsavtalen.",
        "user_employment.signed_place": "Signeringssted",
        "user_employment.signed_at": "Signeringsdato",
        "user_employment.account_number": "Kontonummer",
        "user_employment.hourly_costs_title": "Timepriser og kostnader",
        "user_employment.section_contract_actions": "Arbeidsavtale",
        "user_employment.section_contract_actions_hint": "Utskrift og signering kobles mot avtalegrunnlaget når PDF/signering er tilgjengelig.",
        "user_employment.contract_actions_notice_title": "Klar for neste fase",
        "user_employment.contract_actions_notice": "Datagrunnlaget kan nå fylles ut. Utskrift av arbeidsavtale og Posten signering kobles på i egen implementasjon.",
        "user_employment.print_contract": "Skriv ut arbeidsavtale",
        "user_employment.print_contract_unavailable": "PDF-rute for arbeidsavtale er ikke koblet på ennå.",
        "user_employment.send_to_signing": "Send til signering",
        "user_employment.signing_unavailable": "Posten signering implementeres av separat agent.",
        "user_employment.contract_title": "Arbeidsavtale",
        "user_employment.contract_description": "Arbeidsavtale til digital signering",
        "user_employment.preview_contract_draft": "Se utkast til arbeidsavtale",
        "user_employment.download_contract_draft_pdf": "Last ned PDF-utkast",
        "user_employment.draft_pdf_download_failed": "Kunne ikke laste ned PDF-utkast.",
        "user_employment.contract_draft_label": "Utkast",
        "user_employment.contract_draft_for": "For {{name}}",
        "user_employment.draft_notice_title": "Kontroller før signering",
        "user_employment.draft_notice": "Dette er en forhåndsvisning basert på lagrede og utfylte felt i skjemaet. Lagre endringer før du sender til signering.",
        "user_employment.employee_name": "Arbeidstaker",
        "signing.title": "Digital signering",
        "signing.description": "Send dokumentet til Posten Signering og følg signeringsstatus.",
        "signing.new_request": "Ny signeringsforespørsel",
        "signing.empty": "Ingen signeringsforespørsler er opprettet ennå.",
        "signing.sender_reference": "Referanse",
        "signing.signer_name": "Signaturnavn",
        "signing.national_identity_number": "Fødselsnummer / D-nummer",
        "signing.email": "E-post",
        "signing.mobile": "Mobil",
        "signing.identity_warning": "Bruk fødselsnummer/D-nummer når det er tilgjengelig. E-post/SMS-signering er gyldig, men Promang må da verifisere at riktig person signerte.",
        "signing.send": "Send til signering",
        "signing.created": "Signeringsforespørsel opprettet",
        "signing.refreshed": "Signeringsstatus oppdatert",
        "signing.refresh_status": "Oppdater status",
        "signing.download_signed": "Last ned signert PDF",
        "signing.errors.load_failed": "Kunne ikke hente signeringsforespørsler.",
        "signing.errors.create_failed": "Kunne ikke opprette signeringsforespørsel.",
        "signing.errors.poll_failed": "Kunne ikke oppdatere signeringsstatus.",
        "signing.errors.download_failed": "Kunne ikke laste ned signert dokument.",
        "signing.status.draft": "Utkast",
        "signing.status.queued": "I kø",
        "signing.status.sent": "Sendt",
        "signing.status.in_progress": "Pågår",
        "signing.status.completed": "Fullført",
        "signing.status.failed": "Feilet",
        "signing.status.rejected": "Avvist",
        "signing.status.expired": "Utløpt",
        "signing.status.cancelled": "Kansellert",
        "signing.status.waiting": "Venter",
        "signing.status.available": "Tilgjengelig",
        "signing.status.signed": "Signert",
        "histories.title": "Historikk",
        "histories.subtitle": "Aktivitet og endringer",
        "histories.last_updated": "Sist oppdatert",
        "histories.last_edited": "Sist redigert",
        "histories.by_prefix": "av",
        "histories.no_data": "Ingen data ennå",
        "histories.filter_action": "Filtrer på handling",
        "histories.filter_all": "Alle",
        "histories.empty_filter": "Ingen hendelser for dette filteret.",
        "histories.load_more": "Last inn mer",
        "histories.loading_more": "Laster …",
        "histories.close": "Lukk",
        "histories.system_user": "Systemet",
        "histories.unknown_user": "Ukjent",
        "histories.sync_changes_heading": "Synk-metadata",
        "histories.action.tripletex_sync_attempt": "forsøkte Tripletex-synk for",
        "histories.action.tripletex_sync": "fullførte Tripletex-synk for",
        "histories.action.tripletex_sync_skipped": "hoppet over Tripletex-synk for",
        "histories.deviation_scope.deviation": "Avvik · tidslinje",
        "histories.deviation_scope.project": "Prosjekt · tidslinje",
        "histories.deviation_scope.customer": "Kunde · tidslinje",
        "deviation.work_order.link_dialog_title": "Tilknytt arbeidsordre",
        "deviation.work_order.section_title": "Knyttet arbeidsordre",
        "deviation.work_order.link_submit": "Lagre",
        "deviation.work_order.link_open": "Tilknytt arbeidsordre",
        "deviation.work_order.open_linked": "Åpne arbeidsordre",
        "deviation.work_order.unlink": "Fjern tilknytning",
        "deviation.work_order.change": "Bytt",
        "deviation.work_order.mode_existing": "Velg eksisterende",
        "deviation.work_order.mode_create": "Opprett ny",
        "deviation.work_order.existing_intro":
          "Bare arbeidsordrer uten annet tilknyttet avvik vises. Arbeidsordren som allerede er knyttet til dette avviket, kan velges eller fjernes.",
        "deviation.work_order.create_intro":
          "Opprett ny arbeidsordre — den blir knyttet til dette avviket når du lagrer.",
        "deviation.work_order.create_button": "Opprett arbeidsordre",
        "deviation.work_order.linked_after_create":
          "Arbeidsordre opprettet og knyttet til avviket",
        "deviation.work_order.link_failed_after_create":
          "Arbeidsordren ble opprettet, men kunne ikke knyttes til avviket. Åpne avviket og knytt arbeidsordren manuelt.",
        "deviation.work_order.suggested_wo_title_full":
          "Avvik {{number}} · {{title}}",
        "deviation.work_order.suggested_wo_title_number_only":
          "Avvik {{number}}",
        "deviation.work_order.toast_saved": "Arbeidsordre oppdatert",
        "deviation.form.work_order_heading": "Arbeidsordre fra avvik",
        "deviation.form.work_order_mode_none": "Ikke tilknyttet",
        "deviation.form.work_order_mode_existing": "Velg eksisterende",
        "deviation.form.work_order_mode_create": "Opprett ny",
        "deviation.form.work_order_create_timing_intro": "Hvordan skal oppdraget starte?",
        "deviation.form.work_order_perform_now": "Arbeid utføres nå",
        "deviation.form.work_order_plan_later": "Arbeid skal planlegges",
        "deviation.form.work_order_perform_now_help":
          "Arbeidsordre opprettes med avvikets tittel og beskrivelse, knyttes til avviket, og en hendelse (oppdrag) opprettes på valgt utfører – med start nå og 2 timer.",
        "deviation.form.work_order_plan_later_help":
          "Avviket lagres. Du sendes til å opprette arbeidsordre; den knyttes automatisk til avviket når du lagrer den nye ordren.",
        "deviation.form.executor_label": "Utfører oppdraget",
        "deviation.form.executor_pick": "Velg utfører",
        "deviation.form.executor_hint": "Hendelsen knyttes til denne brukeren.",
        "deviation.form.executor_dialog_help":
          "Den som skal stå som deltaker på hendelsen når oppdraget gjennomføres nå.",
        "deviation.form.need_project_customer_for_work_order":
          "Velg prosjekt og kunde (fra avviket) før du kan opprette eller planlegge arbeidsordre her.",
        "deviation.form.work_order_create_failed":
          "Kunne ikke opprette arbeidsordre.",
        "deviation.form.event_creation_failed":
          "Arbeidsordre ble opprettet, men hendelsen kunne ikke opprettes automatisk. Legg den til manuelt på arbeidsordren.",
        "deviation.form.work_order_and_event_saved":
          "Arbeidsordre og hendelse ble opprettet og knyttet til avviket.",
        "deviation.form.saved": "Lagret",
        "deviation.form.save_failed": "Noe gikk galt ved lagring.",
        "deviation.form.default_wo_title": "Avvik – arbeidsordre",
        "deviations.list.notified_none": "Ingen varsler sendt",
        "deviations.list.notified_compact_suffix": " (+{{count}})",
        "Dashboard": "Dashboard",
        "Overview of your workspace": "Oversikt over arbeidsområdet",
        "Collapse": "Skjul",
        "Expand": "Vis",
        "case": "Sak",
        "is mentioned here": "er nevnt her",
        "is mentioned elsewhere": "er nevnt andre steder",
        "sent_sms_to_customer": "Sendt SMS til kunde",
        "Resource Hub": "Ressurssenter",
        "resource_hub.faq.linked_records_title": "Koblede ressurser",
        "resource_hub.faq.linked_records_help":
          "Knytt innlegget til andre registreringer (HMS/KS-dokument, kjøretøy, produkt, rapport, kunde, prosjekt). Velg type og søk fram posten i listen — du trenger ikke skrive inn numerisk ID. For HMS/KS: skriv minst to tegn i søkefeltet for å finne dokumenter.",
        "resource_hub.faq.linked_records_add": "Legg til kobling",
        "resource_hub.faq.linked_records_type": "Ressurstype",
        "resource_hub.faq.linked_records_id": "ID",
        "resource_hub.faq.linked_records_pick": "Søk og velg …",
        "resource_hub.faq.linked_records_existing": "Tittel (lagret)",
        "resource_hub.faq.link_type.hse_document": "HMS / KS-dokument",
        "resource_hub.faq.link_type.vehicle": "Kjøretøy",
        "resource_hub.faq.link_type.product": "Produkt",
        "resource_hub.faq.link_type.report": "Rapport",
        "resource_hub.faq.link_type.customer": "Kunde",
        "resource_hub.faq.link_type.project": "Prosjekt",
        "resource_hub.faq.linked_records_placeholder_type": "Velg type",
        "service.agreements.list.hero_kicker": "Service",
        "service.agreements.list.subtitle":
          "Søk, filtrer på visning og administrer periodiske serviceavtaler.",
        "service.agreements.list.meta.total": "Avtaler",
        "service.agreements.list.meta.new": "Nye",
        "service.agreements.list.new": "Ny avtale",
        "service.agreements.list.filters_heading": "Filter",
        "service.agreements.list.filters_description":
          "Avgrens listen med søk og forhåndsdefinerte visninger.",
        "service.agreements.list.search_placeholder": "Søk i avtaler …",
        "service.agreements.list.sort_label": "Sortering",
        "service.agreements.list.per_page": "Per side",
        "service.agreements.list.table_kicker": "Liste",
        "service.agreements.list.table_title": "Avtaler",
        "service.agreements.list.table_description":
          "Velg rader for massehandlinger fra verktøylinjen over.",
        "service.agreements.filter.view": "Visning",
        "service.agreements.view.service_soon": "Service snart (5 dager)",
        "service.agreements.view.active": "Aktive",
        "service.agreements.sort.next_service_asc":
          "Neste service — tidligst først",
        "service.agreements.sort.next_service_desc":
          "Neste service — senest først",
        "service.agreements.sort.created_desc": "Opprettet — nyeste først",
        "service.agreements.sort.created_asc": "Opprettet — eldste først",
        "service.agreements.table.col_title": "Tittel",
        "service.agreements.table.col_type": "Type",
        "service.agreements.table.col_project": "Prosjekt",
        "service.agreements.table.col_customer": "Kunde",
        "service.agreements.table.col_delivery": "Leveringsadresse",
        "service.agreements.table.col_next": "Neste service",
        "service.agreements.table.col_interval": "Intervall",
        "service.agreements.table.col_status": "Status",
        "service.agreements.table.col_days": "Dager til service",
        "service.agreements.table.missing_address": "Ingen leveringsadresse",
        "service.agreements.table.col_next_job": "Neste oppdrag",
        "service.agreements.next_job.section_title": "Neste oppdrag",
        "service.agreements.next_job.next_on": "Neste oppdrag skal utføres",
        "service.agreements.next_job.days_until":
          "Det er {{count}} dager til neste oppdrag.",
        "service.agreements.next_job.in_progress": "Oppdrag er under utførelse",
        "service.agreements.actions.missing_type":
          "Mangler type, avtale kan ikke utføres",
        "service.agreements.actions.create_report": "Opprett ny rapport",
        "service.agreements.actions.create_order": "Opprett ordre",
        "service.agreements.actions.go_to_report": "Gå til rapport",
        "service.agreements.actions.hint_create_report":
          "Ny rapport blir opprettet. Når oppdraget er ferdig, blir neste service dato satt ut ifra ferdigstillelsedato.",
        "service.agreements.actions.hint_create_order":
          "Ny ordre opprettes, og neste service dato blir satt automatisk av systemet.",
        "service.agreements.actions.prompt_report_title": "Opprett ny rapport",
        "service.agreements.actions.prompt_report_body":
          "Er du sikker på at du vil opprette en ny rapport for denne serviceavtalen?",
        "service.agreements.actions.prompt_order_title": "Opprett ny ordre",
        "service.agreements.actions.prompt_order_body":
          "Er du sikker på at du vil opprette en ny ordre for denne serviceavtalen?",
        "service.agreements.actions.err_no_agreement":
          "Kan ikke opprette uten serviceavtale",
        "service.agreements.actions.err_active_report_report":
          "Kan ikke opprette rapport når det er en aktiv rapport",
        "service.agreements.actions.err_active_report_order":
          "Kan ikke opprette ordre når det er en aktiv rapport",
        "service.agreements.actions.err_no_customer_report":
          "Kan ikke opprette rapport uten kunde",
        "service.agreements.actions.err_no_customer_order":
          "Kan ikke opprette ordre uten kunde",
        "service.report.order_dialog.title_create": "Opprett ordre fra rapport",
        "service.report.order_dialog.title_additional": "Opprett tilleggsordre",
        "service.report.product_line_dialog.title": "Produktlinje",
        "service.report.product_line_dialog.delete_line": "Slett linje",
        "service.report.product_line_dialog.delete_tooltip": "Slett linje",
        "service.report.product_line_dialog.delete_confirm_title":
          "Slette denne linjen permanent?",
        "service.report.product_line_dialog.delete_confirm_hint":
          "Handlingen kan ikke angres.",
        "service.report.product_line_dialog.delete_cancel": "Avbryt",
        "service.report.product_line_dialog.delete_confirm": "Slett",
        "service.report.product_line_dialog.delete_working": "Sletter…",
        "service.report.product_line_dialog.back_tooltip": "Tilbake til produktlinje",
        "service.report.order_dialog.dialog_eyebrow": "Ordre",
        "service.report.order_dialog.section_invoice": "Kunde og faktura",
        "service.report.order_dialog.section_km": "Kilometer",
        "service.report.order_dialog.section_price_lines": "Avtalte prislinjer",
        "service.report.order_dialog.section_order_group": "Ordregruppering",
        "service.report.order_dialog.price_lines_intro":
          "Følgende prislinjer legges automatisk til i ordren:",
        "service.report.order_dialog.price_lines_included_hours": "Inkluderte timer:",
        "service.report.order_dialog.price_lines_footer_note":
          "Disse prislinjene inkluderer {{hours}} timer som faktureres via prislinjene, ikke separat.",
        "service.report.order_dialog.generate_invoice": "Generer med ChatGPT",
        "service.report.order_dialog.generating_invoice": "Genererer…",
        "service.report.order_dialog.orders_heading": "Ordre på denne rapporten",
        "service.report.order_dialog.open_order": "Gå til ordre {{number}}",
        "service.report.order_dialog.create": "Opprett ordre",
        "service.report.order_dialog.create_another": "Opprett ny ordre",
        "service.report.order_dialog.follow_up_notice_title": "Tilleggsordre",
        "service.report.order_dialog.follow_up_notice_body":
          "Avtalte prislinjer ble lagt på første ordre fra rapporten og legges ikke inn automatisk på nye ordre. Du kan fakturere nye timer, kjøring og ordrelinjer som ikke allerede er fakturert.",
        "service.report.order_dialog.hours_rounding_label": "Avrunding av fakturerte timer",
        "service.report.order_dialog.hours_rounding_actual":
          "Faktisk registrert tid (ingen avrunding)",
        "service.report.order_dialog.hours_rounding_ceil_half":
          "Avrund opp til nærmeste halvtime (0,5 t)",
        "service.report.order_dialog.hours_rounding_nearest_half":
          "Avrund til nærmeste halvtime",
        "service.report.order_dialog.hours_rounding_ceil_hour": "Avrund opp til hele timer",
        "service.report.order_dialog.hours_rounding_nearest_hour": "Avrund til nærmeste hele time",
        "service.report.order_dialog.hours_rounding_hint":
          "Standard er faktisk tid. Velg avrunding kun når faktureringsregler krever det (tilsvarer gammel «avrund opp til halvtime» når du velger opp til halvtime).",
        "service.report.order_dialog.hour_lines_label": "Ordrelinjer for timer",
        "service.report.order_dialog.hour_lines_each":
          "Én linje per timeregistrering (anbefalt for oversikt)",
        "service.report.order_dialog.hour_lines_grouped":
          "Slå sammen per aktivitet (én linje per aktivitet)",
        "service.report.order_dialog.hour_lines_hint":
          "Flere registreringer samme dag på samme aktivitet blir én linje ved «slå sammen». Fast aktivitetsgebyr (budget_fee) blir fortsatt én linje per aktivitet.",
        "service.report.order_dialog.section_order_lines": "Ordrelinjer (vareforbruk)",
        "service.report.order_dialog.section_order_lines_subtitle":
          "{{selected}} av {{total}} ordrelinjer",
        "service.report.order_dialog.section_hours_subtitle":
          "{{selected}} av {{total}} timer",
        "service.report.order_dialog.section_hours_subtitle_manual":
          "Manuelle timer eller velg registreringer under",
        "service.report.order_dialog.toggle_order_lines_aria": "Fakturer ordrelinjer",
        "service.report.order_dialog.toggle_hours_aria": "Fakturer timer",
        "service.report.order_dialog.invoice_order_lines_switch":
          "Fakturer ordrelinjer ({{selected}} av {{total}} med forbruk valgt)",
        "service.report.order_dialog.pick_order_lines":
          "Velg ordrelinjer å fakturere (kun produkter med forbruk):",
        "service.report.order_dialog.no_consumption_lines":
          "Ingen ordrelinjer med forbruk registrert",
        "service.report.order_dialog.add_tilleggsarbeider_group_label":
          "Egen ordregruppe «Tilleggsarbeider»",
        "service.report.order_dialog.add_tilleggsarbeider_group_hint":
          "Slå av for å legge timer og tilhørende linjer i hovedgruppen (samme gruppe som fakturatittel/tekst). Nyttig når du kun vil ha ordrelinjer uten ekstra gruppe.",
        "service.report.order_dialog.section_hours": "Timer (tilleggsarbeid)",
        "service.report.order_dialog.invoice_hours_switch":
          "Fakturer timer ({{selected}} av {{total}} timer valgt)",
        "service.report.order_dialog.invoice_hours_switch_manual":
          "Fakturer timer (manuelt eller fra liste)",
        "service.report.order_dialog.hours_manual_notice_title": "Ingen fakturerbare timeregistreringer",
        "service.report.order_dialog.hours_manual_notice_body":
          "Alle timer kan ligge i avtalte prislinjer, eller ingen timer er registrert. Slå på fakturering og fyll inn manuelt timeantall under for å legge standard timeprodukt på ordren.",
        "service.report.order_dialog.pick_billable_hours":
          "Velg timer å fakturere (kun tilleggsarbeid):",
        "service.report.order_dialog.hours_settings_heading": "Timer-innstillinger",
        "service.report.order_dialog.manual_hours_label":
          "Manuelt timeantall (overstyrer valgte timer når utfylt)",
        "service.report.order_dialog.manual_hours_placeholder":
          "Påkrevd ved kun manuell fakturering — ellers valgfritt",
        "service.report.order_dialog.hours_discount_label": "Rabatt (%)",
        "service.report.order_dialog.hours_preview_heading": "Forhåndsvisning",
        "service.report.order_dialog.hours_preview_quantity": "Antall timer: {{hours}}",
        "service.report.order_dialog.hours_preview_discount": "Rabatt: {{pct}}%",
        "Order Lines": "Orderlinjer",
        "Not chosen": "Ikke valgt",
        "Address": "Adresse",
        "None": "Mangler",
        "New": "Ny",
        "Order Confirmation Sent": "Ordrebekreftelse sendt",
        "Ready to be picked": "Klar til å plukkes",
        "Picked": "Plukket",
        "Packed": "Pakket",
        "Ready to be shipped": "Klar til å sendes",
        "Ready to be invoiced": "Klar til fakturering",
        "Invoiced": "Fakturert",
        "Cancelled": "Kansellert",
        "Accomplished": "Ferdigstilt",
        "Agreement confirmed": "Avtale bekreftet",
        "Agreement not confirmed": "Avtale ikke bekreftet",
        "Ongoing": "Pågående",
        "number.from": "Fra",
        "number.to": "Til",
        "updated": "Oppdatert",
        "product.add": "Legg til produkt",
        "product.update": "Oppdater produkt",
        "product.model_year": "Modellår",
        "product.replaced_by_product": "Erstattet av produkt",
        "product.replaced_by.banner_title": "Dette produktet er erstattet",
        "product.replaced_by.banner_description":
          "Bruk erstatningsproduktet for oppdatert informasjon, pris og lager.",
        "product.replaced_by.open_replacement": "Åpne erstatningsprodukt",
        "product.selector.open_product": "Åpne produkt",
        "product.selector.replaced_label": "Erstattet",
        "product.selector.search_placeholder": "Søk etter produkter …",
        "product.selector.empty_flat_list":
          "Søk eller bla i listen. Bruk trakten for å avgrense aktive, utgåtte eller lagerfilter.",
        "customer.system.product_search_placeholder":
          "Søk etter anlegg (produkter med reservedeler) …",
        "product.selector.filter_system_products": "System (produkter med reservedeler)",
        "product.selector.toggle_filters": "Vis filtre",
        "Show all": "Vis alle",
        "Show in new tab": "Vis i ny fane",
  
        "Welcome to Promang": "Welcome to React and react-i18next",
        "Sign in to your account": "Logg in i din konto",
        "product.brands": "Merkevarer",
        "product.brand": "Produkt Merke",
        "Complaint": "Reklamasjon",
        "Must be Rectified": "Må utbedres",
        "Internal Report": "Intern Rapport",
        "missing_system": "Mangler system",
        "missing_report": "Mangler rapport",
        "missing_customer": "Mangler kunde",
        "missing_order": "Mangler ordre",
        "missing_order_lines": "Mangler orderlinjer",
        "missing_hours": "Mangler timer",
        "customer.type": "Kundetype",
        "customer.name.required": "Kundenavn er påkrevd",
        "Contact information": "Kontaktinformasjon",
        "company.outbound_mail.title": "Utgående e-post (Microsoft)",
        "company.outbound_mail.description": "Velg hvilken delt firmapostkasse Promang skal sende fra (Microsoft 365). Tom eller uten Microsoft-fallback: bruk Promangs standard e-post.",
        "company.outbound_mail.mailbox_label": "Send system-e-post fra delt postkasse",
        "company.outbound_mail.promang_default": "Promang standard (ikke Microsoft)",
        "company.outbound_mail.case_email_hint": "Saks-e-post til ansatte sendes fra den ansattes egen Microsoft-konto når den er koblet under brukerinnstillinger — ikke fra denne delte postkassen.",
        "company.userRoles.helpLabel.scope": "Dette inkluderer:",
        "company.userRoles.helpLabel.admin": "Admin bør tenke på:",
        "company.userRoles.sections.actions": "Handlinger",
        "company.userRoles.sections.submodules": "Undermoduler",
        "company.userRoles.accessIntro":
          "Hjelpeteksten under hver rolle forklarer tilgangen og hva du bør vurdere før du tildeler rettigheter.",
        "company.users.page_title": "Brukere",
        "company.users.subtitle_selected": "{{count}} valgt",
        "company.users.hero.kicker": "Selskap",
        "company.users.hero.title": "Brukere og tilgang",
        "company.users.hero.subtitle":
          "Administrer folk, roller, invitasjoner og filtre på ett sted — i tråd med dashboardoversikten.",
        "company.users.stats.total": "Totalt",
        "company.users.stats.on_page": "På denne siden",
        "company.users.stats.selected": "Valgt",
        "company.users.section.kicker": "Oversikt",
        "company.users.section.title": "Brukerliste",
        "company.users.section.subtitle":
          "Søk, filtrer og åpne en profil for å redigere detaljer.",
        "company.users.section.meta_line": "{{total}} brukere · side {{page}}",
        "company.users.search_placeholder": "Søk etter brukere…",
        "company.users.filters_heading": "Filtre",
        "company.users.filters_description":
          "Søk og avgrens listen med valgene under.",
        "company.users.filter_title": "Filtrer brukere",
        "company.users.filter.active": "Aktive brukere",
        "company.users.filter.employee": "Ansatte",
        "company.users.filter.show_in_dropdown": "Vis i nedtrekk",
        "company.users.new_user": "Ny bruker",
        "company.users.calendar": "Kalender",
        "company.users.loading": "Laster brukere…",
        "company.users.table.status_inactive": "Inaktiv",
        "company.users.table.status_pending": "Venter",
        "company.users.table.status_active": "Aktiv",
        "company.users.table.empty_title": "Ingen brukere funnet",
        "company.users.table.empty_hint":
          "Prøv å endre søk eller filtre for å se flere treff.",
        "company.users.table.row_kicker": "Bruker",
        "company.users.table.unnamed": "Uten navn",
        "company.users.table.calendar": "Kalender",
        "company.users.profile.read_only_title": "Brukerinformasjon er skrivebeskyttet",
        "company.users.profile.read_only_multi_company":
          "Denne brukeren er knyttet til flere selskaper. Profilen (navn, bilde, kontakt osv.) kan bare redigeres fra vedkommendes primære selskap for å unngå motstridende endringer. Bytt til det selskapet i arbeidsområdet, eller sett riktig primærselskap på brukeren.",
        "company.users.table.edit": "Rediger",
        "company.users.table.settings": "Profil",
        "company.users.table.view": "Åpne",
        "company.users.table.selected_of_total":
          "{{selected}} av {{total}} valgt",
        "company.users.table.user_count": "{{count}} brukere",
        "company.users.table.n_selected": "{{count}} valgt",
        "company.users.invitation.expired":
          "Denne brukeren har en utløpt invitasjonslenke.",
        "company.users.invitation.resend_button": "Send invitasjon på nytt",
        "company.users.invitation.resending": "Sender invitasjon...",
        "company.users.invitation.resend_success":
          "Invitasjonen ble sendt på nytt.",
        "company.users.invitation.resend_error":
          "Kunne ikke sende invitasjonen på nytt.",
        "driving": "Kjøring (full flåte)",
        "driving_trips": "Turer og innlogget kjøretøy",
        "driving_drivers": "Sjåfører",
        "driving_vehicles": "Kjøretøy (kjøremodul)",
        "vehicles": "Kjøretøy",
        "Postal Address": "Postadresse",
        "Physical Address": "Besøksadresse",
        "Edit": "Rediger",
        "Back": "Tilbake",
        "webpage.editor.open_live": "Gå til live",
        "webpage.editor.open_live_title": "Åpne siden i nettbutikken (ny fane)",
        "webpage.editor.open_live_title_unpublished":
          "Åpne URL i nettbutikken. Siden må være publisert for at kunder skal se innholdet.",
        "webpage.editor.import_blocks": "JSON / AI",
        "webpage.editor.import_tooltip": "Lim inn JSON-blokker eller kopier AI-instruks",
        "webpage.editor.import_dialog_title": "Importer blokker eller AI-guide",
        "webpage.editor.import_tab_paste": "Lim inn JSON",
        "webpage.editor.import_tab_guide": "AI-instruks (kopier)",
        "webpage.editor.import_hint":
          "Lim inn JSON: enten { \"blocks\": [ ... ] }, eller rå array, eller eksportformat med content.blocks. Du kan pakke inn i ```json ... ```.",
        "webpage.editor.import_replace": "Erstatt alle blokker",
        "webpage.editor.import_append": "Legg til nederst",
        "webpage.editor.import_sample": "Lim inn eksempel",
        "webpage.editor.import_apply": "Bygg blokker",
        "webpage.editor.import_success": "Importerte {{count}} blokk(er). Husk å lagre siden.",
        "webpage.editor.import_error_empty": "Ingen tekst å lese.",
        "webpage.editor.import_error_invalid_json": "Ugyldig JSON. Sjekk anførselstegn og komma.",
        "webpage.editor.import_error_no_blocks_array": "Forventet \"blocks\"-array, rå array eller content.blocks.",
        "webpage.editor.import_error_no_valid_blocks": "Ingen gyldige blokker (type må være text, image, header, section, button eller columns).",
        "webpage.editor.import_error_unknown": "Kunne ikke importere.",
        "webpage.editor.ai_guide_intro":
          "Kopier teksten under og lim den inn som system-/instruks i en AI som skal generere layout. Modellen skal svare med ren JSON uten markdown.",
        "webpage.editor.copy_ai_guide": "Kopier AI-instruks",
        "webpage.editor.ai_guide_copied": "AI-instruks kopiert til utklippstavlen",
        "webpage.editor.ai_guide_copy_failed": "Klarte ikke å kopiere (nettleserrettigheter)",
        "webpage.editor.generate_with_ai": "Generer med ChatGPT",
        "webpage.editor.ai_apply_success": "AI la inn {{count}} blokk(er) i editoren. Husk å lagre siden.",
        "webpage.editor.ai_parse_error": "AI ga ikke gyldig side-JSON. Prøv igjen, eller lim inn JSON under «Lim inn JSON».",
        "Customer Number": "Kundenummer",
        "Name": "Navn",
        "Email": "E-post",
        "pmField.email.invalid": "Oppgi en gyldig e-postadresse.",
        "pmField.email.sameAsName": "E-post og navn kan ikke være like. Bruk navnefeltet for navn og e-postfeltet for e-post.",
        "pmField.email.nameLooksLikeEmail": "Dette ser ut som en e-postadresse. Bruk e-postfeltet for e-post.",
        "Mobile": "Mobil",
        "Org. Nummer": "Org. Nummer",
        "Short Description": "Kort beskrivelse",
        "Address 2": "Adresse 2",
        "Postal": "Postnummer",
        "Place": "Sted",
        "Active": "Aktiv",
        "Yes": "Ja",
        "No": "Nei",
        "Copied to clipboard": "Kopiert til utklippstavle",
        "Failed to copy": "Kunne ikke kopiere",
        "Copy to clipboard": "Kopier til utklippstavle",
        "RESPONSIBLE": "Ansvarlig",
        "EXECUTOR": "Utfører",
        "OBSERVER": "Observatør",
        "note": "Notat",
        "work_order": "Arbeidsordre",
        "Work Orders": "Arbeidsordrer",
        "Work Order List": "Arbeidsordrer - Liste",
        "New Work Order": "Ny Arbeidsordre",
        "Search work orders...": "Søk i arbeidsordrer...",
        "Filter Work Orders by Status": "Filtrer arbeidsordrer etter status",
        "Finished": "Ferdig",
        "Order Date": "Bestillingsdato",
        "Due Date": "Forfallsdato",
        "Event Period": "Hendelsesperiode",
        "Responsible": "Ansvarlig",
        "Executor": "Utfører",
        "Work Order #": "Arbeidsordre #",
        "work_orders.pagination_summary":
          "Side {{page}} av {{totalPages}} ({{total}} totalt)",
        "work_orders.delete_confirm":
          "Dette sletter arbeidsordren permanent. Timer som er knyttet til den, blir frakoblet arbeidsordren. Dette kan ikke angres.",
        "work_orders.delete_success": "Arbeidsordre slettet",
        "work_orders.delete_failed": "Kunne ikke slette arbeidsordren",
        "work_orders.back_to_view": "Tilbake til visning",
        "work_orders.calendar_filter": "Arbeidsordrer",
        "work_orders.project_activity.section_title": "Prosjektaktivitet",
        "work_orders.project_activity.help":
          "Knytt til en prosjektaktivitet som ikke allerede er brukt et annet sted, eller opprett en ny på dette prosjektet. Når du lagrer arbeidsordren, kobles aktiviteten til denne ordren.",
        "work_orders.project_activity.new_title_label": "Tittel på ny aktivitet",
        "work_orders.project_activity.copy_from_title": "Kopier fra tittel",
        "work_orders.project_activity.new_title_placeholder":
          "f.eks. Montering fase 2",
        "work_orders.project_activity.create_button": "Opprett og velg",
        "work_orders.project_activity.creating": "Oppretter…",
        "work_orders.project_activity.created_toast": "Prosjektaktivitet opprettet",
        "work_orders.project_activity.create_error":
          "Kunne ikke opprette prosjektaktivitet",
        "work_orders.project_activity.linked_label": "Prosjektaktivitet",
        "work_orders.billing_ready.action": "Klar til fakturering",
        "work_orders.billing_ready.eyebrow": "Fakturagrunnlag",
        "work_orders.billing_ready.title": "Klargjør fakturainfo",
        "work_orders.billing_ready.title_edit": "Oppdater fakturagrunnlag",
        "work_orders.billing_ready.intro":
          "Lagre fakturatekst og hva som skal faktureres (timer og forbruk). Du kan bare merke arbeidsordren klar til fakturering, eller opprette salgsordre med én gang for å gå videre til fakturering.",
        "work_orders.billing_ready.section_invoice": "Fakturautkast",
        "work_orders.billing_ready.section_hours": "Timer til fakturering",
        "work_orders.billing_ready.section_hours_subtitle":
          "Valgt {{selected}} t av {{total}} t",
        "work_orders.billing_ready.section_items": "Varelinjer (forbruk)",
        "work_orders.billing_ready.section_items_subtitle":
          "{{selected}} av {{total}} linjer valgt",
        "work_orders.billing_ready.section_group": "Ordregruppering (senere)",
        "work_orders.billing_ready.add_tilleggsarbeider_hint":
          "Når ordre senere opprettes fra arbeidsordren, kan timer og varer samles i egen gruppe på salgsordren.",
        "work_orders.billing_ready.toggle_hours_aria": "Ta med timer i fakturagrunnlaget",
        "work_orders.billing_ready.toggle_items_aria": "Ta med varelinjer i fakturagrunnlaget",
        "work_orders.billing_ready.no_billable_hours": "Ingen timer er knyttet til arbeidsordren.",
        "work_orders.billing_ready.no_usage_items": "Ingen forbrukslinjer med brukt antall.",
        "work_orders.billing_ready.submit": "Lagre og merk klar til fakturering",
        "work_orders.billing_ready.success": "Merket klar til fakturering og påminnelse sendt der det fantes utførere",
        "work_orders.billing_ready.failed": "Kunne ikke lagre fakturagrunnlag",
        "work_orders.billing_ready.submit_create_order": "Opprett salgsordre",
        "work_orders.billing_ready.success_order": "Salgsordre opprettet",
        "work_orders.billing_ready.failed_order": "Kunne ikke opprette salgsordre",
        "work_orders.billing_ready.open_order": "Åpne salgsordre",
        "work_orders.billing_ready.sales_income_in_project_notice_title":
          "Ikke fakturerbar som egen salgsordre",
        "work_orders.billing_ready.sales_income_in_project_notice":
          "Arbeidsordren er merket med at omsetning inngår i prosjektet. Bruk prosjektfakturering; «Klar til fakturering» og opprett salgsordre fra denne arbeidsordren er ikke tilgjengelig.",
        "work_orders.bulk_create.toolbar": "{{count}} valgt",
        "work_orders.bulk_create.open": "Opprett salgsordrer…",
        "work_orders.bulk_create.clear": "Nullstill valg",
        "work_orders.bulk_create.title": "Opprett salgsordrer fra arbeidsordrer",
        "work_orders.bulk_create.summary": "Du er i ferd med å opprette én eller flere salgsordrer fra {{count}} arbeidsordre(r).",
        "work_orders.bulk_create.hint":
          "Standard regler gjelder: alle timer og forbrukslinjer som kan faktureres tas med per arbeidsordre. For full kontroll (avrunding, manuelle timer, linjevalg), bruk fakturadialogen på hver arbeidsordre.",
        "work_orders.bulk_create.strategy_label": "Hvordan skal ordrene grupperes?",
        "work_orders.bulk_create.strategy_per_wo": "Én salgsordre per arbeidsordre",
        "work_orders.bulk_create.strategy_customer": "Slå sammen per kunde (én ordre per kunde)",
        "work_orders.bulk_create.strategy_project": "Slå sammen per prosjekt (én ordre per prosjekt)",
        "work_orders.bulk_create.submit": "Opprett ordre",
        "work_orders.bulk_create.success": "Opprettet {{count}} salgsordre(r)",
        "work_orders.bulk_create.failed": "Kunne ikke opprette salgsordrer",
        "work_orders.bulk_create.select_row": "Velg arbeidsordre for massefakturering",
        "work_orders.bulk_create.select_page": "Velg alle arbeidsordrer på siden som kan faktureres",
        "work_orders.checklist.enable_switch": "Bruk sjekkliste på denne arbeidsordren",
        "work_orders.checklist.section_title": "Sjekkliste",
        "work_orders.checklist.save_to_enable_title": "Lagre arbeidsordren",
        "work_orders.checklist.save_to_enable_body":
          "Lagre endringene dine for å aktivere sjekklistefeltet og opprette eller redigere linjer.",
        "work_orders.checklist.missing_title": "Ingen sjekkliste ennå",
        "work_orders.checklist.missing_body":
          "Opprett en sjekkliste ved å velge mal eller starte tom.",
        "work_orders.checklist.choose": "Velg sjekkliste",
        "work_orders.checklist.delete": "Slett sjekkliste",
        "work_orders.checklist.delete_confirm_title": "Slette sjekkliste?",
        "work_orders.checklist.delete_confirm_body":
          "Dette kan ikke angres. Sjekklisten og svarene fjernes.",
        "work_orders.checklist.loading": "Laster sjekkliste…",
        "work_orders.checklist.load_error": "Kunne ikke laste sjekklisten.",
        "work_orders.checklist.load_error_title": "Sjekklisten kunne ikke lastes",
        "work_orders.checklist.load_error_hint":
          "Prøv igjen eller åpne arbeidsordren fra prosjektoversikten.",
        "work_orders.checklist.created": "Sjekkliste opprettet",
        "work_orders.checklist.create_error": "Kunne ikke opprette sjekkliste",
        "work_orders.checklist.deleted": "Sjekkliste fjernet",
        "work_orders.checklist.delete_error": "Kunne ikke slette sjekkliste",
        "work_orders.checklist.save_error": "Kunne ikke lagre sjekkliste",
        "work_orders.checklist.read_only_hint":
          "Du kan se sjekklisten i skrivebeskyttet modus på sjekklistesiden.",
        "work_orders.checklist.page_subtitle": "Sjekkliste",
        "work_orders.checklist.page_heading": "Arbeidsordre sjekkliste",
        "work_orders.checklist.back_to_work_order": "Tilbake til arbeidsordre",
        "work_orders.checklist.disabled_title": "Sjekkliste er ikke aktivert",
        "work_orders.checklist.disabled_body":
          "Aktiver «Bruk sjekkliste» på redigeringssiden for å bruke dette feltet.",
        "work_orders.checklist.read_only_banner":
          "Kun visning: du har ikke tilgang til å redigere denne sjekklisten.",
        "work_orders.checklist.create_from_edit":
          "Opprett en sjekkliste fra redigeringssiden til arbeidsordren.",
        "work_orders.checklist.load_work_order_error": "Kunne ikke laste arbeidsordre",
        "work_orders.checklist.card_title": "Sjekkliste",
        "work_orders.checklist.card_desc_with_checklist":
          "Se og fyll ut sjekklisten på sjekklistesiden.",
        "work_orders.checklist.card_desc_no_checklist":
          "Opprett sjekkliste på redigeringssiden (velg mal eller start tom).",
        "work_orders.checklist.unit": "punkter",
        "work_orders.checklist.mobile_nav": "Sjekkliste",
        "work_orders.list_meta_total": "Totalt: {{count}}",
        "work_orders.table_no_title": "Uten tittel",
        "work_order.view.mobileNav.ariaLabel":
          "Hurtigvalg for timeregistrering og vareforbruk på arbeidsordre",
        "work_order.admin.title": "Admin",
        "work_order.admin.edit": "Rediger arbeidsordre",
        "work_order.admin.edit_desc": "Åpne fullt redigerskjema",
        "work_order.admin.approve": "Godkjenn arbeidsordre",
        "work_order.admin.approve_desc": "Godkjenn eller avslå (koordinator)",
        "work_order.admin.open_project": "Åpne prosjekt",
        "work_order.admin.open_customer": "Åpne kunde",
        "work_order.admin.item_consumption": "Vareforbruk",
        "work_order.admin.item_consumption_desc":
          "Registrer materialer og forbrukt antall",
        "work_order.admin.billing_desc":
          "Forbered fakturagrunnlag eller opprett salgsordre",
        "work_order.admin.finish": "Ferdigstill arbeidsordre",
        "work_order.admin.finish_desc":
          "Gå gjennom sjekkliste og marker som ferdigstilt",
        "work_order.admin.mentions": "@Omtaler",
        "work_order.admin.mentions_desc":
          "Notater og ressurser som refererer til denne arbeidsordren",
        "work_order.admin.mentions_dialog_title": "Omtaler av arbeidsordren",
        "work_order.admin.no_mentions": "Ingen omtaler funnet.",
        "work_order.admin.set_status": "Sett status (admin)",
        "work_order.admin.set_status_desc":
          "Rett opp status for eldre tilfeller, for eksempel allerede fakturert utenfor Promang.",
        "work_order.admin_set_status.title": "Sett status på arbeidsordre",
        "work_order.admin_set_status.intro":
          "Bruk når ordren ble fakturert eller fullført uten vanlig flyt. Oppretter ikke salgsordre.",
        "work_order.admin_set_status.status_label": "Status",
        "work_order.admin_set_status.mark_completed": "Marker som ferdigstilt",
        "work_order.admin_set_status.submit": "Lagre",
        "work_order.admin_set_status.success": "Status oppdatert.",
        "work_order.admin_set_status.error": "Kunne ikke oppdatere status.",
        "work_order.completion.title": "Ferdigstilling",
        "work_order.completion.status_not_applicable":
          "Ferdigstilling er ikke tilgjengelig for denne statusen.",
        "work_order.completion.heading_done": "Arbeidsordre ferdigstilt",
        "work_order.completion.heading_pending": "Ferdigstill arbeidsordre",
        "work_order.completion.sub_done":
          "Arbeidsordren er markert som ferdigstilt.",
        "work_order.completion.sub_blocked":
          "Noen krav må være oppfylt før du kan ferdigstille.",
        "work_order.completion.sub_ready":
          "Alle obligatoriske krav er oppfylt; du kan ferdigstille når du er klar.",
        "work_order.completion.label_status": "Status",
        "work_order.completion.label_progress": "Klarhet",
        "work_order.completion.value_done": "Ferdigstilt",
        "work_order.completion.no_checks": "—",
        "work_order.completion.cta_view": "Vis ferdigstillingsdetaljer",
        "work_order.completion.cta_finish": "Ferdigstill",
        "work_order.event.dialog_create": "Opprett hendelse",
        "work_order.event.dialog_edit": "Rediger hendelse",
        "work_order.event.toast_created": "Hendelse opprettet",
        "work_order.event.toast_updated": "Hendelse oppdatert",
        "work_order.event.toast_deleted": "Hendelse slettet",
        "work_order.event.delete_failed": "Kunne ikke slette hendelse",
        "work_order.event.delete_event": "Slett",
        "work_order.event.saving": "Lagrer…",
        "work_order.event.submit_create": "Opprett",
        "work_order.event.submit_update": "Oppdater",
        "work_order.event.field_title": "Tittel",
        "work_order.event.field_title_placeholder": "Hendelsestittel",
        "work_order.event.field_description": "Beskrivelse",
        "work_order.event.field_description_placeholder": "Beskriv hendelsen…",
        "work_order.event.field_start": "Starttid",
        "work_order.event.field_end": "Sluttid",
        "work_order.event.field_location": "Lokasjon",
        "work_order.event.field_location_placeholder": "Hvor skal hendelsen finne sted?",
        "work_order.event.location_prefilled":
          "Leveringsadresse fra arbeidsordre er forhåndsutfylt (kan redigeres).",
        "work_order.event.all_day": "Hele dagen",
        "work_order.event.attendees_title": "Deltakere på hendelsen",
        "work_order.event.attendees_hint":
          "Alle deltakere på arbeidsordren er foreslått. Fjern kryss for dem som ikke skal være med. Du kan legge til flere under.",
        "work_order.event.add_attendee": "Legg til deltaker",
        "work_order.event.add_confirm": "Legg til",
        "work_order.event.select_user": "Velg bruker",
        "work_order.event.loading_users": "Laster brukere…",
        "work_order.event.no_attendees_from_wo":
          "Ingen deltakere på arbeidsordren. Bruk «Legg til deltaker» for å invitere noen.",
        "work_order.event.from_work_order": "Fra arbeidsordre",
        "work_order.event.remove_attendee": "Fjern",
        "work_order.event.role_participant": "Deltaker",
        "work_order.event.error_need_event_owner":
          "Arbeidsordren må ha en bruker som kan eie kalenderhendelsen (ansvarlig utførende, ordreansvarlig eller oppretter) før du kan opprette en hendelse.",
        "work_order.event.notice_no_event_owner_title": "Mangler eier for hendelsen",
        "work_order.event.notice_no_event_owner_description":
          "Legg til ansvarlig utførende eller ordreansvarlig på arbeidsordren, eller sørg for at den har en oppretter, slik at hendelsen kan knyttes til en bruker. Du kan fortsatt redigere en eksisterende hendelse.",
        "work_order.participants.title": "Deltakere",
        "work_order.participants.description":
          "Hvem som er med på arbeidsordren (roller og status).",
        "work_order.participants.draft_hint":
          "Lagre arbeidsordren først for å administrere deltakere som på prosjekt (egne dialoger).",
        "work_order.participants.add": "Legg til deltaker",
        "work_order.participants.add_first": "Legg til første deltaker",
        "work_order.participants.none": "Ingen deltakere ennå.",
        "work_order.participants.user": "Bruker",
        "work_order.participants.role": "Rolle",
        "work_order.participants.status": "Status",
        "work_order.participants.edit": "Rediger",
        "work_order.participants.delete": "Slett",
        "work_order.participants.delete_confirm":
          "Fjerne denne deltakeren fra arbeidsordren?",
        "work_order.participants.delete_error": "Kunne ikke fjerne deltaker",
        "work_order.participants.error_loading":
          "Kunne ikke laste deltakere",
        "work_order.participants.save_error": "Kunne ikke lagre deltaker",
        "work_order.participants.created": "Deltaker lagt til",
        "work_order.participants.updated": "Deltaker oppdatert",
        "work_order.participants.updating": "Oppdaterer…",
        "work_order.participants.adding": "Legger til…",
        "report.participants.title": "Tilknyttede utførende",
        "report.participants.subtitle":
          "Ekstra mannskap og observatører (alle vises i kalenderen). Ansvarlig utførende fra avtalen settes under Utførende på avtalen.",
        "report.participants.add": "Legg til",
        "report.participants.add_first": "Legg til første",
        "report.participants.none": "Ingen tilknyttede utførende utover avtalen.",
        "report.participants.user": "Bruker",
        "report.participants.role": "Rolle",
        "report.participants.status": "Status",
        "report.participants.choose_role": "Velg rolle",
        "report.participants.choose_status": "Velg status",
        "report.participants.edit": "Rediger",
        "report.participants.delete": "Fjern",
        "report.participants.delete_confirm":
          "Fjerne denne personen fra rapporten?",
        "report.participants.delete_error": "Kunne ikke fjerne",
        "report.participants.save_error": "Kunne ikke lagre",
        "report.participants.created": "Lagt til",
        "report.participants.updated": "Oppdatert",
        "report.participants.updating": "Oppdaterer…",
        "report.participants.adding": "Legger til…",
        "report.participants.error_is_executing_employee":
          "Denne brukeren er allerede satt som ansvarlig utførende på avtalen. Velg en annen, eller endre utførende på avtalen først.",
        "Use card view": "Bruk kortvisning",
        "Switch to card overview layout": "Bytt til kortoversikt",
        "Switch to compact table layout": "Bytt til tabellvisning",
        "contact": "Kontakt",
        "service_agreement": "Serviceavtale",
        "order": "Ordre",
        "product": "Produkt",
        "folder": "Mappe",
  
        // Control Panel / Sentralbord translations
        "answered": "Besvart",
        "missed": "Ikke besvart",
        "Ended": "Avsluttet",
        "Agent": "Agent",
        "Abandoned": "Avbrutt",
        "Answered": "Besvart",
        "Missed": "Ikke besvart",
        "Error": "Feil",
        "Unknown": "Ukjent",
        "No communication found": "Ingen kommunikasjon funnet",
        "No possible customers found": "Ingen mulige kunder funnet",
        "Queue": "Kø",
        "control.panel": "Sentralbord",
        "control.panel.overview":
          "Dashboard for systemintegrasjoner og overvåking",
        "overview": "Oversikt",
        "queues": "Køer",
        "calls": "Samtalehistorikk",
        "persons": "Personer",
        "settings": "Innstillinger",
        "control.panel.overview.title": "Sentralbord Oversikt",
        "control.panel.overview.description":
          "Dashboard for alle integrasjoner og systemer",
        "current.phone.status": "Nåværende Telefonstatus",
        "phone.status": "Telefonstatus",
        "phone.details.status": "Telefonstatus detaljer",
        "connected.to.phonero": "Tilkoblet Phonero",
        "not.connected.to.phonero": "Ikke tilkoblet Phonero-system",
        "change.status": "Endre Status",
        "not.connected.to.phone.system": "Ikke tilkoblet telefonsystem",
        "phonero.status": "Phonero Status",
        "active": "Aktiv",
        "not.configured": "Ikke konfigurert",
        "view.details": "Se detaljer",
        "system.status": "Systemstatus",
        "all.systems.operational": "Alle systemer operative",
        "last.updated": "Sist oppdatert",
        "quick.actions": "Hurtigvalg",
        "configure": "Konfigurer",
        "phonero.queues": "Phonero Køer",
        "monitor.manage.queues": "Overvåk og administrer samtalekøer",
        "call.log": "Samtalehistorikk",
        "view.call.history": "Se samtalehistorikk og detaljer",
        "phonero.persons": "Phonero Personer",
        "manage.persons.phone":
          "Administrer personer og deres telefoninnstillinger",
        "control.panel.settings": "Sentralbord Innstillinger",
        "configure.control.panel": "Konfigurer sentralbord og integrasjoner",
        "integrations": "Integrasjoner",
        "manage.all.integrations": "Administrer alle systemintegrasjoner",
        "phone.integration": "Telefonintegrasjon",
  
        // Phonero presence statuses
        "presence.available": "Tilgjengelig",
        "presence.busy": "Opptatt",
        "presence.away": "Borte",
        "presence.unknown": "Ukjent",
        "presence.connected": "Tilkoblet Phonero",
        "presence.not.available": "Tilgjengelighetsstatus ikke tilgjengelig",
        "presence.failed.to.load": "Kunne ikke laste tilgjengelighetsdata",
        "presence.updated.successfully": "Tilgjengelighet oppdatert",
        "presence.failed.to.update": "Kunne ikke oppdatere tilgjengelighet",
        "presence.cannot.update":
          "Kan ikke oppdatere tilgjengelighet - bruker ikke funnet i Phonero",
  
        // Cases list - new view (nn)
        "Use list view": "Bruk listevisning",
        "Use new view": "Bruk ny visning",
        "Last update": "Siste oppdatering",
        "No updates yet": "Ingen oppdateringer ennå",
        "Add update": "Legg til oppdatering",
        "Write an update...": "Skriv en oppdatering...",
        "Gå til bruker": "Gå til bruker",
        "Bruker": "Bruker",
        "Ansatt": "Ansatt",
        "Update added": "Oppdatering lagt til",
        "Could not add update": "Kunne ikke legge til oppdatering",
        "Title (optional)": "Tittel (valgfritt)",
        "Add title": "Legg til tittel",
        "Link": "Lenke",
        "Add link": "Legg til lenke",
        "Link text (optional)": "Lenketekst (valgfritt)",
        "URL": "URL",
        "Send": "Send",
        "Open case": "Åpne sak",
        "View full": "Vis fullstendig",
        "No employees found": "Ingen ansatte funnet",
  
        // Phonero presence descriptions
        "Free": "Ledig",
        "Meeting": "Møte",
        "Lunch": "Lunsj",
        "Vacation": "Ferie",
        "Busy": "Opptatt",
        "Way": "På vei",
        "Gone for the day": "Ferdig for dagen",
  
        // Live Calls translations
        "Live Calls (Not synched yet)": "Live Samtaler (Ikke synkronisert ennå)",
        "Latest calls from Phonero API (not yet synced to database)":
          "Siste samtaler fra Phonero API (ikke synkronisert til database ennå)",
        "Refreshing...": "Oppdaterer...",
        "Refresh": "Oppdater",
        "Loading live calls...": "Laster live samtaler...",
        "No unsynced live calls found":
          "Ingen usynkroniserte live samtaler funnet",
  
        // Manual Call translations
        "Add Manual Call": "Legg til manuell samtale",
        "From Number (Customer)": "Fra nummer (Kunde)",
        "Date & Time": "Dato & Tid",
        "Duration (seconds)": "Varighet (sekunder)",
        "Note": "Notat",
        "Cancel": "Avbryt",
        "Create Call": "Opprett samtale",
        "Creating...": "Oppretter...",
        "Manual call created successfully": "Manuell samtale opprettet",
        "Manual call added successfully": "Manuell samtale lagt til",
        "Manual": "Manuell",
        "Select Date": "Velg dato",
        "Choose date": "Velg dato",
        "Report": "Rapport",
        "report": "Rapport",
        "report.create": "Opprett rapport",
        "report.update": "Oppdater rapport",
        "report.type": "Rapporttype",
        "report.date": "Rapportdato",
        "report.description": "Rapportbeskrivelse",
        "report.agreement.update": "Oppdater rapportavtale",
        "report.agreement.new": "Ny rapportavtale",
        "report.agreement.modal_intro":
          "Fyll inn når arbeidet er planlagt, og om kunden skal få melding.",
        "report.agreement.title": "Avtale / oppdrag",
        "report.agreement.subtitle": "Tidspunkt, utførende og varsling til kunde",
        "report.agreement.setup_title": "Ingen avtale er lagret ennå",
        "report.agreement.setup_body": "Legg inn dato, tid, hvem som utfører arbeidet, og eventuelt send SMS eller e-post til kunden.",
        "report.agreement.setup_cta": "Legg til avtale",
        "report.agreement.section.schedule": "Tid og utførende",
        "report.agreement.section.schedule_help":
          "Hvem som utfører arbeidet, avtaledato og tidsrom.",
        "report.agreement.section.notify": "Varsling til kunde",
        "report.agreement.section.notify_help":
          "Velg om kunden skal ha melding på SMS eller e-post, og hvem som mottar den.",
        "report.agreement.send_to_customer": "Send avtale til kunde",
        "report.agreement.send_to_customer_hint_on": "Du kan bruke SMS og/eller e-post når det er slått på under.",
        "report.agreement.send_to_customer_hint_off": "Avtalen lagres bare i Promang; kunden får ikke melding.",
        "report.agreement.executing_you": "Deg (innlogget bruker)",
        "report.agreement.select_executing": "Velg ansatt",
        "report.agreement.change_executing": "Bytt…",
        "report.agreement.confirm_hint_required":
          "Avtale sendes til kunde, som må bekreftes via SMS eller e-post.",
        "report.agreement.confirm_hint_optional":
          "Informasjon om avtale sendes kunde, men bekreftelse er ikke påkrevd. Avtalen blir bekreftet automatisk.",
        "report.agreement.validation.date_required": "Dato er påkrevd",
        "report.agreement.validation.executing_required": "Utførende er påkrevd",
        "report.agreement.validation.phone_for_sms": "Mobilnummer er påkrevd når SMS er på",
        "report.agreement.validation.email_for_email": "Gyldig e-post er påkrevd når e-post er på",
        "report.agreement.status.confirmed": "Avtalen er bekreftet",
        "report.agreement.status.not_confirmed": "Avtalen er ikke bekreftet",
        "report.agreement.status.sms_sent": "SMS er sendt",
        "report.agreement.status.sms_not_sent": "SMS er ikke sendt",
        "report.agreement.status.sms_confirmed": "Bekreftet via SMS",
        "report.agreement.status.email_sent": "E-post er sendt",
        "report.agreement.status.email_not_sent": "E-post er ikke sendt",
        "report.agreement.status.none": "Ingen avtale",
        "report.admin.title": "Admin",
        "report.admin.status": "Rapportstatus",
        "report.admin.status_desc": "Under behandling, behandlet, fakturert",
        "report.admin.reset": "Reset",
        "report.admin.reset_desc": "Nullstill rapportmoduler",
        "report.admin.view_main_report": "Vis hovedrapport",
        "report.admin.view_sequel": "Gå til oppfølger",
        "report.admin.view_case": "Vis sak",
        "report.admin.create_case": "Opprett sak",
        "report.admin.create_case_desc": "Opprett eller knytt sak for oppfølging av rapport",
        "report.admin.case_dialog_title": "Oppfølging av rapport",
        "report.admin.create_sequel": "Opprett oppfølger",
        "report.admin.create_sequel_desc": "Opprett ny rapport som oppfølger",
        "report.admin.create_order": "Opprett ordre",
        "report.admin.create_order_desc": "Opprett ordre fra denne rapporten (timer, km, linjer)",
        "report.admin.open_mentions": "Åpne sak hvor rapport er nevnt",
        "report.admin.open_mentions_desc": "Se saker og notater som nevner rapporten",
        "report.admin.mentions_dialog_title": "Rapport nevnt i",
        "report.admin.mentioned_at": "Nevnt",
        "report.admin.no_mentions": "Rapporten er ikke nevnt andre steder",
        "report.view.mobileNav.ariaLabel": "Hurtigvalg for rapportseksjoner",
        "report.view.mobileNav.items": "Vareforbruk",
        "report.view.mobileNav.variables": "Variabler",
        "report.view.mobileNav.checklist": "Sjekkliste",
        "report.view.mobileNav.report": "Rapport",
        "report.view.mobileNav.timeRegistration": "Timeregistrering",
        "report.view.summary.customer": "Kunde",
        "report.view.sectionReport.title": "Rapport",
        "report.view.sectionReport.description": "Skriv rapportinnhold",
        "report.view.sectionReport.unit": "rapport",
        "report.view.sectionReport.statusFinished": "Ferdig",
        "report.view.sectionReport.statusNotRequired": "Ikke påkrevd",
        "report.view.sectionReport.statusMissing": "Mangler",
        "report.view.sectionGuide.title": "Guider",
        "report.view.sectionGuide.description": "Strukturerte guider og historikk for denne rapporten",
        "report.view.sectionGuide.unitRuns": "kjøringer",
        "report.view.sectionGuide.statusNone": "Ikke startet",
        "report.view.sectionGuide.statusHasRuns": "{{count}} fullført",
        "report.view.guideHistory.title": "Guidehistorikk",
        "report.view.guideHistory.empty": "Ingen guider er fullført på denne rapporten ennå.",
        "report.view.guideHistory.startGuide": "Start guide",
        "report.view.guideHistory.close": "Lukk",
        "report.view.guideHistory.completedAt": "Fullført",
        "report.view.guideHistory.by": "Av",
        "report.view.guideHistory.unknownUser": "Ukjent bruker",
        "report.view.guideHistory.answers": "Svar",
        "report.view.guideHistory.tagsApplied": "Etiketter lagt til ({{count}})",
        "report.view.mobileNav.guide": "Guide",
        "report.view.priceCalculated.title": "Det er beregnet en pris for denne jobben",
        "report.view.priceCalculated.subtitle": "Sist lagret kalkyle viser hva kunden skal betale for hele jobben (fastpris + tillegg).",
        "report.view.priceCalculated.open": "Åpne kalkyle",
        "report.view.priceCalculated.exVat": "Eks. mva",
        "report.view.priceCalculated.incVat": "Inkl. mva",
        "report.additional_work_calculator.sectionTitle": "Beregn tilleggsarbeider",
        "report.additional_work_calculator.sectionSubtitle": "Kalkyle for tillegg utover fastpris — enkel oversikt for kunden",
        "report.additional_work_calculator.sectionBody": "Åpne kalkylen for å justere timer, vareforbruk og nytt oppmøte. Hovedtallene viser hva kunden skal betale med og uten mva.",
        "report.additional_work_calculator.open": "Åpne kalkyle",
        "report.additional_work_calculator.dialogTitle": "Kalkyle — hva skal kunden betale?",
        "report.additional_work_calculator.loading": "Henter priseestimat…",
        "report.additional_work_calculator.heroLabel": "Hva skal kunden betale (hele jobben)",
        "report.additional_work_calculator.exVat": "Uten mva (eks.)",
        "report.additional_work_calculator.incVat": "Med mva (inkl.)",
        "report.additional_work_calculator.exVatShort": "eks.",
        "report.additional_work_calculator.incVatShort": "inkl.",
        "report.additional_work_calculator.extraHours": "Tilleggstimer",
        "report.additional_work_calculator.hoursLabel": "Antall timer",
        "report.additional_work_calculator.newVisit": "Nytt oppmøte / kjøring",
        "report.additional_work_calculator.newVisitHelp": "Avstand og priser hentes fra samme grunnlag som priseestimatet (leveringsadresse m.m.). Du kan bruke systemets km, egne km eller fast minimumstakst.",
        "report.additional_work_calculator.includeVisit": "Ta med kostnad for nytt oppmøte",
        "report.additional_work_calculator.estimateKm": "Avstand fra priseestimat: {{km}} km (ca.)",
        "report.additional_work_calculator.estimateKmPrice": "Kilometerpris kunde: {{price}} kr/km eks. mva",
        "report.additional_work_calculator.estimateMin": "Minstebeløp kjøring: {{min}} kr — ved lav km brukes fast takst {{fixed}} kr",
        "report.additional_work_calculator.underMinHint": "Ved systemavstand under minstebeløp brukes fast takst i beregningen.",
        "report.additional_work_calculator.modeSystem": "Bruk km fra system",
        "report.additional_work_calculator.modeCustom": "Egne km",
        "report.additional_work_calculator.modeMinimum": "Kun minimum / fast takst",
        "report.additional_work_calculator.customKm": "Antall kilometer",
        "report.additional_work_calculator.productsTitle": "Vareforbruk (ikke fastprislinjer)",
        "report.additional_work_calculator.noProducts": "Ingen varelinjer utenfor fastpris er registrert på rapporten.",
        "report.additional_work_calculator.lineHint": "Endringer her påvirker kun kalkylen — ikke rapportlinjene.",
        "report.additional_work_calculator.qty": "Antall",
        "report.additional_work_calculator.unitPrice": "Pris/stk (eks.)",
        "report.additional_work_calculator.exclude": "Utelat fra beregning",
        "report.additional_work_calculator.includeAgain": "Ta med igjen",
        "report.additional_work_calculator.detailsToggle": "Mer for firma (kostpris, margin, fastpris)",
        "report.additional_work_calculator.hourlyCustomer": "Timepris kunde (kr eks.)",
        "report.additional_work_calculator.hourlyCustomerHelp": "Timepris som kunden faktureres. Standard hentes fra firmaets timeprodukt.",
        "report.additional_work_calculator.hourlyCost": "Timepris kostpris (kr eks.)",
        "report.additional_work_calculator.hourlyCostHelp": "Kostpris per time for firmaet.",
        "report.additional_work_calculator.fallbackHourly": "Standardpris brukt — faktisk kundepris ikke funnet.",
        "report.additional_work_calculator.fallbackCost": "Standardpris brukt — faktisk kostpris ikke funnet.",
        "report.additional_work_calculator.rowLaborCust": "Arbeid (kunde)",
        "report.additional_work_calculator.rowLaborCost": "Arbeid (kostpris)",
        "report.additional_work_calculator.rowMaterialCust": "Varer (kunde)",
        "report.additional_work_calculator.rowMaterialCost": "Varer (kostpris)",
        "report.additional_work_calculator.rowVisitCust": "Oppmøte (kunde)",
        "report.additional_work_calculator.rowVisitCost": "Oppmøte (kostpris)",
        "report.additional_work_calculator.rowFixed": "Fastprislinjer (kunde, eks.)",
        "report.additional_work_calculator.rowTotalCost": "Sum kostpris firma (eks.)",
        "report.additional_work_calculator.rowMargin": "Margin (eks.)",
        "report.additional_work_calculator.historyToggle": "Lagrede kalkyler ({{count}})",
        "report.additional_work_calculator.restore": "Gjenopprett",
        "report.additional_work_calculator.close": "Lukk",
        "report.additional_work_calculator.save": "Lagre kalkyle",
        "report.additional_work_calculator.saveAsNew": "Lagre som ny beregning",
        "report.additional_work_calculator.saveOverwrite": "Lagre over siste",
        "report.additional_work_calculator.saveOverwriteHint": "Erstatter den nyeste lagrede kalkylen. Eldre historikk beholdes.",
        "report.additional_work_calculator.newCalculation": "Ny beregning",
        "report.additional_work_calculator.newCalculationHint": "Nullstiller skjema ut fra rapport og priseestimat (siste lagring påvirker ikke).",
        "report.additional_work_calculator.saving": "Lagrer…",
        "report.additional_work_calculator.toastSaved": "Kalkyle lagret",
        "report.additional_work_calculator.toastSavedNew": "Ny beregning lagret",
        "report.additional_work_calculator.toastSavedOverwrite": "Siste beregning er oppdatert",
        "report.additional_work_calculator.toastSaveError": "Kunne ikke lagre kalkyle",
        "report.additional_work_calculator.toastRestored": "Verdier fra lagret kalkyle er lastet inn",
        "report.additional_work_calculator.addFromCatalog": "Legg til produkt",
        "report.additional_work_calculator.addManualLine": "Tom linje",
        "report.additional_work_calculator.addProductsTitle": "Velg produkter til kalkylen",
        "report.additional_work_calculator.addSelectedProducts": "Legg til i kalkyle",
        "report.additional_work_calculator.toastProductsAdded": "{{count}} produkt(er) lagt til i kalkylen",
        "report.additional_work_calculator.lineTitle": "Beskrivelse / vare",
        "report.additional_work_calculator.lineHintCustom": "Kun i kalkylen — oppretter ikke rapportlinje.",
        "report.additional_work_calculator.unitCost": "Kost/stk (eks.)",
        "report.additional_work_calculator.removeLine": "Fjern linje",
        "report.additional_work_calculator.loadFromReport": "Last kalkyle fra rapport",
        "report.additional_work_calculator.loadFromReportHint":
          "Listen viser bare rapporter med lagret priskalkyle. Velg rapport — siste lagrede kalkyle brukes. Varelinjer fra kilderapporten kobles ikke til denne rapporten.",
        "report.additional_work_calculator.reportSelectorLabel": "Rapport med priskalkyle",
        "report.additional_work_calculator.selectorCalcSummary": "Sist lagra: {{ex}} eks. / {{inc}} inkl.",
        "report.additional_work_calculator.loadFromReportDialogTitle": "Last inn kalkyle fra annen rapport",
        "report.additional_work_calculator.loadFromReportBody":
          "Oppgi rapport-ID (samme som i URL eller rapportkort). Varelinjer fra den rapporten kobles ikke til denne — de blir kun med i kalkylen her.",
        "report.additional_work_calculator.reportIdLabel": "Rapport-ID",
        "report.additional_work_calculator.loadFromReportApply": "Last inn",
        "report.additional_work_calculator.loadFromReportCancel": "Avbryt",
        "report.additional_work_calculator.loadFromReportLoading": "Henter…",
        "report.additional_work_calculator.loadFromReportIdRequired": "Oppgi rapport-ID",
        "report.additional_work_calculator.loadFromReportIdInvalid": "Ugyldig rapport-ID",
        "report.additional_work_calculator.loadFromReportSame": "Velg en annen rapport enn denne",
        "report.additional_work_calculator.toastLoadedFromReport": "Kalkyle lastet fra rapport {{number}}",
        "report.additional_work_calculator.toastNoCalculatorOnReport": "Den rapporten har ingen lagret kalkyle",
        "report.additional_work_calculator.toastLoadReportError": "Kunne ikke hente rapport eller kalkyle",
        "report.additional_work_calculator.addToConsumption": "Legg til i vareforbruk",
        "report.additional_work_calculator.addToConsumptionWorking": "Legger til…",
        "report.additional_work_calculator.addToConsumptionHint":
          "Oppretter eller oppdaterer en varelinje på rapporten (samme som vareforbruk). Priser fra kalkylen synkroniseres til linjen når de avviker.",
        "report.additional_work_calculator.toastAddedToConsumption": "Lagt til i vareforbruk",
        "report.additional_work_calculator.toastAddToConsumptionNeedQty": "Angi antall større enn 0",
        "report.additional_work_calculator.toastAddToConsumptionNeedTitle": "Angi beskrivelse for manuell linje",
        "report.additional_work_calculator.toastAddToConsumptionUnlinked":
          "Varen ble lagt til, men kalkylen kunne ikke kobles til linjen automatisk — oppdater eller legg til på nytt fra vareforbruk.",
        "report.additional_work_calculator.toastAddToConsumptionPriceSyncError":
          "Varelinje opprettet, men prisene fra kalkylen kunne ikke oppdateres",
        "report.additional_work_calculator.toastAddToConsumptionError": "Kunne ikke legge til i vareforbruk",
        "report.additional_work_calculator.discountLabel": "Rabatt timer / kjøring",
        "report.additional_work_calculator.discountHint":
          "Beløp i kroner eks. mva som trekkes fra tilleggstimer og nytt oppmøte/kjøring (ikke fra varer eller fastpris). Kan ikke overstige summen av disse.",
        "report.additional_work_calculator.discountFieldLabel": "Rabatt timer/kjøring (kr eks. mva)",
        "report.additional_work_calculator.lineDiscountLabel": "Rabatt linje (eks.)",
        "report.additional_work_calculator.lineDiscountHint":
          "Rabatt i kroner eks. mva på denne varelinjen. Kan ikke overstige linjens beløp (antall × pris/stk).",
        "report.additional_work_calculator.rowSubtotal": "Sum før rabatter (eks.)",
        "report.additional_work_calculator.rowDiscount": "Rabatt (eks.)",
        "report.additional_work_calculator.rowDiscountMaterials": "Rabatt varer (eks.)",
        "report.additional_work_calculator.rowDiscountHoursVisit": "Rabatt timer/kjøring (eks.)",
        "report.additional_work_calculator.rowMaterialCustGross": "Varer før rabatt (kunde, eks.)",
        "report.additional_work_calculator.detailsToggleCustomer": "Prisdetaljer (kunde, eks.)",
        "report.additional_work_calculator.rowTotalCustomerExVat": "Sum kunde (eks.)",
        "report.additional_work_calculator.excludeShort": "Utelat",
        "report.additional_work_calculator.includeShort": "Ta med",
        "report.additional_work_calculator.addToConsumptionShort": "Vareforbruk",
        "report.additional_work_calculator.addPriceLines": "Legg til prislinje",
        "report.additional_work_calculator.addPriceLinesHint":
          "Oppretter én avtalt prislinje «Avtalt arbeid inkl. oppmøte»: summen av tilleggstimer og oppmøte/kjøring (eks. mva, før rabatt på timer/kjøring). Kobler første prosjektaktivitet som har aktivitetselement, ellers første aktivitet på prosjektet. Juster under Prislinjer.",
        "report.additional_work_calculator.priceLineWorkIncludingVisitTitle":
          "Avtalt arbeid inkl. oppmøte (kalkyle)",
        "report.additional_work_calculator.toastPriceLinesNothing":
          "Legg inn tilleggstimer og/eller slå på nytt oppmøte med beløp over null.",
        "report.additional_work_calculator.toastPriceLinesAdded": "{{count}} prislinje(r) lagt til",
        "report.additional_work_calculator.toastPriceLinesError": "Kunne ikke opprette prislinje",
        "report.sectionCard.viewOnlyHint": "Kun visning (klikk for å se)",
        "report.sectionCard.progress": "Fremgang",
        "report.sectionDialog.reportTitle": "Rapportinnhold",
        "report.sectionDialog.reportDescription": "Skriv rapportinnhold",
        "report.sectionDialog.reportContentLabel": "Rapportinnhold",
        "report.sectionDialog.internalReportLabel": "Intern rapport",
        "report.sectionDialog.placeholderReport": "Skriv rapportinnhold her…",
        "report.sectionDialog.placeholderInternal": "Skriv intern rapport her…",
        "report.sectionDialog.formatting": "Formaterer…",
        "report.sectionDialog.formatWithAi": "Formater med ChatGPT",
        "report.sectionDialog.autoSaveHint": "Endringer lagres automatisk.",
        "report.sectionDialog.saving": "Lagrer…",
        "report.sectionDialog.saved": "Lagret",
        "report.sectionDialog.autoSaveError": "Kunne ikke lagre rapporttekst",
        "report.sectionDialog.close": "Lukk",
        "report.agreement.section.followup": "Oppfølging til kunde",
        "report.agreement.section.followup_help":
          "Send påminnelse, send avtalen på nytt (SMS), eller send oppdatert avtale etter at den er bekreftet.",
        "report.agreement.section.manual_confirm": "Bekreft avtale manuelt",
        "report.agreement.section.manual_confirm_help":
          "Bruk når kunden allerede har bekreftet utenfor Promang. Du blir spurt om å bekrefte før det lagres.",
        "report.agreement.section.cancel_agreement": "Avbryt avtale",
        "report.agreement.section.cancel_agreement_help":
          "Velg type avbestilling eller årsak. «Oppdrag kansellert» avslutter uten begrunnelse og uten melding om ny tid. SMS til kunden kan slås av/på under før du bekrefter.",
        "report.agreement.cancel_sms_hint":
          "Hvis dette er på, kan det sendes SMS når avbestillingen sendes (avhengig av oppsett).",
        "report.agreement.prompt.reminder_title": "Send bekreftelsespåminnelse?",
        "report.agreement.prompt.reminder_body":
          "Sjekk at du ikke allerede har sendt en påminnelse for denne avtalen.",
        "report.agreement.prompt.resend_title": "Send avtale på nytt?",
        "report.agreement.prompt.resend_body":
          "Sjekk at du ikke allerede har sendt ny melding til kunden.",
        "report.agreement.prompt.updated_appointment_title":
          "Send oppdatert avtale?",
        "report.agreement.prompt.updated_appointment_body":
          "Det sendes samme dato og tid som før; beskrivelse og annet kan være oppdatert.",
        "report.agreement.prompt.confirm_manual_title":
          "Registrere manuell bekreftelse?",
        "report.agreement.prompt.confirm_manual_body":
          "Avtalen merkes som bekreftet ({{method}}). Vil du fortsette?",
        "report.agreement.prompt.cancel_agreement_title": "Avbryte avtalen?",
        "report.agreement.prompt.cancel_agreement_body":
          "Årsak: {{reason}}. Dette avbestiller avtalen i Promang. Vil du fortsette?",
        "cancel.reason": "Årsak til avbestilling",
        "cancel.reason.required": "Årsak til avbestilling er påkrevd",
        "cancel.reason.employee_sickness": "Servicetekniker syk",
        "cancel.reason.customer_sickness": "Kunde syk",
        "cancel.reason.not_confirmed": "Ikke bekreftet av kunde",
        "cancel.reason.not_suited": "Tidspunkt passet ikke for kunden",
        "cancel.reason.assignment_cancelled": "Oppdrag kansellert",
        "cancel.reason.not_chosen": "Ikke valgt",
        "report.agreement.edit": "Rediger avtale",
        "report.agreement.time_range": "Tidsrom",
        "report.variables.update": "Oppdater variabler",
        "report.price_lines.title": "Prislinjer",
        "report.price_lines.description": "Administrer prislinjer og avtalte priser",
        "report.price_lines.add": "Legg til prislinje",
        "report.price_lines.empty": "Ingen prislinjer lagt til",
        "report.price_lines.line": "Prislinje",
        "report.price_lines.title_field": "Tittel",
        "report.price_lines.activity_item": "Aktivitet",
        "report.price_lines.no_activity": "Ingen aktivitet",
        "report.price_lines.description_field": "Beskrivelse",
        "report.price_lines.is_agreed_price": "Avtalt prislinje",
        "report.price_lines.agreed_price": "Avtalt pris",
        "report.price_lines.agreed_price_excl_vat": "Avtalt pris (eks. mva)",
        "report.price_lines.agreed_price_incl_vat": "Avtalt pris (inkl. mva)",
        "report.price_lines.vat_type": "MVA Type",
        "report.price_lines.no_vat_type": "Ingen MVA Type",
        "report.price_lines.select_vat_type": "Velg MVA Type",
        "report.price_lines.select_vat_type_description": "Velg en MVA type for denne prislinjen",
        "report.price_lines.search_vat_types": "Søk etter MVA typer...",
        "report.price_lines.no_vat_types_found": "Ingen MVA typer funnet",
        "report.price_lines.no_vat_types_available": "Ingen MVA typer tilgjengelig",
        "report.price_lines.select_activity": "Velg Aktivitet",
        "report.price_lines.project_activity": "Prosjektaktivitet",
        "report.price_lines.select_project_activity": "Velg prosjektaktivitet",
        "report.price_lines.select_project_first": "Velg et prosjekt først",
        "report.price_lines.remove_activity": "Fjern Aktivitet",
        "report.price_lines.agreed_hours": "Avtalte timer",
        "project_activity.label": "Prosjektaktivitet",
        "project_activity.select": "Velg prosjektaktivitet",
        "project_activity.dialog_title": "Velg prosjektaktivitet",
        "project_activity.search_placeholder": "Søk i prosjektaktiviteter…",
        "project_activity.empty": "Ingen prosjektaktiviteter funnet",
        "project_activity.select_project_first": "Velg prosjekt først",
        "project_activity.load_error": "Kunne ikke laste prosjektaktiviteter",
        "project_activity.clear_selection": "Fjern valg",
        "project_activity.none": "Ingen prosjektaktivitet",
        "project_activity.missing": "Ingen prosjektlinje",
        "hours.period_table.project_and_line": "Prosjekt / prosjektlinje",
        "Loading": "Laster",
        "hours.registration_warning.title": "Advarsel: Timer overstiger beregnet",
        "hours.registration_warning.message": "Du er i ferd med å registrere {newHours} timer på aktiviteten \"{activityTitle}\". Dette vil bringe totalt registrerte timer til {totalAfterRegistration} timer, som overstiger de beregnede {estimatedHours} timene. Nå registrert: {registeredHours} timer.",
        "hours.registration_warning.question": "Er du sikker på at du vil registrere disse timene på denne aktiviteten?",
        "hours.registration_warning.confirm": "Ja, jeg er sikker",
        "hours.registration_warning.cancel": "Nei, korriger",
        "hours.registration_warning.this_activity": "denne aktiviteten",
        "hours.form_tab_details": "Detaljer",
        "hours.approved_edit_notice_title": "Godkjent time",
        "hours.approved_edit_notice_body":
          "Denne timen er godkjent. Som bedriftsadministrator kan du likevel redigere den; godkjenningsstatus beholdes. Lønn eller Tripletex bør kontrolleres manuelt etter endringer.",
        "hours.bulk_reassign.project_field": "Prosjekt",
        "hours.bulk_reassign.title": "Flytt timer til annet prosjekt / aktivitet",
        "hours.bulk_reassign.intro": "Du redigerer {{count}} time(r). Velg målprosjekt og prosjektaktivitet (linje).",
        "hours.bulk_reassign.project_required": "Prosjekt er påkrevd",
        "hours.bulk_reassign.activity_required": "Prosjektaktivitet er påkrevd",
        "hours.bulk_reassign.submit": "Bruk på valgte timer",
        "hours.bulk_reassign.saving": "Lagrer…",
        "hours.bulk_reassign.success": "Oppdaterte {{count}} time(r).",
        "hours.bulk_reassign.partial": "Oppdaterte {{updated}}; {{failed}} feilet — se listen.",
        "hours.bulk_reassign.error": "Kunne ikke flytte timer",
        "hours.bulk_reassign.open": "Flytt valgte…",
        "hours.approval.filter_project": "Prosjekt",
        "hours.approval.all_projects": "Alle prosjekter",
        "hours.approval.clear_project_filter": "Fjern prosjekt",
        "hours.approval.selection_summary.title": "Oppsummering av valg",
        "hours.approval.selection_summary.subtitle":
          "«Registrert» og periode-tall er fra listen for valgt datointervall og filter (samme utvalg som tabellen).",
        "hours.approval.selection_summary.total_selected": "Valgt: {{hours}} t · {{entries}} poster",
        "hours.approval.selection_summary.period_totals": "I perioden (lastet): {{hours}} t · {{entries}} poster",
        "hours.approval.selection_summary.by_date": "Per dato",
        "hours.approval.selection_summary.day_row": "{{date}}: {{selected}} t valgt av {{registered}} t registrert",
        "hours.approval.selection_summary.other_days": "Andre dager med registreringer: {{days}} dager · {{hours}} t",
        "hours.approval.selection_summary.clear": "Fjern valg",
        "hours.approval.selection_summary.unknown_user": "Ukjent bruker",
        "hours.approval.bulk_unapprove.action": "Avgodkjenn valgte",
        "hours.approval.bulk_unapprove.no_approved": "Ingen av de valgte timene er godkjent.",
        "hours.approval.bulk_unapprove.success": "Godkjenning fjernet for {{count}} time(r).",
        "hours.approval.bulk_unapprove.error": "Kunne ikke avgodkjenne alle valgte timer",
        "hours.approval.bulk_unapprove.process_note": "Bulk avgodkjent",
        "project.time_registration.bulk_reassign": "Flytt valgte timer…",
        "project.time_registration.select_hour": "Velg time for masseflytting",
        "hours.sheet.add_hour": "Legg til time",
        "hours.sheet.edit_hour": "Rediger time",
        "hours.sheet.new_hour": "Ny time",
        "hours.sheet.stats_title": "Statistikk",
        "hours.sheet.stats_selected_period": "Valgt periode (listen)",
        "hours.sheet.stats_calendar_month": "Kalendermåned",
        "hours.sheet.stats_weeks_heading": "Uker",
        "hours.sheet.stats_this_week": "Denne uken",
        "hours.sheet.stats_prev_week": "Forrige uke",
        "hours.sheet.stats_normal_suffix": "normal (tidsskjema)",
        "hours.sheet.stats_no_schedule": "Ingen arbeidstidsplan er knyttet til ansettelsen — normaltimer og prosent vises ikke.",
        "hours.sheet.stats_loading_extra": "Henter måned- og uketotaler…",
        "report.price_lines.updated": "Prislinje oppdatert",
        "report.price_lines.created": "Prislinje opprettet",
        "report.price_lines.deleted": "Prislinje slettet",
        "report.price_lines.save_error": "Kunne ikke lagre prislinje",
        "report.price_lines.delete_error": "Kunne ikke slette prislinje",
        "report.price_lines.edit": "Rediger prislinje",
        "report.copy.price_lines_option": "Prislinjer",
        "report.copy.variables_option": "Variabler",
        "report.sequel.copy_variables_switch": "Kopier fra hovedrapport",
        "report.sequel.copy_variables_hint_on":
          "Variabler kopieres fra hovedrapporten, inkl. grupper, type-grupper, verdier og målinger.",
        "report.sequel.copy_variables_hint_off": "Ingen variabler kopieres.",
        "report.sequel.copy_variables_none_available":
          "Ingen variabelrader eller grupper på hovedrapporten — ingenting å kopiere.",
        "report.sequel.copy_price_lines_switch": "Kopier fra hovedrapport",
        "report.sequel.copy_price_lines_hint_on":
          "Prislinjer kopieres fra hovedrapporten ({{count}} linjer).",
        "report.sequel.copy_price_lines_hint_off": "Ingen prislinjer kopieres.",
        "report.sequel.copy_price_lines_none_available": "Ingen prislinjer på hovedrapporten.",
        "report.price_lines.updating": "Oppdaterer...",
        "report.price_lines.adding": "Legger til...",
        "report.price_lines.delete_confirm": "Er du sikker på at du vil slette denne prislinjen?",
        "report.price_lines.delete": "Slett prislinje",
        "report.price_lines.error_loading": "Feil ved lasting av prislinjer",
        "report.price_lines.add_first": "Legg til første prislinje",
        "report.price_lines.title_required": "Tittel er påkrevd",
        "report.price_lines.validation.agreed_price_or_hours":
            "Oppgi avtalt pris (eks. eller inkl. mva) eller avtalte timer, eller slå av «Avtalt prislinje».",
        "report.price_lines.server_errors_title": "Kunne ikke lagre — se meldingene under",
        "report.price_lines.field_errors_hint": "Felt med feil er markert.",
        "report.details.description": "Grunnleggende rapportinformasjon",
        "report.items.description": "Administrer varer og forbruk",
        "report.activities.description": "Administrer aktiviteter og timer",
        "report.checklist.description": "Fullfør sjekklistepunkter",
        "report.checklist.loading": "Laster sjekkliste…",
        "report.checklist.load_error": "Kunne ikke laste sjekkliste",
        "report.checklist.load_error_title": "Sjekklisten kunne ikke lastes",
        "report.checklist.load_error_hint":
          "Gå til et annet steg og tilbake, eller lukk og åpne dialogen på nytt. Hvis problemet vedvarer, prøv igjen senere.",
        "quality.checklist.view.completionTitle": "Fullfør sjekkliste",
        "quality.checklist.view.completionDescription":
          "Når alle punkter er godkjent eller registrert som avvik, kan du ferdigstille sjekklisten. Ulagrede endringer lagres når du fortsetter.",
        "quality.checklist.view.completionButton": "Ferdigstill sjekkliste",
        "quality.checklist.view.completionSaving": "Lagrer…",
        "quality.checklist.view.completionDoneTitle": "Sjekklisten er ferdigstilt",
        "quality.checklist.view.completionDoneDescription":
          "Sjekklisten er markert som ferdig.",
        "quality.checklist.type.titleLabel": "Tittel",
        "quality.checklist.type.activeLabel": "Aktiv",
        "quality.checklist.type.introLabel": "Introduksjon til denne sjekklistetypen",
        "quality.checklist.type.defaultActions": "Tilgjengelige svar",
        "quality.checklist.type.defaultActionsHint":
          "Velg hvilke utfall som skal vises som knapper på sjekklistepunkter. Enkeltpunkter kan begrense listen videre.",
        "quality.checklist.type.pointsHeading": "Sjekklistepunkter",
        "quality.checklist.type.pointsSubheading":
          "Legg inn tittel, veiledning til oppdragsgiver/bruker, og hvilke svar som gjelder for hvert punkt.",
        "quality.checklist.type.documentsRequired": "Dokumentasjon påkrevd",
        "quality.checklist.type.pointLabel": "Punkt {{n}}",
        "quality.checklist.type.pointTitle": "Punktet sitt navn",
        "quality.checklist.type.guidanceLabel": "Veiledning",
        "quality.checklist.type.guidanceHint":
          "Vises den som fyller ut sjekklisten, slik at de forstår hva som skal bekreftes. Fritekstsvaret skrives i feltet under ved utfylling.",
        "quality.checklist.type.pointActions": "Svar for dette punktet",
        "quality.checklist.type.pointActionsHint":
          "Skru av svar som ikke skal vises bare for dette punktet. Standard følger sjekklistetypen.",
        "quality.checklist.type.addRow": "Nytt punkt",
        "quality.checklist.type.deleteRowConfirm": "Slette dette punktet?",
        "quality.checklist.type.customFieldsTitle": "Egendefinerte felt",
        "quality.checklist.type.customFieldsHint":
            "Legg til inndatafelt som må fylles ut ved utføring av dette punktet (f.eks. målt strøm, gjenvinningstall).",
        "quality.checklist.type.customFieldLabel": "Etikett",
        "quality.checklist.type.customFieldType": "Type",
        "quality.checklist.type.customFieldUnit": "Enhet",
        "quality.checklist.type.customFieldPlaceholder": "Plassholdertekst",
        "quality.checklist.type.customFieldRequired": "Påkrevd",
        "quality.checklist.type.customFieldAdd": "Legg til felt",
        "quality.checklist.type.customFieldTypes.text": "Tekst",
        "quality.checklist.type.customFieldTypes.number": "Tall",
        "quality.checklist.type.customFieldTypes.textarea": "Lang tekst",
        "quality.checklist.actions.performed": "Utført",
        "quality.checklist.actions.approved": "Godkjent",
        "quality.checklist.actions.na": "Ikke aktuelt",
        "quality.checklist.actions.deviation": "Avvik",
        "quality.checklist.item.title": "Tittel",
        "quality.checklist.item.guidanceTitle": "Veiledning",
        "quality.checklist.item.completionNote": "Notater / observert",
        "quality.checklist.item.deviationNoteRequired": "Legg inn en kort forklaring på avviket.",
        "quality.checklist.item.responseLabel": "Utfall",
        "quality.checklist.item.customFieldsTitle": "Målinger / data",
        "quality.checklist.item.customFieldRequired": "Dette feltet er påkrevd",
        "quality.checklist.item.customFieldsRequiredBeforeOutcome":
            "Fyll ut påkrevde felt før du velger utfall.",
        "report.type.required": "Rapporttype er påkrevd",

        "report.dev.title": "Dev",
        "report.dev.variables_v2": "Variabler V2",
        "report.dev.variables_v2_desc": "Rediger rapportvariabler (gruppert editor)",

        "report.variables.legacy.headingOnly": "Variabler",
        "report.variables.legacy.headingTagged": "Variabler (Legacy)",
        "report.variables.legacy.saving": "Lagrer...",
        "report.variables.legacy.save": "Lagre variabler",
        "report.variables.orphaned.title": "Ufullstendige hovedvariabler",
        "report.variables.orphaned.body":
          "Disse variablene er markert som hovedvariabler men mangler type gruppe. De bør knyttes til en type gruppe eller slettes.",
        "report.variables.ungrouped.heading": "Variabler uten gruppe",
        "report.variables.groups.heading": "Grupper",
        "report.variables.newSystem.title": "Variabler",
        "report.variables.createTypeGroup": "Opprett type gruppe",
        "report.variables.createGroup": "Opprett gruppe",
        "report.variables.sketch.tablist": "Variabler (skisse)",
        "report.variables.sketch.groupTablist": "Grupper og hovedoversikt",
        "report.variables.sketch.navGroupLabel": "Gruppe",
        "report.variables.sketch.navVariableTypeLabel": "Variabeltype",
        "report.variables.sketch.typeTablist": "Variabeltyper",
        "report.variables.sketch.noTypesInGroup": "Ingen variabeltyper her ennå.",
        "report.variables.sketch.ungroupedTab": "Uten gruppe",
        "report.variables.sketch.ungroupedTabSub": "{{count}} variabeltyper",
        "report.variables.sketch.pickVariableType": "Velg en variabeltype i fanen over.",
        "report.variables.sketch.addGroup": "Legg til gruppe",
        "report.variables.sketch.groupNoTypes": "Ingen typegrupper",
        "report.variables.sketch.unitsNotSet": "Måleenhet ikke satt",
        "report.variables.sketch.untitledGroup": "Uten navn",
        "report.variables.sketch.measureLabel": "Mål",
        "report.variables.sketch.projectedShort": "Prosj.",
        "report.variables.sketch.variableTypeFallback": "Variabeltype",
        "report.variables.sketch.tabOrphaned": "Ufullstendige",
        "report.variables.sketch.tabOrphanedSub": "{{count}} hovedvariabler",
        "report.variables.sketch.tabLegacySub": "Eldre format",
        "report.variables.sketchTab.legacy": "Eldre",
        "report.variables.sketch.emptyAll":
          "Ingen grupper eller løse variabeltyper ennå. Bruk knappene over for å opprette.",
        "report.variables.sketch.groupTabEmpty":
          "Ingen typegrupper i denne fanen ennå. Legg til hovedvariabel.",
        "report.variables.sketch.editGroup": "Rediger gruppe",
        "report.variables.sketch.addMainVariable": "Hovedvariabel",
        "report.variables.sketch.addAnotherMainVariable": "Legg til ny hovedvariabel i gruppen",
        "report.variables.sketch.typeGroupUngrouped": "Type-gruppe (uten gruppe)",
        "report.variables.sketch.deleteGroupAria": "Slett gruppe",
        "report.variables.sketch.structureMenuTrigger": "Gruppe og struktur",
        "report.variables.sketch.structureMenuAria": "Gruppe og struktur — flere handlinger",
        "report.variables.sketch.deleteGroupMenu": "Slett gruppe",
        "report.variables.sketch.addVariable": "Legg til variabel",
        "report.variables.sketch.addBulkVariables": "Legg til bulk variabel",
        "report.variables.sketch.editTypeGroupAria": "Rediger variabeltype",
        "report.variables.sketch.deleteTypeGroupAria": "Slett variabeltype",
        "report.variables.sketch.typeGroupMoreAria": "Flere handlinger for variabeltype",
        "report.variables.sketch.editTypeGroupMenu": "Rediger variabeltype",
        "report.variables.sketch.deleteTypeGroupMenu": "Slett variabeltype",
        "report.variables.sketch.measurements": "Målinger",
        "report.variables.sketch.editVariable": "Rediger",
        "report.variables.sketch.editVariableAria": "Rediger variabel",
        "report.variables.sketch.deleteVariable": "Slett",
        "report.variables.sketch.deleteVariableAria": "Slett variabel",
        "report.variables.sketch.variableRowMenuAria": "Handlinger for variabel",
        "report.variables.sketch.noSubvariablesYet": "Ingen variabler ennå",
        "report.variables.sketch.actionSheetClose": "Lukk",
        "report.variables.sketch.openVariableActionsAria": "Vis handlinger for variabel",
        "report.variables.sketch.variableActionsTitle": "Variabel",
        "report.variables.sketch.variableActionsHint": "Velg en handling under.",
        "report.variables.sketch.rowProjected": "Prosjektert:",
        "report.variables.sketch.rowPreMeasurement": "Før-måling:",
        "report.variables.sketch.rowMeasured": "Målt:",
        "report.variables.sketch.globalTotalsHeading": "Total pr. variabeltype (alle grupper)",
        "report.variables.sketch.globalStatTotalLabel": "Total",
        "report.variables.sketch.globalSumPre": "Før-mål (total)",
        "report.variables.sketch.globalSumMeasured": "Målt (total)",
        "report.variables.sketch.tabSumProjected": "Σ Prosj.",
        "report.variables.sketch.tabSumPre": "Σ Før",
        "report.variables.sketch.tabSumMeasured": "Σ Målt",
        "report.variables.sketch.cardTotalPrefix": "TOTAL",
        "report.variables.sketch.totalsProjRow": "Proj. total",
        "report.variables.sketch.totalsPreRow": "Pre total",
        "report.variables.sketch.totalsMeasRow": "Målt total",
        "report.variables.sketch.newGroup": "Ny gruppe",
        "report.variables.sketch.typeGroupShort": "Type-gruppe",
        "report.variables.sketch.tableColVariable": "Variabel",
        "report.variables.sketch.tableColProj": "Proj.",
        "report.variables.sketch.tableColPre": "Pre",
        "report.variables.sketch.tableColMeas": "Målt",
        "report.variables.sketch.tableColLsSuffix": "(l/s)",
        "report.variables.sketch.bulkAddShort": "Bulk-add",
        "report.variables.sketch.fabNoType": "Opprett en type-gruppe før du legger til variabler.",
        "report.variables.sketch.statusMeasuredOnly": "Målt",
        "report.variables.sketch.statusGood": "God",
        "report.variables.sketch.statusCheck": "Sjekk",
        "report.variables.sketchEditor.statusMeasured": "Målt",
        "report.variables.sketchEditor.statusGood": "God match",
        "report.variables.sketchEditor.statusGoodSub": "Målt verdi er innenfor akseptabelt område",
        "report.variables.sketchEditor.statusCheck": "Sjekk avvik",
        "report.variables.sketchEditor.statusCheckSub": "Målt avviker mer enn 15 % fra prosjektert",
        "report.variables.sketchEditor.refRequired": "Referanse er påkrevd",
        "report.variables.sketchEditor.saveError": "Kunne ikke lagre",
        "report.variables.sketchEditor.measureError": "Kunne ikke lagre måling",
        "report.variables.sketchEditor.saved": "Lagret",
        "report.variables.sketchEditor.noGroup": "Uten gruppe",
        "report.variables.sketchEditor.measuredActual": "Målt (faktisk)",
        "report.variables.sketchEditor.cancel": "Avbryt",
        "report.variables.sketchEditor.saving": "Lagrer…",
        "report.variables.sketchEditor.saveChanges": "Lagre endringer",
        "report.variables.sketchEditor.deleteSubvariable": "Slett undervariabel",
        "report.variables.sketchEditor.deleteSubvariableHint":
          "Sletting gjelder kun denne undervariabelen. Hovedvariabel og type-gruppe beholdes.",
        "report.variables.sketchEditor.deleteSubvariableConfirm":
          "Er du sikker på at du vil slette undervariabelen «{{reference}}»? Målinger og verdier slettes permanent.",
        "report.variables.sketchEditor.subvariableDeleted": "Undervariabel slettet",
        "report.variables.sketchEditor.subvariableDeleteError": "Kunne ikke slette variabel",
        "report.variables.sketchEditor.deleteSubvariableCancel": "Avbryt",
        "report.variables.sketchEditor.deleteSubvariableWorking": "Sletter…",
        "report.variables.sketchEditor.deleteSubvariableConfirmAction": "Slett permanent",
        "report.variables.sketchEditor.measuredHint":
          "Oppdaterer siste måling ved lagring. Bruk «Legg til måling» under for å registrere flere målepunkter.",
        "report.variables.sketchEditor.addMeasurementHeading": "Legg til ny måling",
        "report.variables.sketchEditor.addMeasurementValue": "Målingsverdi",
        "report.variables.sketchEditor.addMeasurementButton": "Legg til",
        "report.variables.sketchEditor.addingMeasurement": "Legger til…",
        "report.variables.sketchEditor.measurementAdded": "Måling lagt til",
        "report.variables.sketchEditor.measurementInvalid": "Oppgi en gyldig målingsverdi",
        "report.variables.sketchEditor.historyHeading": "Målingshistorikk ({{count}})",
        "report.variables.sketchEditor.historyLoading": "Laster målinger…",
        "report.variables.sketchEditor.historyEmpty": "Ingen målinger registrert",
        "report.variables.sketchEditor.historyLoadError": "Kunne ikke laste målinger",
        "report.variables.sketchEditor.historyColValue": "Verdi",
        "report.variables.sketchEditor.historyColDate": "Dato/tid",
        "report.variables.sketchEditor.tabMeasurements": "Målinger",
        "report.variables.sketchEditor.tabDetails": "Verdier",
        "report.variables.sketchEditor.tabsAria": "Rediger variabel — faner",
        "report.variables.sketchEditor.measurementsIntro": "Registrer ny måling eller se historikk.",
        "report.variables.sketchEditor.detailsIntro": "Referanse og felt som lagres sammen.",
        "report.variables.sketchEditor.goToDetails": "Rediger referanse og øvrige verdier →",
        "report.variables.sketchEditor.close": "Lukk",
        "report.variables.sketchEditor.addMeasurementPlaceholder": "Verdi",
        "report.variables.sketchEditor.measuredHintDetails":
          "Oppdaterer siste måling hvis du lagrer en ny verdi her. Nye målepunkter legger du til under Målinger.",
        "report.variables.measurementDialog.title": "Målinger",
        "report.variables.measurementDialog.variableFallback": "Variabel",
        "report.variables.measurementDialog.contextHeading": "Grunnlag",
        "report.variables.measurementDialog.reference": "Referanse",
        "report.variables.measurementDialog.measurementUnit": "Måleenhet",
        "report.variables.measurementDialog.projectedUnit": "Prosjektert enhet",
        "report.variables.measurementDialog.projectedLabel": "Prosjektert",
        "report.variables.measurementDialog.preMeasurementLabel": "Før-måling",
        "report.variables.measurementDialog.latestHeading": "Siste måling",
        "service Agreement": "Serviceavtale",
        "project": "Prosjekt",
        "project_plan": "Prosjektplan",
        "projects_plan": "Prosjektplan",
        "projects_accounting": "Prosjektregnskap",
        "project.details": "Prosjektdetaljer",
        "project.edit": "Rediger prosjekt",
        "absence": "Fravær",
        "Week": "Uke",
        "Day": "Dag",
        "Filters": "Filtre",
        "Project Filter": "Prosjektfilter",
        "Activity Filter": "Aktivitetsfilter",
        "All Projects": "Alle prosjekter",
        "All Activities": "Alle aktiviteter",
        "Clear Filters": "Tøm filtre",
        "No hours recorded for this day":
          "Ingen timer registrert for denne dagen",
        "entries": "oppføringer",
        "Loading hours...": "Laster timer...",
        "already_registered_hours_for_event": "Allerede registrert timer på dette event",
        "dashboard_report.status.planned": "Planlagt",

        "company_guide.badge": "Bedriftsguide",
        "company_guide.hours.title": "Timeregistrering, fravær og arbeidsplan",
        "company_guide.hours.subtitle":
          "Sjekkliste for administratorer med Timer-modulen (vises på brukerguiden for timer).",
        "company_guide.hours.progress_label": "Status",
        "company_guide.hours.progress_loading": "Laster…",
        "company_guide.hours.progress_error": "Kunne ikke hente status. Prøv å oppdatere siden.",
        "company_guide.hours.progress_summary_ok": "{{done}} av {{total}} anbefalte steg er på plass.",
        "company_guide.hours.progress_summary_warnings":
          "{{done}} av {{total}} anbefalte steg er på plass. {{warnings}} punkt(er) trenger fortsatt oppmerksomhet.",
        "company_guide.hours.footer_hint":
          "Legacy Activity/ActivityItem brukes i hovedsak mot Tripletex-synk, ikke som primær timeføring i Promang.",
        "company_guide.hours.footer_link_settings": "Åpne Timer → Innstillinger",
        "company_guide.hours.link.scroll_to_explanation": "Les forklaringen under",
        "company_guide.hours.link.settings_section": "Åpne i innstillinger",
        "company_guide.hours.link.work_schedule": "Åpne tidsplan",
        "company_guide.hours.task.registration_model.title": "Timeregistrering og prosjektlinjer",
        "company_guide.hours.task.registration_model.info":
          "Timer på prosjekt krever project_activity på prosjektet. Activity/ActivityItem er utdatert som valg i UI og brukes ved synk mot Tripletex.",
        "company_guide.hours.task.absence_types.title": "Fraværstyper",
        "company_guide.hours.task.absence_types.ok": "{{count}} fraværstype(r) er definert.",
        "company_guide.hours.task.absence_types.warn":
          "Opprett fraværstyper som matcher bedriftens behov (ferie, syk, avspasering …).",
        "company_guide.hours.task.absence_types.unknown": "Kunne ikke verifisere fraværstyper automatisk.",
        "company_guide.hours.task.handlers.title": "Ansvar for timer og fravær",
        "company_guide.hours.task.handlers.ok": "Timer- og fraværsansvarlig er satt.",
        "company_guide.hours.task.handlers.warn":
          "Sett hvem som behandler timelister og egenmeldinger, så ansatte vet hvem som følger opp.",
        "company_guide.hours.task.work_schedule.title": "Arbeidsplan og stillingsbrøk",
        "company_guide.hours.task.work_schedule.info":
          "Sørg for at ansatte har arbeidsplan som stemmer med stilling; det påvirker planlagte timer og fravær.",
        "company_guide.hours.task.work_schedule.ok": "Arbeidsplaner er opprettet og ansatte er koblet til.",
        "company_guide.hours.task.work_schedule.warn_none": "Opprett minst én arbeidsplan for firmaet.",
        "company_guide.hours.task.work_schedule.warn_unassigned":
          "{{count}} aktiv(e) ansatt(e) mangler arbeidsplan (tidsplan).",
        "company_guide.hours.link.work_schedule_admin": "Administrer arbeidsplaner",

        "company_guide.company.badge": "Bedriftsguide",
        "company_guide.company.heading": "Grunnleggende firmainnstillinger",
        "company_guide.company.subtitle":
          "Logo, kontakt, adresser og salgsbetingelser gir trygghet i kundedialog, tilbud og netthandel.",
        "company_guide.company.progress_label": "Status",
        "company_guide.company.progress_loading": "Laster…",
        "company_guide.company.progress_error": "Kunne ikke hente firmadata. Prøv å oppdatere siden.",
        "company_guide.company.progress_ok": "{{done}} av {{total}} anbefalte punkt er på plass.",
        "company_guide.company.progress_warnings":
          "{{done}} av {{total}} anbefalte punkt er på plass. {{warnings}} trenger oppmerksomhet.",
        "company_guide.company.footer_hint":
          "Endringer gjør du under Firma → Innstillinger. Sjekklisten oppdateres når du lagrer.",
        "company_guide.company.link.settings": "Åpne firmainnstillinger",
        "company_guide.company.task.name.title": "Firmanavn og organisasjon",
        "company_guide.company.task.name.warn": "Firmanavn eller organisasjonsnummer mangler eller er ufullstendig.",
        "company_guide.company.task.name.ok": "Navn og org.nr ser ut til å være registrert.",
        "company_guide.company.task.logo.title": "Logo",
        "company_guide.company.task.logo.warn": "Legg inn logo for dokumenter, tilbud og kundevisning.",
        "company_guide.company.task.logo.ok": "Logo er registrert.",
        "company_guide.company.task.contact.title": "Kontaktinformasjon",
        "company_guide.company.task.contact.warn": "Oppgi minst én av e-post, telefon eller mobil.",
        "company_guide.company.task.contact.ok": "Minst én kontaktkanal er satt.",
        "company_guide.company.task.address.title": "Adresse",
        "company_guide.company.task.address.warn": "Legg inn forretningsadresse eller postadresse.",
        "company_guide.company.task.address.ok": "Adresse er registrert.",
        "company_guide.company.task.sales_conditions_url.title": "Salgsbetingelser (URL)",
        "company_guide.company.task.sales_conditions_url.warn": "Lenke til salgsbetingelser mangler — viktig for tilbud og netthandel.",
        "company_guide.company.task.sales_conditions_url.ok": "Lenke til salgsbetingelser er satt.",
        "company_guide.company.task.vat.title": "MVA / org.nr",
        "company_guide.company.task.vat.warn": "Organisasjonsnummer / MVA-felt bør være utfylt.",
        "company_guide.company.task.vat.ok": "Org.nr / MVA er registrert.",

        "dashboard.company_guide.alert_company_title": "Firmaprofil trenger oppmerksomhet",
        "dashboard.company_guide.alert_company_subtitle":
          "{{count}} punkt i firmaguiden bør ryddes opp i.",
        "dashboard.company_guide.alert_hours_title": "Timer-oppsett trenger oppmerksomhet",
        "dashboard.company_guide.alert_hours_subtitle":
          "{{count}} punkt i timer-guiden bør ryddes opp i.",
        "dashboard.company_guide.alert_cta": "Åpne guide og sjekkliste",

        "user_guide.hub.card.company.title": "Firma og innstillinger",
        "user_guide.hub.card.company.description":
          "Logo, kontakt, adresser, salgsbetingelser og annet som bør være på plass.",

        "user_guide.company.back_to_hub": "Tilbake til brukerguiden",
        "user_guide.company.badge": "Firma",
        "user_guide.company.title": "Firmainnstillinger og profil",
        "user_guide.company.intro":
          "Riktig firmainformasjon gir trygghet mot kunder, i tilbud og i integrasjoner. Som administrator bør du gjennomføre sjekklisten under og oppdatere det som mangler.",
        "user_guide.company.section.why.title": "Hvorfor dette er viktig",
        "user_guide.company.section.why.p1":
          "Logo og kontaktdetaljer vises der kunder og leverandører forventer et profesjonelt uttrykk.",
        "user_guide.company.section.why.p2":
          "Adresse og salgsbetingelser er ofte påkrevd i avtaler, netthandel og ved eksport av dokumenter.",
        "user_guide.company.section.where.title": "Hvor du gjør endringene",
        "user_guide.company.section.where.p1":
          "Gå til Firma → Innstillinger. Bruk lenkene i sjekklisten for å hoppe rett til riktig seksjon.",

        "user_employment.work_schedule_label": "Arbeidsplan (timer)",
        "user_employment.work_schedule_hint":
          "Knyttes til timeregistrering, planlagt tid og fravær. Opprett planer under Timer → Arbeidsplaner.",
        "user_employment.work_schedule_none": "Ingen valgt",

        "work_schedules_admin.title": "Arbeidsplaner",
        "work_schedules_admin.intro":
          "Her oppretter og vedlikeholder du arbeidsplaner (timer per ukedag). Nye ansatte får siste opprettede plan som standard hvis du ikke velger annet.",
        "work_schedules_admin.summary_title": "Oversikt",
        "work_schedules_admin.summary_plans": "{{count}} arbeidsplan(er) i firmaet.",
        "work_schedules_admin.summary_unassigned_ok": "Alle aktive ansatte har arbeidsplan.",
        "work_schedules_admin.summary_unassigned_warn":
          "{{count}} aktiv(e) ansatt(e) mangler arbeidsplan — tildel under bruker/ansatt.",
        "work_schedules_admin.assign_hint": "Tildel plan på ansatt:",
        "work_schedules_admin.assign_link": "Brukere / ansatte",
        "work_schedules_admin.new": "Ny arbeidsplan",
        "work_schedules_admin.edit": "Rediger",
        "work_schedules_admin.delete": "Slett",
        "work_schedules_admin.save": "Lagre",
        "work_schedules_admin.saving": "Lagrer…",
        "work_schedules_admin.cancel": "Avbryt",
        "work_schedules_admin.field_name": "Navn (valgfritt)",
        "work_schedules_admin.field_name_placeholder": "F.eks. Kontor 7,5t",
        "work_schedules_admin.empty": "Ingen arbeidsplaner ennå — opprett én for å komme i gang.",
        "work_schedules_admin.unnamed": "Uten navn",
        "work_schedules_admin.confirm_delete": "Slette «{{name}}»? Kan ikke slettes hvis den er i bruk.",
        "work_schedules_admin.created": "Arbeidsplan opprettet",
        "work_schedules_admin.saved": "Arbeidsplan lagret",
        "work_schedules_admin.deleted": "Arbeidsplan slettet",
        "work_schedules_admin.load_error": "Kunne ikke hente arbeidsplaner",
        "work_schedules_admin.save_error": "Kunne ikke lagre",
        "work_schedules_admin.delete_error": "Kunne ikke slette",
        "work_schedules_admin.back_guide": "Tilbake til brukerguide (timer)",
        "work_schedules_admin.day.monday": "Mandag",
        "work_schedules_admin.day.tuesday": "Tirsdag",
        "work_schedules_admin.day.wednesday": "Onsdag",
        "work_schedules_admin.day.thursday": "Torsdag",
        "work_schedules_admin.day.friday": "Fredag",
        "work_schedules_admin.day.saturday": "Lørdag",
        "work_schedules_admin.day.sunday": "Søndag",

        "work_schedule_view.page_title": "Tidsplan",
        "work_schedule_view.fallback_title": "Arbeidsplan",
        "work_schedule_view.subtitle": "Timer per ukedag justert for stillingsprosent",
        "work_schedule_view.empty": "Ingen arbeidsplan er knyttet til deg som ansatt ennå.",
        "work_schedule_view.empty_hint": "Be en administrator opprette en plan og tildele den under din bruker/ansatt.",
        "work_schedule_view.link_users": "Gå til brukeroversikt",
        "work_schedule_view.day_off": "Fri",
        "work_schedule_view.hours_value": "{{hours}} timer",
        "work_schedule_view.day.monday": "Mandag",
        "work_schedule_view.day.tuesday": "Tirsdag",
        "work_schedule_view.day.wednesday": "Onsdag",
        "work_schedule_view.day.thursday": "Torsdag",
        "work_schedule_view.day.friday": "Fredag",
        "work_schedule_view.day.saturday": "Lørdag",
        "work_schedule_view.day.sunday": "Søndag",

        "hours.resource_plan.title": "Ressursplan og tilgjengelighet",
        "hours.resource_plan.subtitle": "Se hvem som er planlagt, tilgjengelig, fraværende eller stemplet inn på faktiske dager.",
        "hours.resource_plan.date_from": "Fra dato",
        "hours.resource_plan.date_to": "Til dato",
        "hours.resource_plan.access_title": "Tilgang for ansatte",
        "hours.resource_plan.access_body": "Brukere med Timer-tilgang kan se operativ status for kollegaer uten adminrettigheter.",
        "hours.resource_plan.load_error": "Kunne ikke laste ressursplan",
        "hours.resource_plan.stats.employees": "Ansatte",
        "hours.resource_plan.stats.available_days": "Tilgjengelige dagsrader",
        "hours.resource_plan.stats.clocked_in": "Stemplet inn",
        "hours.resource_plan.stats.scheduled_hours": "Planlagte timer",
        "hours.resource_plan.days_title": "Dager i perioden",
        "hours.resource_plan.days_subtitle": "Velg en dag for detaljert oversikt over medarbeidere.",
        "hours.resource_plan.day_stats": "{{available}} av {{employees}} tilgjengelige",
        "hours.resource_plan.no_day": "Ingen dag valgt",
        "hours.resource_plan.employee_overview": "Medarbeidere, planlagt tid og status for valgt dag.",
        "hours.resource_plan.empty": "Ingen ansatte funnet for valgt periode.",
        "hours.resource_plan.unknown_employee": "Ukjent medarbeider",
        "hours.resource_plan.table.employee": "Medarbeider",
        "hours.resource_plan.table.status": "Status",
        "hours.resource_plan.table.department": "Avdeling",
        "hours.resource_plan.table.scheduled": "Arbeidsplan",
        "hours.resource_plan.table.shift": "Vakt",
        "hours.resource_plan.table.note": "Notat",
        "hours.resource_plan.status.clocked_in": "På jobb nå",
        "hours.resource_plan.status.available": "Tilgjengelig",
        "hours.resource_plan.status.planned": "Planlagt",
        "hours.resource_plan.status.absent": "Fravær",
        "hours.resource_plan.status.unavailable": "Ikke tilgjengelig",
        "hours.resource_plan.status.off": "Fri",

        "hour_settings.page.subtitle":
          "Fravær, godkjenningsflyt, lønnslåsing og øvrige valg for timeregistrering (prosjekttimer bygger på project_activity på prosjekt).",
        "hour_settings.guide.title": "Slik kommer dere i gang med timer",
        "hour_settings.guide.intro":
          "Under finner du de samme steg som på dashbordet. Timeregistrering bygger på prosjekt og project_activity; listen over generelle aktiviteter i innstillinger er valgfri administrasjon og ikke et oppstartskrav.",
        "hour_settings.guide.step.project_activity":
          "Prosjekttimer: sørg for project_activity (og prosjekt) der ansatte skal føre timer — det er dette nye Promang krever for prosjektregistrering.",
        "hour_settings.guide.step.absence_types": "Fraværstyper: opprett og vedlikehold typer dere bruker.",
        "hour_settings.guide.step.handlers":
          "Sett administrator for timer og for egenmeldinger (fravær).",
        "hour_settings.guide.step.payroll_lock":
          "Vurder låsing av lønnsperiode og utbetalingsdato når dere har rutiner på plass.",
        "hour_settings.guide.step.time_documents":
          "Valgfritt — dokumentasjon på frittstående timer uten rapport eller arbeidsordre.",
        "hour_settings.guide.step.work_schedule":
          "Opprett arbeidsplaner under Timer → Arbeidsplaner og knytt dem til ansatte (brukerprofiler).",
        "hour_settings.guide.back_dashboard": "Tilbake til forsiden",
        "hour_settings.guide.open_user_guide": "Brukerguide: timer og fravær",
        "hour_settings.time_documents.section_title": "Dokumentasjon på timer",
        "hour_settings.time_documents.section_description":
          "Tillat å legge ved bilder/filer på frittstående timer når timen ikke er knyttet til service­rapport eller arbeidsordre.",
        "hour_settings.time_documents.enabled": "Tillat dokumentasjon (bilder/filer) via timeregistrering",

        "hour.time_documents.title": "Dokumentasjon",
        "hour.time_documents.subtitle": "Bilder og filer knyttet til denne timen.",
        "hour.time_documents.help_save_first": "Lagre timen før du kan legge ved filer.",
        "hour.time_documents.pending_hint":
          "Legg til filer her. De lastes opp automatisk med en gang du har lagret timen (du trenger ikke et ekstra opplastingssteg).",
        "hour.time_documents.pending_add": "Legg til filer",
        "hour.time_documents.pending_count": "{{count}} fil(er) står i kø for opplasting",
        "hour.time_documents.pending_remove": "Fjern",
        "hour.time_documents.pending_file_type_denied": "Denne filtypen er ikke tillatt.",
        "hour.time_documents.pending_upload_done": "Vedlegg er lastet opp",
        "hour.time_documents.pending_upload_failed":
          "Timen ble lagret, men opplasting av vedlegg feilet. Lukk og åpne timen på nytt for å prøve igjen.",
        "hour.time_documents.blocked_linked":
          "Dokumentasjon er ikke tilgjengelig når timen er knyttet til rapport eller arbeidsordre.",
        "hour.time_documents.blocked_lock": "Perioden er låst; vedlegg kan ikke endres.",

        "user_guide.hub.badge": "Brukerguide",
        "user_guide.hub.title": "Slik bruker du Promang",
        "user_guide.hub.subtitle":
          "Trinnvise guider for administratorer og ansatte. Innholdet oppdateres her i appen — teknisk utviklerdokumentasjon ligger utenfor denne visningen.",
        "user_guide.hub.card.hours.title": "Timer, fravær og arbeidsplan",
        "user_guide.hub.card.hours.description":
          "Oppstart for bedrifter: fraværstyper, ansvarlige, lønnslås, påminnelser og arbeidsplan.",
        "user_guide.hub.footer_note": "Mangler du svar? Prøv også ressurssenteret under FAQ.",

        "dashboard.company_guide.hours_teaser_title": "Timer og fravær",
        "dashboard.company_guide.hours_teaser_subtitle":
          "Oppstartsstatus og detaljert guide finner du på brukerguiden — ikke på forsiden.",
        "dashboard.company_guide.hours_teaser_cta": "Åpne status og guide",

        "user_guide.hours.back_to_hub": "Tilbake til brukerguiden",
        "user_guide.hours.checklist.badge": "Oppstart",
        "user_guide.hours.checklist.heading": "Status for oppsett (timer-modulen)",
        "user_guide.hours.checklist.subtitle":
          "Kun synlig for administratorer. Hvert punkt lenker til innstillinger eller mer forklaring lenger ned på siden.",
        "user_guide.hours.badge": "Timer og fravær",
        "user_guide.hours.title": "Timer, fravær og arbeidsplan",
        "user_guide.hours.purpose":
          "Denne guiden hjelper nye bedrifter og administratorer med å sette opp fravær, ansvarlige og arbeidsplan. Sjekklisten på dashbordet (kun admin) peker hit for detaljer.",

        "user_guide.hours.section.registration.title": "Timeregistrering i Promang",
        "user_guide.hours.section.registration.p1":
          "Timer på prosjekt skal knyttes til et prosjekt og en prosjektlinje (project activity). Det er dette som styrer timeregistrering i arbeidsflaten.",
        "user_guide.hours.section.registration.p2":
          "Eldre begreper Activity og ActivityItem brukes i bakgrunnen mot regnskapssystemer (for eksempel Tripletex-synk). De er ikke det du normalt velger når du fører timer i grensesnittet.",
        "user_guide.hours.section.registration.p3":
          "Lister over «generelle aktiviteter» under Timer → Innstillinger kan brukes til administrasjon, men er ikke et eget krav i oppstartsjekken på dashbordet.",

        "user_guide.hours.section.visibility.title": "Hvem ser hva?",
        "user_guide.hours.section.visibility.li1":
          "På forsiden vises bare en kort lenke for administratorer når Timer er aktiv. Full status og sjekkliste ligger her på brukerguiden.",
        "user_guide.hours.section.visibility.li2":
          "Alle som har tilgang til Timer → Innstillinger ser det korte hjelpekortet øverst på innstillingssiden.",

        "user_guide.hours.section.steps.title": "Anbefalt rekkefølge",
        "user_guide.hours.section.steps.s1.title": "1. Fraværstyper",
        "user_guide.hours.section.steps.s1.where": "Gå til Timer → Innstillinger → Fraværstyper.",
        "user_guide.hours.section.steps.s1.b1":
          "Opprett typer som passer bedriften: ferie, syk, egenmelding, avspasering, permisjon og lignende.",
        "user_guide.hours.section.steps.s1.b2":
          "Fravær registreres mot disse typene. Hvem som godkjenner egenmeldinger avhenger av roller og hvem dere setter som fraværsansvarlig.",

        "user_guide.hours.section.steps.s2.title": "2. Ansvar for timer og fravær",
        "user_guide.hours.section.steps.s2.where": "Gå til Timer → Innstillinger → Håndtering av timer og fravær.",
        "user_guide.hours.section.steps.s2.b1":
          "Timer: velg gjerne den som skal godkjenne timelister og følge opp avvik.",
        "user_guide.hours.section.steps.s2.b2":
          "Egenmelding / fravær: velg den som skal behandle egenmeldinger (ofte HR eller nærmeste leder).",
        "user_guide.hours.section.steps.s2.b3": "Begge bør settes tidlig, så ansatte vet hvem som følger opp.",

        "user_guide.hours.section.steps.s3.title": "3. Låsing av lønnsperiode (valgfritt)",
        "user_guide.hours.section.steps.s3.where": "Gå til Timer → Innstillinger → Låsing av lønnsperiode.",
        "user_guide.hours.section.steps.s3.b1":
          "Når rutinene er på plass kan dere låse måned ved periodeslutt og sette utbetalingsdato i tråd med lønn.",
        "user_guide.hours.section.steps.s3.b2":
          "Låste perioder begrenser endringer bakover i tid; unntak håndteres av dem som har rettigheter til opplåsing der det er aktivert.",

        "user_guide.hours.section.steps.s4.title": "4. Påminnelser om timer (valgfritt)",
        "user_guide.hours.section.steps.s4.where": "Gå til Timer → Innstillinger → Påminnelse om timer.",
        "user_guide.hours.section.steps.s4.b1": "Slå på daglig påminnelse og sett tidspunkter om dere vil minne folk på å føre timer.",
        "user_guide.hours.section.steps.s4.b2":
          "E-post som sendes ut må være satt opp i drift (planlagte jobber) — spør administrator eller leverandør om dette er aktivt.",

        "user_guide.hours.section.steps.s5.title": "5. Arbeidsplan og stillingsbrøk",
        "user_guide.hours.section.steps.s5.where": "Bruk Tidsplan og brukerprofiler under Brukere.",
        "user_guide.hours.section.steps.s5.b1":
          "Hver ansatt bør ha arbeidsplan som stemmer med stillingen — det påvirker forventet tid og planlegging.",
        "user_guide.hours.section.steps.s5.b2": "Kalender og oppfølging av fravær forutsetter at dette er på plass.",

        "user_guide.hours.section.related.title": "Nyttige snarveier",
        "user_guide.hours.section.related.link_hours": "Timeliste",
        "user_guide.hours.section.related.link_approval": "Timegodkjenning",
        "user_guide.hours.section.related.link_absence": "Fraværsoversikt",
        "user_guide.hours.section.related.link_monthly": "Månedsoversikt timer",
        "user_guide.hours.section.related.link_settings": "Innstillinger for timer",

        "user_guide.hours.section.more_help.title": "Mer hjelp",
        "user_guide.hours.section.more_help.p1":
          "Har du spørsmål som ikke står her, kan ressurssenteret (FAQ) eller kundestøtte hjelpe videre.",
        "user_guide.hours.section.more_help.faq_link": "Gå til FAQ i ressurssenteret",

        "Time Registration": "Timeregistrering",
        "Registered hours": "Registrerte timer",
        "Close": "Lukk",
        "Hours Overview": "Timer Oversikt",
        "Track and manage work hours": "Spor og administrer arbeidstimer",
        "Select Employee": "Velg Ansatt",
        "Set Date": "Sett dato",
        "Today": "Idag",
        "Calendar": "Kalender",
  
        // Work Statistics translations
        "Work Statistics": "Arbeidsstatistikk",
        "Overview of your work hours and performance":
          "Oversikt over dine arbeidstimer og ytelse",
        "Something went wrong while loading work stats":
          "Noe gikk galt ved lasting av arbeidsstatistikk",
        "Could not load work statistics": "Kunne ikke laste arbeidsstatistikk",
        "No data available": "Ingen data tilgjengelig",
        "No work statistics found for this user.":
          "Ingen arbeidsstatistikk funnet for denne brukeren.",
        "Expected This Week": "Forventet denne uken",
        "Worked This Week": "Arbeidet denne uken",
        "Worked This Month": "Arbeidet denne måneden",
        "Earned Time Off": "Opptjent fritid",
        "Weekly Progress": "Ukentlig fremgang",
        "Hours worked this week": "Timer arbeidet denne uken",
        "Remaining": "Gjenstående",
        "Overtime": "Overtid",
        "Weekly Goal": "Ukentlig mål",
        "Completed": "Fullført",
        "In Progress": "Under arbeid",
        "Status": "Status",
        "Under Target": "Under mål",
        "On Track": "På sporet",
        "Efficiency": "Effektivitet",
  
        // Vehicle translations
        "Vehicle handbook": "Kjøretøyhåndbok",
        "Check in to a vehicle to open its handbook from this menu.":
          "Sjekk inn på et kjøretøy for å åpne håndboken fra denne menyen.",
        "Vehicle handbook could not be opened. Try again or contact an administrator.":
          "Kunne ikke åpne kjøretøyhåndbok. Prøv igjen eller kontakt administrator.",
        "Go to trips": "Gå til turer",
        "Vehicle handbook entry subtitle":
          "Sjekk inn, så åpnes håndboken for kjøretøyet du er innlogget på.",
        "Vehicle handbook check in": "Sjekk inn på kjøretøy",
        "Vehicle handbook check in hint":
          "Velg et kjøretøy for innsjekk; du sendes deretter til håndboken.",
        "Vehicle handbook not a driver":
          "Du er ikke registrert som sjåfør i selskapet. Kontakt administrator hvis du trenger tilgang til kjøring.",
        "Vehicle handbook no vehicles permission":
          "Du trenger tilgang til kjøretøylisten for å sjekke inn her. Du kan fortsatt sjekke inn fra Turer eller dashbordet hvis det er tilgjengelig.",
        "Vehicle Information": "Fordoninformasjon",
        "Number Plate": "Registreringsnummer",
        "VIN (Chassis Number)": "VIN (Chassisnummer)",
        "Make": "Merke",
        "Model": "Modell",
        "Model Year": "Årsmodell",
        "Body Style": "Karosstype",
        "Nickname": "Kallenavn",
        "Current Odometer (km)": "Nåværende kilometerstand (km)",
        "Description": "Beskrivelse",
        "Statens Vegvesen Information": "Statens Vegvesen Informasjon",
        "Norwegian Vehicle Authority Information": "Norsk Vegvesen Informasjon",
        "Registration Date": "Registreringsdato",
        "First Registration": "Første registrering",
        "Vehicle Type": "Fordonstype",
        "Fuel Type": "Drivstofftype",
        "Engine Size (cc)": "Motoreffekt (cc)",
        "Power (kW)": "Effekt (kW)",
        "Inspection Information": "Besiktningsinformasjon",
        "EU-kontroll / Periodic Vehicle Inspection":
          "EU-kontroll / Periodisk fordonbesiktning",
        "Last Inspection Date": "Siste besiktningsdato",
        "Next Inspection Date": "Neste besiktningsdato",
        "Inspection Result": "Besiktningsresultat",
        "Inspection Station": "Besiktningsstasjon",
        "Insurance Information": "Forsikringsinformasjon",
        "Vehicle Insurance Details": "Fordonforsikring Detaljer",
        "Insurance Company": "Forsikringsselskap",
        "Policy Number": "Policenummer",
        "Insurance Start Date": "Forsikring startdato",
        "Insurance End Date": "Forsikring sluttdato",
        "Insurance Type": "Forsikringstype",
        "Annual Premium (NOK)": "Årlig premie (NOK)",
        "Service Information": "Serviceinformasjon",
        "Maintenance and Service Details": "Vedlikehold og Service Detaljer",
        "Last Service Date": "Siste servicedato",
        "Next Service Date": "Neste servicedato",
        "Service Interval (km)": "Serviceintervall (km)",
        "Service Provider": "Serviceleverandør",
        "Warranty End Date": "Garanti sluttdato",
        "Warranty Type": "Garantitype",
        "Damage Reports": "Skaderapporter",
        "Vehicle Damage History": "Fordon Skadehistorikk",
        "Damage reports will be implemented in the future":
          "Skaderapporter vil bli implementert i fremtiden",
        "Internal Controls": "Interne kontroller",
        "Company Internal Vehicle Controls":
          "Bedriftens Interne Fordonskontroller",
        "Last Internal Check": "Siste interne kontroll",
        "Next Internal Check": "Neste interne kontroll",
        "Safety Equipment Status": "Sikkerhetsutstyr Status",
        "Vehicle Status": "Fordonstatus",
        "Trips": "Turer",
        "Service": "Service",
        "Documents": "Dokumenter",
        "Vehicle": "Fordon",
        "Vehicle Documents": "Fordon Dokumenter",
        "Manage vehicle documents and files":
          "Administrer fordon dokumenter og filer",
        "Vehicle Trips": "Fordon Turer",
        "trips found": "turer funnet",
        "No trips found for this vehicle":
          "Ingen turer funnet for dette fordonet",
        "Vehicle safety and maintenance checklists":
          "Fordon sikkerhet og vedlikehold sjekklister",
        "Create Checklist": "Opprett sjekkliste",
        "Last Internal Control": "Siste interne kontroll",
        "Checklist Number": "Sjekkliste nummer",
        "Items Approved": "Godkjente punkter",
        "Checklist Items": "Sjekkliste punkter",
        "Approved": "Godkjent",
        "Not Approved": "Ikke godkjent",
        "No checklists found": "Ingen sjekklister funnet",
        "Get started by creating a new checklist":
          "Start med å opprette en ny sjekkliste",
        "Select Checklist Type": "Velg sjekkliste type",
        "Choose the type of checklist you want to create for this vehicle":
          "Velg type sjekkliste du vil opprette for dette fordonet",
        "Create a new checklist for this project":
          "Opprett en ny sjekkliste for dette prosjektet",
        "Choose the type of checklist you want to create for this project":
          "Velg type sjekkliste du vil opprette for dette prosjektet",
        "Project checklist title": "Prosjektsjekkliste #{{number}}{{suffix}}",
        "Customer checklist title": "Kundesjekkliste #{{number}}{{suffix}}",
        "Folder checklist title": "Mappe-sjekkliste #{{number}}{{suffix}}",
        "Generic new checklist title": "Sjekkliste #{{number}} ({{date}})",
        "Report checklist default title": "Rapport {{number}} - {{address}}",
        "Choose the type of checklist you want to create for this report":
          "Velg type sjekkliste du vil opprette for denne rapporten",
        "Choose the type of checklist you want to create for this folder":
          "Velg type sjekkliste du vil opprette for denne mappen",
        "Choose the type of checklist you want to create for this customer":
          "Velg type sjekkliste du vil opprette for denne kunden",
        "Choose the type of checklist you want to create":
          "Velg type sjekkliste du vil opprette",
        "Checklist title placeholder": "Skriv inn tittel for sjekklisten",
        "Checklist title edit hint":
          "Foreslått automatisk — du kan endre tittelen før du velger type.",
        "Title": "Tittel",
        "Enter checklist title": "Skriv inn sjekkliste tittel",
        "No checklist types available": "Ingen sjekkliste typer tilgjengelig",
        "items": "punkter",
  
        // Journal translations
        "journal": "Journal",
        "journal.title": "Journal Tittel",
        "journal.description": "Journal Beskrivelse",
        "journal.date": "Journal Dato",
        "journal.next_follow_up": "Neste Oppfølgingsdato",
        "journal.status": "Journal Status",
        "journal.create": "Opprett Journal Oppføring",
        "journal.update": "Oppdater Journal Oppføring",
        "journal.delete": "Slett Journal Oppføring",
        "journal.entries": "Journal Oppføringer",
        "journal.no_entries": "Ingen journal oppføringer funnet",
        "journal.add_entry": "Legg til Journal Oppføring",
        "journal.edit_entry": "Rediger Journal Oppføring",
        "journal.entry_created": "Journal oppføring opprettet",
        "journal.entry_updated": "Journal oppføring oppdatert",
        "journal.entry_deleted": "Journal oppføring slettet",
        "journal.follow_up_reminder": "Oppfølgingspåminnelse",
        "journal.service_documentation": "Service Dokumentasjon",
        "journal.calibration_record": "Kalibreringsjournal",
        "journal.repair_record": "Reparasjonsjournal",
        "journal.maintenance_record": "Vedlikeholdsjournal",
  
        // Tool translations
        "tool": "Verktøy",
        "tools": "Verktøy",
        "tool.title": "Verktøy Tittel",
        "tool.number": "Verktøy Nummer",
        "tool.description": "Verktøy Beskrivelse",
        "tool.status": "Verktøy Status",
        "tool.category": "Verktøy Kategori",
        "tool.brand": "Verktøy Merke",
        "tool.model": "Verktøy Modell",
        "tool.serial_number": "Serienummer",
        "tool.purchase_date": "Kjøpsdato",
        "tool.purchase_price": "Kjøpspris",
        "tool.supplier.label": "Kjøpt fra (leverandør)",
        "tool.supplier.placeholder": "Velg leverandør",
        "tool.supplier.select_one": "Velg leverandør",
        "tool.supplier.select_multiple": "Velg leverandører",
        "tool.supplier.search_placeholder": "Søk etter leverandører…",
        "tool.supplier.empty": "Ingen leverandører funnet. Prøv et annet søk.",
        "tool.supplier.load_more": "Last flere",
        "tool.supplier.clear": "Fjern valg",
        "tool.supplier.load_error": "Kunne ikke laste leverandører",
        "tool.supplier.selected_count": "{{count}} valgt",
        "tool.service_interval": "Service Intervall (dager)",
        "tool.last_service": "Siste Service",
        "tool.next_service": "Neste Service",
        "tool.service_overdue": "Service Forfalt",
        "tool.service_due_soon": "Service Snart Forfaller",
        "tool.create": "Opprett Verktøy",
        "tool.update": "Oppdater Verktøy",
        "tool.delete": "Slett Verktøy",
        "tool.overview": "Verktøy Oversikt",
        "tool.manage_tools": "Administrer Verktøy",
        "tool.no_tools": "Ingen verktøy funnet",
        "tool.add_tool": "Legg til Verktøy",
        "tool.edit_tool": "Rediger Verktøy",
        "tool.tool_created": "Verktøy opprettet",
        "tool.tool_updated": "Verktøy oppdatert",
        "tool.tool_deleted": "Verktøy slettet",
        "tool.service_overview": "Service Oversikt",
        "tool.upcoming_services": "Kommende Service",
        "tool.overdue_services": "Forfalte Service",
        "tool.total_tools": "Totalt Verktøy",
        "tool.active_tools": "Aktive Verktøy",
        "tool.quick_row_label": "—",
        "tool.quick_new": "Ny",
        "tool.quick_add_placeholder": "Tittel — trykk Tab eller Enter for å lagre",
        "tool.next_number_hint_title": "Foreslått neste verktøynummer",
        "tool.quick_add_tab_hint": "Tab / Enter",
        "tool.active_column": "Aktiv",
        "tool.assign_short": "Tildel",
        "tool.duplicate": "Kopier",
        "tool.duplicate_created": "Verktøy kopiert",
        "tool.number_auto_placeholder": "Neste: {{next}} (tom = auto)",
  
        // Tool Category translations
        "tool.categories": "Verktøy Kategorier",
        "tool.category.name": "Kategori Navn",
        "tool.category.description": "Kategori Beskrivelse",
        "tool.category.create": "Opprett Verktøy Kategori",
        "tool.category.update": "Oppdater Verktøy Kategori",
        "tool.category.delete": "Slett Verktøy Kategori",
        "tool.category.no_categories": "Ingen verktøy kategorier funnet",
        "tool.category.add_category": "Legg til Verktøy Kategori",
        "tool.category.edit_category": "Rediger Verktøy Kategori",
        "tool.category.created": "Verktøy kategori opprettet",
        "tool.category.updated": "Verktøy kategori oppdatert",
        "tool.category.deleted": "Verktøy kategori slettet",
        "tool.category.manage_title": "Verktøykategorier",
        "tool.category.all_categories": "Alle kategorier",
        "tool.category.new_category": "Ny",
        "tool.category.delete_confirm": "Slette denne kategorien?",
        "tool.category.delete_confirm_with_tools":
          "Kategorien er knyttet til {{count}} verktøy. Slette likevel?",
        "tool.category.delete_failed": "Kunne ikke slette kategorien",
        "tool.category.tools_count": "{{count}} verktøy",
  
        // Tool Brand translations
        "tool.brands": "Verktøy Merker",
        "tool.brand.name": "Merke Navn",
        "tool.brand.description": "Merke Beskrivelse",
        "tool.brand.create": "Opprett Verktøy Merke",
        "tool.brand.update": "Oppdater Verktøy Merke",
        "tool.brand.delete": "Slett Verktøy Merke",
        "tool.brand.no_brands": "Ingen verktøy merker funnet",
        "tool.brand.add_brand": "Legg til Verktøy Merke",
        "tool.brand.edit_brand": "Rediger Verktøy Merke",
        "tool.brand.created": "Verktøy merke opprettet",
        "tool.brand.updated": "Verktøy merke oppdatert",
        "tool.brand.deleted": "Verktøy merke slettet",
        "tool.brand.manage_title": "Verktøymerker",
        "tool.brand.all_brands": "Alle merker",
        "tool.brand.new_brand": "Nytt",
        "tool.brand.delete_confirm": "Slette dette merket?",
        "tool.brand.delete_confirm_with_tools":
          "Merke er knyttet til {{count}} verktøy. Slette likevel?",
        "tool.brand.delete_failed": "Kunne ikke slette merket",
        "tool.brand.tools_count": "{{count}} verktøy",
        "tool.open": "Åpne",
        "tool.back_to_overview": "Tilbake til verktøy",
        "tool.assigned_user_column": "Tildelt",
        "tool.assignment_heading": "Tildeling",
        "tool.assignment_hint":
          "Knytt verktøyet til en ansatt, eller fjern tildeling (retur til lager).",
        "tool.assigned_to": "Tildelt",
        "tool.not_assigned": "Ikke tildelt",
        "tool.assign_user": "Tildel bruker",
        "tool.reassign_user": "Bytt bruker",
        "tool.return_from_user": "Fjern tildeling (retur)",
        "tool.assign_saved": "Tildeling oppdatert",
        "tool.return_saved": "Verktøy returnert",
        "tool.notes_heading": "Verktøynotater",
        "tool.notes_hint":
          "Interne notater om verktøyet (vises ikke som journal/service).",
        "tool.notes_placeholder": "Skriv notater…",
        "tool.save_notes": "Lagre notater",
        "tool.notes_saved": "Notater lagret",
        "tool.completed_service_intervals": "Utførte serviceintervaller",
        "tool.completed_service_intervals_hint":
          "Journalposter med status fullført og «service» i tittel (samme regel som neste service).",
        "tool.no_completed_service_intervals":
          "Ingen utførte serviceintervaller er registrert ennå.",
        "tool.journal_other_hint":
          "Andre journalposter (aktive, oppfølging, ikke-service osv.).",
        "tool.journal_empty_hint": "Opprett en journalpost for service eller notater.",
        "tool.journal_no_other_entries": "Ingen andre journalposter.",
        "tool.print_label": "Skriv ut skilt / etikett",
        "tool.usage_history_heading": "Brukshistorikk (tildeling)",
        "tool.usage_history_hint":
          "Hvem som har hatt verktøyet, hvor mange dager (kalenderdager, inkludert første og siste dag), og om perioden ble avsluttet med retur eller overlevering til ny bruker.",
        "tool.usage_history_empty":
          "Ingen historikk ennå. Historikk registreres når du tildeler, bytter bruker eller returnerer verktøyet.",
        "tool.usage_user": "Bruker",
        "tool.usage_from": "Fra",
        "tool.usage_to": "Til",
        "tool.usage_days": "Dager",
        "tool.usage_outcome": "Avslutning",
        "tool.usage_status": "Status",
        "tool.usage_status_active": "Aktiv utlån",
        "tool.usage_status_ended": "Avsluttet",
        "tool.usage_reason.return": "Returnert (ikke tildelt)",
        "tool.usage_reason.reassign": "Byttet til annen bruker",
        "tool.employee_tools_title": "Verktøy",
        "tool.employee_tools_intro_title": "Dine tildelte verktøy",
        "tool.employee_tools_intro":
          "En enkel oversikt over verktøy som er registrert på deg, med tildelingsdato og nøkkelinformasjon.",
        "tool.employee_tools_short": "Dine tildelte verktøy.",
        "tool.employee_tools_loading": "Laster verktøy...",
        "tool.employee_tools_load_error": "Kunne ikke laste verktøy.",
        "tool.employee_tools_empty_title": "Ingen verktøy tildelt",
        "tool.employee_tools_empty": "Det er ikke registrert noen verktøy på deg.",
        "tool.employee_tools_assigned_on": "Tatt i bruk",
        "tool.employee_tools_unknown_date": "Ukjent dato",
        "tool.employee_tools_no_service": "Ingen planlagt service",
        "tool.employee_tools_days_held": "{{count}} dager i bruk",
  
        // Tool Status translations
        "tool.status.active": "Aktiv",
        "tool.status.inactive": "Inaktiv",
        "tool.status.maintenance": "Under Vedlikehold",
        "tool.status.retired": "Pensjonert",
  
        // Journal Status translations
        "journal.status.active": "Aktiv",
        "journal.status.completed": "Fullført",
        "journal.status.archived": "Arkivert",
  
        // Personalhåndbok translations
        "Personalhåndbok": "Personalhåndbok",
        "personalhåndbok.description":
          "Tilgang til bedriftens retningslinjer, sikkerhetsprosedyrer og ansattinformasjon",
        "Open": "Åpne",
        "HMS Guidelines": "Rutiner",
        "Safety procedures and guidelines": "Sikkerhetsprosedyrer og rutiner",
        "Instructions": "Retningslinjer",
        "Company policies and procedures":
          "Bedriftens retningslinjer og prosedyrer",
        "Instruction Chapters": "Retningslinjer - Kapitler",
        "Chapter": "Kapittel",
        "Create Chapter": "Opprett kapittel",
        "Update Chapter": "Oppdater kapittel",
        "Chapter Number": "Kapittel nummer",
        "Parent Chapter": "Overordnet kapittel",
        "Sub Chapters": "Underkapitler",
        "No chapter number": "Ingen kapittel nummer",
        "Colleagues": "Kollegaer",
        "Team overview and contacts": "Team oversikt og kontakter",
        "Overview": "Oversikt",
        "Recent HMS Guidelines": "Siste rutiner",
        "Recent Instructions": "Siste retningslinjer",
        "Recent KS/HMS Documents": "Siste KS/HMS dokumenter",
        "KS/HMS Documents": "KS/HMS Dokumenter",
        "employee_handbook.pending_read_ack_title":
          "KS/HMS: dokumenter som mangler bekreftelse",
        "employee_handbook.pending_read_ack_body":
          "Du har {count} dokument(er) som ikke er bekreftet som lest og forstått. Åpne hvert dokument og bekreft, eller gå til full visning under HMS/KS.",
        "employee_handbook.all_documents_acknowledged":
          "Du har bekreftet alle KS/HMS-dokumentene du har tilgang til (lest og forstått).",
        "employee_handbook.read_status_acknowledged": "Lest og bekreftet",
        "employee_handbook.read_status_pending": "Mangler bekreftelse",
        "employee_handbook.read_status_creator_exempt": "Forfatter (ikke pliktig)",
        "employee_handbook.go_to_documents_tab": "Gå til KS/HMS-dokumenter",
        "employee_handbook.open_full_document": "Åpne full side (HMS/KS)",
        "dashboard_report.handbook_read_incomplete":
          "{pending} av {total} KS/HMS-dokumenter mangler bekreftelse som lest/forstått.",
        "employee_handbook.stat_line_pending":
          "{count} dokument(er) mangler bekreftelse som lest og forstått.",
        "Kapitler": "Kapitler",
        "Dokumenter uten kapittel": "Dokumenter uten kapittel",
        "Dokumenter som ikke er tilknyttet noe kapittel": "Dokumenter som ikke er tilknyttet noe kapittel",
        "Søk etter dokumenter...": "Søk etter dokumenter...",
        "Fant {count} dokumenter": "Fant {count} dokumenter",
        "Ingen dokumenter funnet": "Ingen dokumenter funnet",
        "Prøv å endre søkeordene dine": "Prøv å endre søkeordene dine",
        "Laster dokument...": "Laster dokument...",
        "Ingen innhold tilgjengelig": "Ingen innhold tilgjengelig",
        "Dokumenter uten bransje": "Dokumenter uten bransje",
        "Dokumenter uten kategori": "Dokumenter uten kategori",
        "Dokumenter uten bransje og kategori": "Dokumenter uten bransje og kategori",
        "No chapter": "Ingen kapitel",
        "Employee Handbook": "Personalhåndbok",
  
        // Deviation Template translations
        "deviation.template": "Avvik mal",
        "deviation.template.select": "Velg mal",
        "deviation.template.select.description":
          "Velg en mal for å gjøre det enklere å registrere avviket",
        "deviation.template.standard": "Standard avvik",
        "deviation.template.standard.description": "Vanlig avviksregistrering",
        "deviation.form.type_category_hint":
          "Velg kategorien som best beskriver dette avviket.",
        "deviation.form.search_types": "Søk i avvikstyper…",
        "deviation.form.no_matching_types": "Ingen treff i avvikstyper",
        "deviation.template.incident_injury": "Uønsket hendelse - Skade",
        "deviation.template.incident_injury.description":
          "Strukturert skjema for registrering av uønsket hendelse med skade",
        "deviation.template.back": "← Tilbake til maler",
  
        // Event description translations
        "deviation.event.description": "Hendelsesbeskrivelse",
        "deviation.event.description.title": "Hendelsesbeskrivelse",
        "deviation.event.description.subtitle": "Beskriv hendelsen som skjedde",
        "deviation.event.date": "Dato for hendelse",
        "deviation.event.time": "Tidspunkt",
        "deviation.event.description.field": "Beskrivelse av hendelsen",
        "deviation.event.description.placeholder":
          "Beskriv detaljert hva som skjedde...",
        "deviation.event.involved_persons": "Involverte personer",
        "deviation.event.witnesses": "Vitner",
  
        // Location translations
        "deviation.location": "Hvor skjedde hendelsen",
        "deviation.location.title": "Hvor skjedde hendelsen",
        "deviation.location.subtitle": "Angi sted og avdeling",
        "deviation.location.place": "Sted",
        "deviation.location.department": "Avdeling",
        "deviation.location.building": "Bygg/Område",
        "deviation.location.room_area": "Rom/Område",
        "deviation.location.details": "Mer detaljert beskrivelse av stedet",
        "deviation.location.details.placeholder":
          "Beskriv stedet mer detaljert...",
  
        // Categorization translations
        "deviation.categorization": "Kategorisering",
        "deviation.categorization.title": "Kategorisering av hendelsen",
        "deviation.categorization.subtitle":
          "Kategoriser hendelsen for å gjøre det enklere å analysere og følge opp",
        "deviation.categorization.category": "Kategori",
        "deviation.categorization.severity": "Alvorlighetsgrad",
        "deviation.categorization.immediate_cause": "Umiddelbar årsak",
        "deviation.categorization.underlying_cause": "Underliggende årsak",
        "deviation.categorization.details": "Mer detaljert kategorisering",
        "deviation.categorization.details.placeholder":
          "Beskriv kategoriseringen mer detaljert...",
  
        // Event categories
        "deviation.category.law_violation": "Avvik lov",
        "deviation.category.regulation_violation": "Avvik forskrift",
        "deviation.category.procedure_violation": "Brudd på rutine",
        "deviation.category.process_violation": "Brudd på prosedyre",
        "deviation.category.training_violation": "Brudd på opplæring",
        "deviation.category.information": "Informasjon",
        "deviation.category.other": "Annet",
  
        // Treatment translations
        "deviation.treatment": "Behandling",
        "deviation.treatment.title": "Behandling av hendelsen",
        "deviation.treatment.subtitle":
          "Vurder om årsakanalyse og strakstiltak er nødvendig",
        "deviation.treatment.root_cause_analysis": "Årsakanalyse",
        "deviation.treatment.immediate_actions": "Strakstiltak",
        "deviation.treatment.root_cause_analysis.details": "Årsakanalyse",
        "deviation.treatment.root_cause_analysis.placeholder":
          "Beskriv årsakanalysen...",
        "deviation.treatment.immediate_actions.details": "Strakstiltak",
        "deviation.treatment.immediate_actions.placeholder":
          "Beskriv strakstiltakene...",
        "deviation.treatment.suggested_actions": "Forslag til tiltak",
        "deviation.treatment.suggested_actions.placeholder":
          "Beskriv forslag til tiltak...",
  
        // Action translations
        "deviation.action": "Tiltak",
        "deviation.action.title": "Opprett tiltak",
        "deviation.action.subtitle":
          "Opprett og planlegg konkrete tiltak basert på analysen",
        "deviation.action.title.field": "Tiltak tittel",
        "deviation.action.deadline": "Frist",
        "deviation.action.responsible": "Ansvarlig person",
        "deviation.action.department": "Avdeling",
        "deviation.action.location": "Sted",
        "deviation.action.category": "Kategori",
        "deviation.action.description": "Beskrivelse av tiltak",
        "deviation.action.description.placeholder":
          "Beskriv tiltaket detaljert...",
        "deviation.action.health_service_cooperation":
          "Samarbeid med bedrifthelsetjenesten",
        "deviation.action.cost": "Kostnad (NOK)",
        "deviation.action.documents": "Dokumenter",
        "deviation.action.related_elements": "Tilknyttede elementer",
  
        // Action categories
        "deviation.action.category.safety": "Sikkerhet",
        "deviation.action.category.quality": "Kvalitet",
        "deviation.action.category.environment": "Miljø",
        "deviation.action.category.procedure": "Prosedyre",
        "deviation.action.category.training": "Opplæring",
        "deviation.action.category.maintenance": "Vedlikehold",
        "deviation.action.category.equipment": "Utstyr",
        "deviation.action.category.communication": "Kommunikasjon",
        "deviation.action.category.other": "Annet",
  
        // Action statuses
        "deviation.action.status.planned": "Planlagt",
        "deviation.action.status.started": "Påbegynt",
        "deviation.action.status.in_progress": "Under arbeid",
        "deviation.action.status.completed": "Fullført",
        "deviation.action.status.cancelled": "Kansellert",
        "deviation.action.status.on_hold": "På vent",
  
        // Action priorities
        "deviation.action.priority.low": "Lav",
        "deviation.action.priority.medium": "Medium",
        "deviation.action.priority.high": "Høy",
        "deviation.action.priority.critical": "Kritisk",
  
        // Form validation messages
        "deviation.event.description.required": "Hendelsesbeskrivelse er påkrevd",
        "deviation.location.required": "Sted er påkrevd",
        "deviation.category.required": "Kategori er påkrevd",
        "deviation.action.title.required": "Tiltak tittel er påkrevd",
        "deviation.action.description.required": "Beskrivelse er påkrevd",
        "deviation.action.category.required": "Kategori er påkrevd",
        "deviation.action.deadline.required": "Frist er påkrevd",
        "deviation.action.responsible.required": "Ansvarlig person er påkrevd",
  
        // Success/Error messages
        "deviation.template.saved": "Data ble lagret!",
        "deviation.action.created": "Tiltak ble opprettet!",
        "deviation.template.save_error": "Noe gikk galt. Kunne ikke lagre data!",
        "deviation.action.create_error":
          "Noe gikk galt. Kunne ikke opprette tiltak!",
  
        // Navigation
        "deviation.previous": "Forrige",
        "deviation.next": "Neste",
        "deviation.complete": "Fullfør",
        "deviation.reset": "Nullstill",
        "deviation.create_action": "Opprett tiltak",
        "deviation.saving": "Lagrer...",
  
        // Action creation dialog
        "deviation.action.create.question": "Ønsker du å opprette tiltak?",
        "deviation.action.create.description":
          "Du kan opprette konkrete tiltak med frist, ansvarlig person og beskrivelse.",
        "deviation.action.create.yes": "Ja, opprett tiltak",
        "deviation.action.create.no": "Nei, ikke nå",
        "deviation.action.notes": "Notater om tiltak (valgfritt)",
        "deviation.action.notes.placeholder":
          "Legg til notater om tiltak hvis nødvendig...",
  
        // Chemical Inventory (Stoffkartotek) translations
        "chemical.inventory": "Stoffkartotek",
        "chemical.inventory.description":
          "Administrer kjemiske stoffer og sikkerhetsdatablader",
        "chemical.inventory.new": "Nytt stoff",
        "chemical.inventory.edit": "Rediger stoff",
        "chemical.inventory.delete": "Slett stoff",
        "chemical.inventory.create": "Opprett stoffkartotek",
        "chemical.inventory.update": "Oppdater stoffkartotek",
        "chemical.inventory.search": "Søk i stoffkartotek...",
        "chemical.inventory.no_results": "Ingen stoffer funnet",
        "chemical.inventory.add_from_product": "Legg til fra produkt",
        "chemical.inventory.basic_info": "Grunnleggende informasjon",
        "chemical.inventory.safety_info": "Sikkerhetsinformasjon",
        "chemical.inventory.supplier_info": "Leverandørinformasjon",
        "chemical.inventory.risk_assessment": "Risikovurdering",
        "chemical.inventory.documents": "Dokumenter",
        "chemical.inventory.notes": "Notater",
        "chemical.inventory.history": "Historikk",
        "chemical.inventory.safety_sheet": "Verneblad",
        "chemical.inventory.hazard_symbols": "Faresymboler",
        "chemical.inventory.hms_level": "HMS-nivå",
        "chemical.inventory.cas_number": "CAS-nummer",
        "chemical.inventory.chemical_formula": "Kjemisk formel",
        "chemical.inventory.molecular_weight": "Molekylvekt",
        "chemical.inventory.purity": "Renhet",
        "chemical.inventory.physical_state": "Fysisk tilstand",
        "chemical.inventory.color": "Farge",
        "chemical.inventory.odor": "Lukt",
        "chemical.inventory.hazard_statements": "Farepåstander",
        "chemical.inventory.precautionary_statements": "Advarselspåstander",
        "chemical.inventory.signal_word": "Signalord",
        "chemical.inventory.hazard_classification": "Fareklassifisering",
        "chemical.inventory.general_use": "Generell bruk",
        "chemical.inventory.fire_measures": "Brannslokkingstiltak",
        "chemical.inventory.spill_measures": "Tiltak ved utslipp",
        "chemical.inventory.first_aid": "Førstehjelp",
        "chemical.inventory.storage_conditions": "Lagringsforhold",
        "chemical.inventory.personal_protection": "Personlig verneutstyr",
        "chemical.inventory.exposure_limits": "Eksponeringsgrenser",
        "chemical.inventory.stability_reactivity": "Stabilitet og reaktivitet",
        "chemical.inventory.toxicological_info": "Toksikologisk informasjon",
        "chemical.inventory.ecological_info": "Økologisk informasjon",
        "chemical.inventory.disposal_considerations": "Avfallshåndtering",
        "chemical.inventory.transport_info": "Transportinformasjon",
        "chemical.inventory.supplier_name": "Leverandørnavn",
        "chemical.inventory.supplier_address": "Leverandøradresse",
        "chemical.inventory.supplier_country": "Leverandørland",
        "chemical.inventory.supplier_phone": "Leverandørtelefon",
        "chemical.inventory.emergency_phone": "Nødtelefon",
        "chemical.inventory.supplier_email": "Leverandør e-post",
        "chemical.inventory.general_use_risk": "Risikovurdering - generell bruk",
        "chemical.inventory.per_operation_risk":
          "Risikovurdering - per arbeidsoperasjon",
        "chemical.inventory.risk_assessment_documents":
          "Dokumenter til risikovurdering",
        "chemical.inventory.location_specific_risk":
          "Lokasjonspesifikk risikovurdering",
        "chemical.inventory.storage_location": "Lagringsplass",
        "chemical.inventory.usage_instructions": "Bruksanvisning",
        "chemical.inventory.version": "Versjon",
        "chemical.inventory.status": "Status",
        "chemical.inventory.last_review_date": "Siste gjennomgangsdato",
        "chemical.inventory.next_review_date": "Neste gjennomgangsdato",
        "chemical.inventory.notes_field": "Notater",
        "chemical.inventory.safety_instructions": "Sikkerhetsinstruksjoner",
        "chemical.inventory.verneblad": "Verneblad",
        "chemical.inventory.verneblad.description":
          "Lag enkle instruksjoner for dine ansatte om produktets farer, førstehjelp og brannslokkingstiltak. Heng det opp i nærheten av lagringsplassen.",
        "chemical.inventory.verneblad.danger_info": "Informasjon om fare",
        "chemical.inventory.verneblad.location_risk":
          "Lokasjonspesifikk risikovudering",
        "chemical.inventory.verneblad.location": "Lokasjon",
        "chemical.inventory.verneblad.files_documents": "Filer og dokumenter",
        "chemical.inventory.verneblad.comments": "Kommentarer",
        "chemical.inventory.verneblad.log_history": "Logg og historikk",
        "chemical.inventory.verneblad.remove_product":
          "Kunne fjerne 'produktet' fra stoffkartoteket",
        "chemical.inventory.verneblad.full_risk_assessment":
          "Full risikovurdering av produktet",
        "chemical.inventory.verneblad.general_use": "Generell bruk",
        "chemical.inventory.verneblad.per_operation": "Bruk per arbeidsoperasjon",
        "chemical.inventory.verneblad.risk_documents":
          "Dokumenter til risikovurdering",
        "Nytt system": "Nytt system",
        // Events sidebar and scheduling
        "Events": "Hendelser",
        "Your schedule for the selected day": "Din plan for valgt dag",
        "Loading events...": "Laster hendelser...",
        "No events to show": "Ingen hendelser å vise",
        "Event": "Hendelse",
        "Conflict": "Konflikt",
        "item_list_handling.pick_progress_short": "{{picked}}/{{total}} plukket",
        "item_list_handling.pick_progress_tooltip": "Varehåndtering: {{picked}} av {{total}} linjer plukket. Listestatus: {{status}}.",
        "Planned time": "Planlagt tid",
        "Start": "Start",
        "End": "Slutt",
        "Location": "Sted",
        "Assumed 60 min duration for conflict check": "Antatt varighet 60 min for konfliktkontroll",
        "Executing Employee": "Utførende",
        "Agreement date": "Avtaledato",
        "Fixed time": "Fast tidspunkt",
        "Timeframe from": "Tidsrom fra",
        "Timeframe to": "Tidsrom til",
        "Appointment confirmation required": "Bekreftelse på avtale påkrevd",
        "Send email to customer": "Send e-post til kunde",
        "Phone number": "Telefonnummer",
        "Email address": "E-postadresse",
        "Manually confirm agreement": "Bekreft avtale manuelt",
        "Send confirmation reminder": "Send påminnelse om bekreftelse",
  
        // Customer Handler translations
        "customer.handler": "Kundebehandleren",
        "customer.handler.description": "Søk etter kunder, opprett samtaler og administrer kundekommunikasjon",
        "customer.handler.selected.section": "Valgt kunde",
        "customer.handler.related.information": "Relatert informasjon",
        "customer.handler.open.customer.profile": "Åpne kundeprofil",
        "customer.handler.open.customer.profile.hint": "Åpner kundeprofilen i ny fane",
        "customer.handler.no.contact.info": "Ingen adresse, e-post eller mobil registrert",
        "customer.handler.edit.customer": "Rediger kunde",
        "customer.handler.edit.communication": "Rediger",
        "customer.handler.communication.subject": "Emne",
        "customer.handler.communication.body": "Innhold",
        "customer.handler.communication.update.success": "Kommunikasjon oppdatert",
        "search.customer": "Søk kunde",
        "search.by.mobile.or.address": "Søk etter mobilnummer eller adresse",
        "search.by.mobile.or.address.hint": "Skriv inn mobilnummer eller adresse for å søke",
        "searching": "Søker...",
        "search": "Søk",
        "search.results": "Søkeresultater",
        "search.failed": "Søket feilet",
        "search.failed.server.error": "Serverfeil oppstod",
        "search.failed.server.error.message": "En feil oppstod under søket. Vennligst prøv igjen. Ikke opprett ny kunde hvis du tror kunden allerede eksisterer.",
        "search.failed.unexpected.response": "Uventet respons fra server",
        "search.error.title": "Søkefeil",
        "search.error.hint": "Vennligst prøv å søke igjen. Hvis problemet vedvarer, kontakt support. Ikke opprett duplikat kunde.",
        "create.conversation": "Opprett samtale",
        "name.or.mobile.required": "Navn eller mobilnummer er påkrevd",
        "unknown.customer": "Ukjent kunde",
        "conversation.saved": "Samtale lagret",
        "conversation.saved.and.handled": "Samtale lagret og behandlet",
        "failed.to.create.customer": "Kunne ikke opprette kunde",
        "communication.added": "Kommunikasjon lagt til",
        "failed.to.add.communication": "Kunne ikke legge til kommunikasjon",
        "communication.marked.processed": "Kommunikasjon markert som behandlet",
        "communication.marked.unprocessed": "Kommunikasjon markert som ubehandlet",
        "failed.to.update.communication": "Kunne ikke oppdatere kommunikasjon",
        "no.communications.selected": "Ingen kommunikasjoner valgt",
        "communications.linked.to.case": "Kommunikasjoner knyttet til sak",
        "failed.to.link.communications": "Kunne ikke knytte kommunikasjoner",
        "selected.communications": "Valgte kommunikasjoner",
        "link.to.case": "Knytt til sak",
        "see.more": "Se mer",
        "mark.as.processed": "Merk som behandlet",
        "channel": "Kanal",
        "direction": "Retning",
        "sent.at": "Sendt",
        "start.time": "Starttid",
        "end.time": "Sluttid",
        "related": "Relatert",
        "processed": "Behandlet",
        "unprocessed": "Ubehandlet",
        "created.by": "Opprettet av",
        "street.address": "Gateadresse",
        "postal.code": "Postnummer",
        "city": "By",
        "conversation.date": "Samtaledato",
        "conversation.time": "Samtaletid",
        "conversation.note.placeholder": "Legg til notat om samtalen...",
        "save": "Lagre",
        "handle": "Behandle",
        "selected.customer": "Valgt kunde",
        "loading": "Laster...",
        "loading.customer": "Laster kunde...",
        "communications": "Kommunikasjoner",
        "inbound": "Innkommende",
        "outbound": "Utgående",
        "no.communications": "Ingen kommunikasjoner funnet",
        "no.cases": "Ingen saker funnet",
        "upcoming.events": "Kommende hendelser",
        "no.events": "Ingen hendelser funnet",
        "add.communication": "Legg til kommunikasjon",
        "pending": "Venter",
        "handled": "Behandlet",
        "Communication": "Kommunikasjon",
        "Message": "Melding",
        "Channel": "Kanal",
        "Direction": "Retning",
        "Customer": "Kunde",
        "link.to.case.choice.description": "Ønsker du å knytte til en eksisterende sak eller opprette en ny?",
        "link.to.existing.case": "Knytt til eksisterende sak",
        "link.to.existing.case.description": "Søk og velg en eksisterende sak",
        "create.new.case": "Opprett ny sak",
        "create.new.case.description": "Opprett en ny sak og knytt kommunikasjoner",
        "search.case": "Søk sak",
        "search.case.placeholder": "Søk etter saksnummer, tittel eller kunde...",
        "no.cases.found": "Ingen saker funnet",
        "cases": "Saker",
        "customer.cases": "Kundens saker",
        "linking.communications": "Knytter kommunikasjoner...",
        "treatment.section": "Behandlingsseksjon",
        "treatment.section.description": "Alle kommunikasjoner som krever behandling",
        "search.communications": "Søk kommunikasjoner...",
        "all.statuses": "Alle statuser",
        "all.channels": "Alle kanaler",
        "phone": "Telefon",
        "email": "E-post",
        "sms": "SMS",
        "showing": "Viser",
        "of": "av",
        "customer.loaded": "Kunde lastet inn",
        "customer.not.found": "Kunde ikke funnet",
        "failed.to.load.communications": "Kunne ikke laste kommunikasjoner",
        "failed.to.load.customer": "Kunne ikke laste kunde",
  
        // Inventory Count translations (Norwegian)
        "inventory.counts.title": "Lageropptellinger",
        "inventory.counts.description": "Administrer lageropptellinger og lagerkontroll",
        "inventory.count.title": "Lageropptelling",
        "inventory.count.create": "Ny opptelling",
        "inventory.count.count_number": "Opptellingsnummer",
        "inventory.count.date": "Dato",
        "inventory.count.status": "Status",
        "inventory.count.status.draft": "Kladd",
        "inventory.count.status.pending_approval": "Venter på godkjenning",
        "inventory.count.status.approved": "Godkjent",
        "inventory.count.status.completed": "Fullført",
        "inventory.count.add_item": "Legg til linje",
        "inventory.count.select_product": "Velg produkt",
        "inventory.count.scan_qr": "Skann QR-kode",
        "inventory.count.import_csv": "Importer CSV/Excel",
        "inventory.count.selected_products": "Valgte produkter",
        "inventory.count.item_number": "Artikelnr",
        "inventory.count.remove": "Fjern",
        "inventory.count.note_optional": "Notat (valgfritt)",
        "inventory.count.note_placeholder": "Legg til notat...",
        "inventory.count.reset": "Nullstill",
        "inventory.count.add_products": "Legg til produkter",
        "inventory.count.add_product": "Legg til produkt",
        "inventory.count.add_scanned_product": "Legg til skannet produkt",
        "inventory.count.scan_another": "Skann et annet",
        "inventory.count.select_products": "Velg produkter",
        "inventory.count.products_selected": "{{count}} produkt(er) valgt",
        "inventory.count.qr.required": "Skriv inn eller skann en QR-kode",
        "inventory.count.qr.placeholder": "Skriv produktnummer eller skann QR-kode",
        "inventory.count.product.already_selected": "Produktet er allerede valgt",
        "inventory.count.product.added": "Produkt lagt til",
        "inventory.count.product.not_found": "Produkt ikke funnet. Prøv manuell søk.",
        "inventory.count.product.search_error": "Kunne ikke søke etter produkt",
        "inventory.count.product.select_required": "Velg minst ett produkt",
        "inventory.count.items": "Linjer",
        "inventory.count.product": "Produkt",
        "inventory.count.quantity": "Mengde",
        "inventory.count.purchase_price": "Innkjøpspris",
        "inventory.count.total": "Total",
        "inventory.count.note": "Notat",
        "inventory.count.total_items": "Antall linjer",
        "inventory.count.total_quantity": "Total mengde",
        "inventory.count.no_items": "Ingen linjer",
        "inventory.count.no_items_description": "Legg til linjer for å starte opptellingen",
        "inventory.count.item.added": "Linje lagt til",
        "inventory.count.item.add_error": "Kunne ikke legge til linje",
        "inventory.count.item.updated": "Linje oppdatert",
        "inventory.count.item.update_error": "Kunne ikke oppdatere linje",
        "inventory.count.item.deleted": "Linje fjernet",
        "inventory.count.item.delete_error": "Kunne ikke fjerne linje",
        "inventory.count.item.delete_confirm": "Er du sikker på at du vil fjerne denne linjen?",
        "inventory.count.quantity_required": "Mengde må være større enn 0",
        "inventory.count.csv.import_title": "Importer linjer fra CSV/Excel",
        "inventory.count.csv.drop_here": "Slipp fil her",
        "inventory.count.csv.drop_or_select": "Dra og slipp en fil her, eller klikk for å velge",
        "inventory.count.csv.supported_formats": "CSV, XLS, XLSX",
        "inventory.count.csv.file_selected": "Fil valgt",
        "inventory.count.csv.change_file": "Bytt fil",
        "inventory.count.csv.column_mapping": "Kolonnemapping",
        "inventory.count.csv.field.product_id": "Produkt ID",
        "inventory.count.csv.field.item_number": "Artikelnr",
        "inventory.count.csv.field.title": "Tittel",
        "inventory.count.csv.field.quantity": "Mengde",
        "inventory.count.csv.field.purchase_price": "Innkjøpspris",
        "inventory.count.csv.field.note": "Notat",
        "inventory.count.csv.not_mapped": "Ikke mappet",
        "inventory.count.csv.preview": "Forhåndsvisning",
        "inventory.count.csv.first_rows": "første rader",
        "inventory.count.csv.import": "Importer",
        "inventory.count.csv.importing": "Importerer...",
        "inventory.count.csv.import_success": "Importerte {{count}} linjer",
        "inventory.count.csv.import_error": "Kunne ikke importere linjer",
        "inventory.count.csv.bulk_create_error": "Kunne ikke opprette produkter i bulk",
        "inventory.count.csv.mapping_required": "Vennligst map minst Produkt ID eller Artikelnr",
        "inventory.count.csv.no_headers": "Kunne ikke oppdage CSV-overskrifter",
        "inventory.count.csv.read_error": "Feil ved lesing av fil",
        "inventory.count.csv.processing_error": "Feil ved behandling av fil",
        "inventory.count.csv.product_not_found": "Produkt ikke funnet",
        "inventory.count.csv.product_search_error": "Feil ved søk etter produkt",
        "inventory.count.csv.product_id_required": "Produkt ID eller Artikelnr påkrevd",
        "inventory.count.csv.no_valid_items": "Ingen gyldige linjer funnet i filen",
        "inventory.count.csv.missing_products_title": "Produkter ikke funnet",
        "inventory.count.csv.missing_products_message": "{{count}} produkt(er) ble ikke funnet i systemet. Velg handling for hver:",
        "inventory.count.csv.action": "Handling",
        "inventory.count.csv.add_as_new": "Legg til som nytt produkt",
        "inventory.count.csv.skip": "Hopp over",
        "inventory.count.csv.continue_import": "Fortsett import",
        "inventory.count.csv.processing_items": "Behandler {{current}} av {{total}} produkter",
        "inventory.count.csv.processing": "Behandler...",
        "inventory.count.csv.partial_import_success": "Importerte {{imported}} linjer, {{missing}} produkter ikke funnet",
        "inventory.count.csv.no_items_to_import": "Ingen linjer å importere",
        "inventory.count.duplicate.title": "Produkt finnes allerede i listen",
        "inventory.count.duplicate.message": "Dette produktet ligger allerede i opptellingslisten. Ønsker du å legge til ytterligere en linje?",
        "inventory.count.duplicate.added_at": "Lagt til",
        "inventory.count.duplicate.confirm": "Legg til linje",
        "inventory.counts.search_placeholder": "Søk i lageropptellinger...",
        "inventory.counts.filter_title": "Filtrer på status",
        "inventory.count.new_title": "Ny lageropptelling",
        "inventory.count.title_required": "Tittel er påkrevd",
        "inventory.count.date_required": "Dato er påkrevd",
        "inventory.count.storage_required": "Lager er påkrevd",
        "inventory.count.storage": "Lager",
        "inventory.count.select_storage": "Velg lager",
        "inventory.count.create_success": "Lageropptelling opprettet",
        "inventory.count.create_error": "Kunne ikke opprette lageropptelling",
        "inventory.count.approve": "Godkjenn",
        "inventory.count.unapprove": "Avgodkjenn",
        "inventory.count.approve_all": "Godkjenn alle",
        "inventory.count.unapprove_all": "Avgodkjenn alle",
        "inventory.count.approve_all_success": "{{count}} linjer godkjent",
        "inventory.count.approve_all_error": "Kunne ikke godkjenne alle linjer",
        "inventory.count.all_items_already_approved": "Alle linjer er allerede godkjent",
        "inventory.count.approved": "Godkjent",
        "inventory.count.approved_at": "Godkjent",
        "inventory.count.approved_by": "Godkjent av",
        "inventory.count.approve_success": "Opptelling godkjent",
        "inventory.count.approve_error": "Kunne ikke godkjenne opptelling",
        "inventory.count.unapprove_success": "Opptelling avgodkjent",
        "inventory.count.unapprove_error": "Kunne ikke avgodkjenne opptelling",
        "inventory.count.copy": "Kopier opptelling",
        "inventory.count.no_title": "Ingen tittel",
        "inventory.count.could_not_load": "Kunne ikke laste lageropptellinger",
        "inventory.count.no_counts_found": "Ingen lageropptellinger funnet",
        "inventory.count.create_new": "Opprett en ny lageropptelling",
        "selected": "valgt",
        "Select": "Velg",
        "Select all": "Velg alle",
        "Updated": "Oppdatert",
        "Created": "Opprettet",
        "inventory.count.copy_from_previous": "Kopier fra tidligere opptelling",
        "inventory.count.copy_all_products": "Kopier alle produkter fra lager",
        "inventory.count.select_count_to_copy": "Velg opptelling å kopiere",
        "inventory.count.copy_success": "Opptelling kopiert",
        "inventory.count.copy_error": "Kunne ikke kopiere opptelling",
        "inventory.count.copy_products_success": "Produkter kopiert",
        "inventory.count.copy_products_error": "Kunne ikke kopiere produkter",
        "inventory.count.approved_items": "Godkjente linjer",
        "inventory.count.approve_count": "Godkjenn opptelling",
        "inventory.count.date_updated": "Dato oppdatert",
        "inventory.count.date_update_error": "Kunne ikke oppdatere dato",
        "inventory.count.storage_updated": "Lager oppdatert",
        "inventory.count.storage_update_error": "Kunne ikke oppdatere lager",
        "inventory.count.no_storage": "Ingen lager",
        "inventory.count.export_pdf": "Eksporter PDF",
        "inventory.count.export_csv": "Eksporter CSV/Excel",
        "inventory.count.export_pdf_success": "PDF eksportert",
        "inventory.count.export_pdf_error": "Kunne ikke eksportere PDF",
        "inventory.count.export_csv_success": "CSV eksportert",
        "inventory.count.export_csv_error": "Kunne ikke eksportere CSV",
        "product.stock_report.title": "Lagerrapport",
        "product.stock_report.description": "Komplett oversikt over alle lagerbevegelser (inn/ut) og hvor produktet er registrert (varetelling, korreksjon, ordre, rapport, etc.)",
        "product.stock_report.date": "Dato",
        "product.stock_report.type": "Type",
        "product.stock_report.transaction_title": "Tittel",
        "product.stock_report.quantity": "Antall",
        "product.stock_report.storage": "Lager",
        "product.stock_report.status": "Status",
        "product.stock_report.approved": "Godkjent",
        "product.stock_report.pending": "Venter",
        "product.stock_report.no_transactions": "Ingen transaksjoner",
        "product.stock_report.no_transactions_description": "Ingen lagerbevegelser funnet for dette produktet",
        "inventory.count.product_stock": "Produktbeholdning",
        "inventory.count.tracked_quantity": "Lagerført antall",
        "inventory.count.available_quantity": "Tilgjengelig antall",
        "inventory.count.incoming_quantity": "Inngående antall",
        "inventory.count.outgoing_quantity": "Utgående antall",
        "inventory.count.sales_price": "Salgspris",

        "inventory.settings.title": "Lagerinnstillinger",
        "inventory.settings.subtitle": "Administrer lagre og plukkeliste",
        "inventory.settings.new_storage": "Nytt lager",
        "inventory.settings.storages": "Lagre",

        "inventory.picking.title": "Plukkliste",
        "inventory.picking.subtitle": "Ordre, arbeidsordre og servicerapporter — linjer som skal plukkes",
        "inventory.picking.hero_kicker": "Lager",
        "inventory.picking.filters_heading": "Filter og søk",
        "inventory.picking.filters_description": "Avgrens hvilke dokumenttyper og linjer som vises. Ordre er av som standard — velg Ordre for å ta dem med.",
        "inventory.picking.list_kicker": "Plukk",
        "inventory.picking.list_title": "Dokumenter og linjer",
        "inventory.picking.list_description": "Utvid hvert dokument for å se produktlinjer, velge lager og registrere plukk.",
        "inventory.picking.loading": "Laster…",
        "inventory.picking.empty_title": "Ingen linjer å vise",
        "inventory.picking.picked_label": "Plukket",
        "inventory.picking.meta.groups": "Grupper",
        "inventory.picking.meta.lines": "Linjer",
        "inventory.picking.search_placeholder": "Søk ordre, produkt, varenummer…",
        "inventory.picking.filter.unpicked_only": "Kun ikke plukket / delvis",
        "inventory.picking.filter.warehouse_only": "Kun lagerprodukter",
        "inventory.picking.filter.warehouse_only_help": "Når på, vises kun linjer der produktet er merket som lagerstyrt. Er alle produktene det, ser listen lik ut med og uten filter. Når av, vises alle linjer; produkter uten lagerstyring får amber-rad og merket «Ikke lagerstyrt».",
        "inventory.picking.filter.include_skipped": "Vis «skal ikke plukkes»",
        "inventory.picking.filter.include_skipped_help": "Linjer markert som skal ikke plukkes er skjult som standard. Slå på for å se dem igjen (f.eks. for å fjerne merket).",
        "inventory.picking.non_warehouse_badge": "Ikke lagerstyrt",
        "inventory.picking.non_warehouse_hint": "Produktet er ikke merket for lagerstyring. Du kan likevel plukke og velge lager ved behov.",
        "inventory.picking.refresh": "Oppdater",
        "inventory.picking.empty": "Ingenting å plukke med gjeldende filtre.",
        "inventory.picking.load_error": "Kunne ikke hente plukkliste",
        "inventory.picking.open_source": "Åpne dokument",
        "inventory.picking.open_document_short": "Åpne",
        "inventory.picking.open_item_list": "Vareliste",
        "inventory.picking.qty": "Antall",
        "inventory.picking.qty_picked": "Plukket",
        "inventory.picking.storage": "Lager",
        "inventory.picking.pick_storage": "Lager",
        "inventory.picking.storage_placeholder": "Velg lager…",
        "inventory.picking.storage_required": "Velg lager før du merker som plukket",
        "inventory.picking.toggle_picked": "Merk plukket",
        "inventory.picking.marked_picked": "Merket som plukket",
        "inventory.picking.marked_unpicked": "Plukk fjernet",
        "inventory.picking.toggle_error": "Kunne ikke oppdatere linje",
        "inventory.picking.skip.label": "Skal ikke plukkes",
        "inventory.picking.skip.badge": "Skal ikke plukkes",
        "inventory.picking.skip.row_hint": "Denne linjen er utenfor plukk på lager. Fjern «Skal ikke plukkes» hvis den skal plukkes.",
        "inventory.picking.skip.blocks_pick": "Fjern «Skal ikke plukkes» før du merker som plukket.",
        "inventory.picking.skip.on": "Merket som skal ikke plukkes",
        "inventory.picking.skip.off": "Linjen kan plukkes igjen",
        "inventory.picking.skip.error": "Kunne ikke oppdatere «skal ikke plukkes»",
        "inventory.picking.send_reminder": "Send påminnelse",
        "inventory.picking.reminder_sent": "Påminnelse lagt i kø",
        "inventory.picking.reminder_error": "Kunne ikke sende påminnelse",
        "inventory.picking.quick_print.tooltip": "Rask etikett (PDF)",
        "inventory.picking.quick_print.document_tooltip": "Rask dokumentetikett (nummer, kunde, adresse, type)",
        "inventory.picking.quick_print.opened": "Etikett åpnet i ny fane",
        "inventory.picking.quick_print.no_product": "Mangler produkt",
        "inventory.picking.quick_print.no_types": "Ingen etiketttyper er konfigurert",
        "inventory.picking.quick_print.failed": "Kunne ikke lage PDF for etikett",
        "inventory.picking.delivery_note.tooltip": "Skriv ut følgeseddel (PDF)",
        "inventory.picking.delivery_note.opened": "Følgeseddel åpnet i ny fane",
        "inventory.picking.delivery_note.failed": "Kunne ikke lage følgeseddel-PDF",
        "inventory.picking.delivery_note.missing_id": "Mangler dokument-id",
        "inventory.picking.delivery_note.unsupported": "Følgeseddel er ikke tilgjengelig for denne dokumenttypen ennå",
        "inventory.picking.module.order": "Ordre",
        "inventory.picking.module.work_order": "Arbeidsordre",
        "inventory.picking.module.report": "Rapport",
        "inventory.picking.execution_on": "Utførelsesdato",
        "inventory.picking.status.invoiced": "Fakturert",
        "inventory.picking.status.used_job": "Brukt på oppdrag",
        "inventory.picking.status.in_vehicle": "Tatt med i bil",
        "inventory.picking.status.not_used": "Ikke brukt",
        "inventory.picking.status.returned": "Lagt tilbake på lager",
        "inventory.picking.status.left_vehicle": "Ligger i bil",
        "inventory.picking.status.picked": "Plukket",
        "inventory.picking.status.not_picked": "Ikke plukket",
        "inventory.picking.settings.title": "Påminnelser for plukkliste",
        "inventory.picking.settings.description": "Brukere som får e-post når du bruker «Send påminnelse» på plukkelista.",
        "inventory.picking.settings.recipients": "Mottakere",
        "inventory.picking.settings.recipients_placeholder": "Velg brukere…",
        "inventory.picking.settings.save": "Lagre",
        "inventory.picking.settings.saving": "Lagrer…",
        "inventory.picking.settings.saved": "Innstillinger lagret",
        "inventory.picking.settings.save_error": "Kunne ikke lagre innstillinger",
        "inventory.picking.settings.load_error": "Kunne ikke hente plukkeinnstillinger",

        "Exporting...": "Eksporterer...",
        "Processing...": "Behandler...",
        
        // Offer Calculation translations (Norwegian)
        "offer.calculation.title": "Kalkyler / Tilbudsposter",
        "offer.calculation.subtitle": "Administrer kalkyler og tilbudsposter",
        "offer.calculation.new": "Ny kalkyle",
        "offer.calculation.search_placeholder": "Søk i kalkyler...",
        "offer.calculation.name": "Navn",
        "offer.calculation.type": "Type",
        "offer.calculation.status": "Status",
        "offer.calculation.total": "Total",
        "offer.calculation.actions": "Handlinger",
        "offer.calculation.view": "Vis",
        "offer.calculation.edit": "Rediger",
        "offer.calculation.delete": "Slett",
        "offer.calculation.delete_confirm": "Er du sikker på at du vil slette denne kalkylen?",
        "offer.calculation.no_results": "Ingen kalkyler funnet",
        "offer.calculation.active": "Aktiv",
        "offer.calculation.inactive": "Inaktiv",
        "offer.calculation.type.standard": "Standard",
        "offer.calculation.type.product": "Produkt",
        "offer.calculation.type.hours": "Timer",
        "offer.calculation.type.car_allowance": "Bilgodtgjørelse",
        "offer.calculation.type.nested": "Nestet",
        "offer.calculation.line": "linje",
        "offer.calculation.lines": "linjer",
        "offer.calculation.delete_success": "Kalkyle ble slettet",
        "offer.calculation.delete_error": "Kunne ikke slette kalkyle",
        "offer.calculation.untitled": "Uten tittel",
        "offer.calculation.mode.title": "Velg kalkyleoppsett",
        "offer.calculation.mode.subtitle": "Velg om denne kalkylen skal bygges som vanlige linjer eller med modulbygger. Dette låses etter at kalkylen er lagret.",
        "offer.calculation.mode.lines_title": "Kalkyle pr. linje",
        "offer.calculation.mode.lines_hint": "Bruk dagens linjebaserte kalkyle med produkter, timer og manuelle rader.",
        "offer.calculation.mode.modules_title": "Modulbygger",
        "offer.calculation.mode.modules_hint": "Bygg en visuell flyt med produkter, timer, formler og piler.",
        "offer.calculation.mode.locked_hint": "Kalkyleoppsett er låst etter opprettelse for å unngå at linjer og modulbygger blandes.",
        "offer.calculation.builder.section_title": "Kalkylebygger",
        "offer.calculation.builder.section_hint": "Behold dagens linjer, eller bygg en visuell modulbasert kalkyle som kan kobles til backend senere.",
        "offer.calculation.builder.section_hint_lines": "Denne kalkylen er linjebasert. Bruk linjer, produkter, timer og manuelle rader.",
        "offer.calculation.builder.section_hint_modules": "Denne kalkylen bruker modulbygger. Bygg flyten visuelt og test den i brukervisning.",
        "offer.calculation.builder.tab_lines": "Linjer",
        "offer.calculation.builder.tab_modules": "Modulbygger",
        "offer.calculation.builder.tab_insert": "Brukervisning",
        "offer.calculation.page.kicker": "Tilbudskalkyle",
        "offer.calculation.page.subtitle": "Bygg, test og bruk kalkyler i full bredde med linjer, moduler og en egen innlimingsvisning.",
        "offer.calculation.insert.title": "User insert view",
        "offer.calculation.insert.subtitle": "Slik oppleves kalkylen når den limes inn i tilbud, moduler eller andre flyter.",
        "offer.calculation.insert.inputs_title": "Justerbare felt",
        "offer.calculation.insert.inputs_hint": "Kun felt som ikke er låst kan endres her, for eksempel antall kilometer, prosent og fordeling.",
        "offer.calculation.insert.flow_title": "Slik henger kalkylen sammen",
        "offer.calculation.insert.flow_hint": "Bokser og koblinger vises som et readonly kart, mens tallene oppdateres live.",
        "offer.calculation.insert.fields_tab": "Juster felt",
        "offer.calculation.insert.map_tab": "Kart",
        "offer.calculation.insert.offer_dialog_title": "Tilpass kalkyle før den legges til tilbudet",
        "offer.calculation.insert.offer_cancel": "Avbryt",
        "offer.calculation.insert.offer_add": "Legg til i tilbud",
        "offer.calculation.insert.adjust_fields": "Juster felter",
        "offer.calculation.insert.edit_lines": "Rediger kalkyle",
        "offer.calculation.insert.adjustable_fields": "Justerbare felter",
        "offer.calculation.insert.adjustable_fields_hint": "Denne kalkylen bruker modulbygger. Åpne justering for å endre antall, kilometer, prosent og andre åpne felter.",
        "offer.calculation.module.palette_title": "Moduler",
        "offer.calculation.module.palette_hint": "Dra moduler inn i lerretet, eller klikk for å legge dem til.",
        "offer.calculation.module.canvas_title": "Modulkart",
        "offer.calculation.module.canvas_hint": "Flytt bokser, koble dem med piler og velg om forbindelsen skal legge til eller trekke fra.",
        "offer.calculation.module.connecting_hint": "Velg neste boks for å lage en kobling.",
        "offer.calculation.module.reset_example": "Nullstill til eksempel",
        "offer.calculation.module.zoom_out": "Zoom ut",
        "offer.calculation.module.zoom_in": "Zoom inn",
        "offer.calculation.module.reset_view": "Nullstill visning",
        "offer.calculation.module.result_title": "Resultat",
        "offer.calculation.module.result_hint": "Dette er en frontend-forhåndsvisning. Backend blir sannheten for totaler når den implementeres.",
        "offer.calculation.module.editor_title": "Rediger valgt modul",
        "offer.calculation.module.edge_title": "Rediger pil",
        "offer.calculation.module.breakdown_title": "Fordeling",
        "offer.calculation.module.connect": "Koble",
        "offer.calculation.module.connect_here": "Koble hit",
        "offer.calculation.module.remove": "Fjern",
        "offer.calculation.module.remove_edge": "Fjern pil",
        "offer.calculation.module.locked": "Låst",
        "offer.calculation.module.unlocked": "Åpen",
        "offer.calculation.module.enabled": "Aktiv",
        "offer.calculation.module.disabled": "Inaktiv",
        "offer.calculation.module.operation.add": "Legg til",
        "offer.calculation.module.operation.subtract": "Trekk fra",
        "offer.calculation.module.scope.all": "Hele jobben",
        "offer.calculation.module.scope.work": "Kun jobb",
        "offer.calculation.module.scope.driving": "Kun kjøring",
        "offer.calculation.module.scope.selected": "Valgte moduler",
        "offer.calculation.module.field.title": "Tittel",
        "offer.calculation.module.field.amount": "Beløp",
        "offer.calculation.module.field.enabled": "Status",
        "offer.calculation.module.field.quantity": "Antall",
        "offer.calculation.module.field.unit_price": "Enhetspris",
        "offer.calculation.module.field.product_name": "Produktnavn",
        "offer.calculation.module.field.hours": "Timer",
        "offer.calculation.module.field.hourly_rate": "Timesats",
        "offer.calculation.module.field.cost_hourly_rate": "Kost-timesats",
        "offer.calculation.module.field.percent": "Prosent",
        "offer.calculation.module.field.scope": "Gjelder",
        "offer.calculation.module.field.divisor": "Fordeles på",
        "offer.calculation.module.field.expression": "Formel",
        "offer.calculation.module.field.note": "Notat",
        "offer.calculation.module.field.operation": "Operasjon",
        "offer.calculation.module.formula.assistant_title": "Formelhjelp",
        "offer.calculation.module.formula.assistant_subtitle": "Velg en ferdig mal, eller trykk på variabler og funksjoner. Du trenger ikke huske Excel-syntaks.",
        "offer.calculation.module.formula.templates": "Ferdige maler",
        "offer.calculation.module.formula.variables": "Sett inn verdi",
        "offer.calculation.module.formula.functions": "Smarte funksjoner",
        "offer.calculation.module.formula.example_title": "Tips",
        "offer.calculation.module.formula.example_text": "`input` er summen fra pilene inn til {{title}}. Start med en mal og juster tallene.",
        "offer.calculation.module.formula.variable.input": "Sum fra piler inn",
        "offer.calculation.module.formula.variable.quantity": "Eget antall",
        "offer.calculation.module.formula.variable.price": "Egen pris",
        "offer.calculation.module.formula.variable.percent": "Egen prosent",
        "offer.calculation.module.formula.function.sum": "Summer flere tall",
        "offer.calculation.module.formula.function.round": "Rund av til heltall",
        "offer.calculation.module.formula.function.min": "Makspris-tak",
        "offer.calculation.module.formula.function.max": "Minimumspris",
        "offer.calculation.module.formula.template.same": "Bruk summen som den er",
        "offer.calculation.module.formula.template.fixed_add": "Legg til fast beløp",
        "offer.calculation.module.formula.template.fixed_subtract": "Trekk fra fast beløp",
        "offer.calculation.module.formula.template.ten_percent": "Legg på 10 %",
        "offer.calculation.module.formula.template.custom_percent": "Legg på egen %",
        "offer.calculation.module.formula.template.quantity_price": "Antall ganger pris",
        "offer.calculation.module.formula.template.split_two": "Del på 2",
        "offer.calculation.module.formula.template.round": "Rund av totalen",
        "offer.calculation.module.node.service": "Tjeneste",
        "offer.calculation.module.node.service_hint": "Fast beløp som kan låses, f.eks. leilighet.",
        "offer.calculation.module.node.quantity": "Antall x pris",
        "offer.calculation.module.node.quantity_hint": "Antall ganger enhetspris, f.eks. kilometer.",
        "offer.calculation.module.node.product_price": "Produktpris",
        "offer.calculation.module.node.product_price_hint": "Produktnavn, antall og pris i én modul.",
        "offer.calculation.module.node.product_catalog": "Produktliste",
        "offer.calculation.module.node.product_catalog_hint": "Legg til produkter fra produktregisteret eller manuelle produktlinjer.",
        "offer.calculation.module.node.labor_hours": "Timefelt",
        "offer.calculation.module.node.labor_hours_hint": "Timer ganger timesats, f.eks. tilleggsarbeid eller servicearbeid.",
        "offer.calculation.module.node.percentage": "Prosent",
        "offer.calculation.module.node.percentage_hint": "Påslag eller rabatt på inngående moduler.",
        "offer.calculation.module.node.distribution": "Fordeling",
        "offer.calculation.module.node.distribution_hint": "Fordel inngående beløp på X.",
        "offer.calculation.module.node.formula": "Excel formel",
        "offer.calculation.module.node.formula_hint": "Bruk input, quantity, price, percent, SUM og ROUND.",
        "offer.calculation.module.node.subtotal": "Subtotal",
        "offer.calculation.module.node.subtotal_hint": "Samler flere inngående moduler.",
        "offer.calculation.module.node.total": "Total",
        "offer.calculation.module.node.total_hint": "Sluttpunkt for kalkylen.",
        "offer.calculation.module.node.note": "Notat",
        "offer.calculation.module.node.note_hint": "Forklarende boks uten beløp.",
        "offer.calculation.module.product.title": "Produkter",
        "offer.calculation.module.product.hint": "Velg produkter fra registeret eller legg inn egne produktlinjer.",
        "offer.calculation.module.product.add_from_catalog": "Legg til fra produktregister",
        "offer.calculation.module.product.add_manual": "Manuell linje",
        "offer.calculation.module.product.empty": "Ingen produkter lagt til ennå.",
        "offer.calculation.module.product.manual_title": "Manuelt produkt",
        "offer.calculation.module.product.include": "Ta med",
        "offer.calculation.module.product.exclude": "Utelat",
        "offer.calculation.module.product.total": "Produkttotal",
        "offer.calculation.module.product.cancel": "Avbryt",
        "offer.calculation.module.product.add_selected": "Legg til valgte",
        
        // Accounting Summary translations (Norwegian)
        "accounting.summary.title": "Regnskapssummering",
        "accounting.summary.costs": "Kostnader",
        "accounting.summary.income": "Inntekter",
        "accounting.summary.profit": "Fortjeneste",
        "accounting.summary.profit_margin": "margin",
        "accounting.summary.projects": "Prosjekter",
        "accounting.summary.labor": "Lønnskostnader",
        "accounting.summary.material": "Materialkostnader",
        "accounting.summary.supplier_invoices": "Leverandørfakturaer",
        "accounting.summary.item_lists": "Varelister",
        "accounting.summary.customer_invoices": "Kundefakturaer",
        "accounting.summary.reports": "Rapporter",
        "accounting.summary.total": "Totalt",
        "accounting.summary.calculated_at": "Beregnet",
        "accounting.summary.cached": "Cachet",
        "accounting.summary.load_error": "Kunne ikke laste regnskapssummering",
        "accounting.summary.monthly_overview": "Månedlig oversikt",
        "accounting.summary.chart_description": "Stolper: inntekter & kostnader · Linje: månedlig resultat (inntekter − kostnader)",
        "accounting.summary.no_monthly_data": "Ingen månedlige data tilgjengelig",
        "accounting.summary.months.january": "Jan",
        "accounting.summary.months.february": "Feb",
        "accounting.summary.months.march": "Mar",
        "accounting.summary.months.april": "Apr",
        "accounting.summary.months.may": "Mai",
        "accounting.summary.months.june": "Jun",
        "accounting.summary.months.july": "Jul",
        "accounting.summary.months.august": "Aug",
        "accounting.summary.months.september": "Sep",
        "accounting.summary.months.october": "Okt",
        "accounting.summary.months.november": "Nov",
        "accounting.summary.months.december": "Des",
        "accounting.summary.expected_report_income": "Oppdrag forventet inntekt",
        "accounting.summary.expected_income": "Forventet inntekt",
        "accounting.summary.expected_costs": "Forventet kostnad",
        "accounting.summary.expected_profit": "Forventet fortjeneste",
        "chemical.inventory.verneblad.contact_info":
          "Kontaktinformasjon for 'leverandøren av produktet' tas fra produkt som er tilknyttet brand - jeg tror kanskje vi må legge til adresse, land, telefon - nødtelefon må legges på pr. produkt.",
        "chemical.inventory.verneblad.protective_equipment":
          "verneutstyr + symboler, tiltak ved brann, tiltak ved utslipp, førstehjelstiltak etc.",
        "chemical.inventory.hms_level.1": "Lav risiko",
        "chemical.inventory.hms_level.2": "Medium risiko",
        "chemical.inventory.hms_level.3": "Høy risiko",
        "chemical.inventory.hms_level.4": "Kritisk risiko",
        "chemical.inventory.status.active": "Aktiv",
        "chemical.inventory.status.inactive": "Inaktiv",
        "chemical.inventory.status.archived": "Arkivert",
        "chemical.inventory.document_type.safety_data_sheet":
          "Sikkerhetsdatablad",
        "chemical.inventory.document_type.risk_assessment": "Risikovurdering",
        "chemical.inventory.document_type.safety_instruction":
          "Sikkerhetsinstruksjon",
        "chemical.inventory.document_type.certificate": "Sertifikat",
        "chemical.inventory.document_type.other": "Annet",
        "chemical.inventory.note_type.general": "Generell",
        "chemical.inventory.note_type.safety": "Sikkerhet",
        "chemical.inventory.note_type.risk": "Risiko",
        "chemical.inventory.note_type.operation": "Operasjon",
        "chemical.inventory.note_type.other": "Annet",
        "Ingen kjemisk informasjon registrert for dette produktet":
          "No chemical information registered for this product",
        "Produkt ble lagt til i stoffkartotek":
          "Product was added to chemical inventory",
        "Kunne ikke legge til i stoffkartotek":
          "Could not add to chemical inventory",
        "Legger til...": "Adding...",
        "Vis detaljer": "View details",
        "Navn er påkrevd": "Name is required",
        "CAS-nummer er påkrevd": "CAS number is required",
        "Ugyldig e-post": "Invalid email",
        "Kunne ikke lagre stoffkartotek": "Could not save chemical inventory",
        "Lagrer...": "Saving...",
        "Oppdater": "Update",
        "Opprett": "Create",
        "Avbryt": "Cancel",
        "Produkt er påkrevd": "Product is required",
        "Notater kan kun legges til etter at stoffet er opprettet":
          "Notes can only be added after the chemical is created",
  
        // Project Management translations
        "project.time_registration": "Timeregistrering",
        "project.time_registration.sync": "Synkroniser med Tripletex",
        "project.time_registration.sync_to_tripletex":
          "Synkroniser til Tripletex",
        "project.time_registration.sync_from_tripletex":
          "Synkroniser fra Tripletex",
        "project.time_registration.sync_success": "Timeregistrering synkronisert",
        "project.time_registration.sync_error":
          "Kunne ikke synkronisere timeregistrering",
        "project.time_registration.loading": "Laster timeregistrering…",
        "project.time_registration.list_title": "Timeregistrering — {{title}}",
        "project.time_registration.filter": "Filtrer",
        "project.time_registration.date_from": "Fra dato",
        "project.time_registration.date_to": "Til dato",
        "project.time_registration.empty":
          "Ingen timeregistrering funnet for dette prosjektet",
        "project.time_registration.registrations": "registreringer",
        "project.time_registration.no_activity": "Ingen aktivitet",
        "project.time_registration.approved_section": "Godkjente timer",
        "project.time_registration.approved_section_hint":
          "Disse timene er godkjent og inngår i summering og timekostnader over.",
        "project.time_registration.excluded_section":
          "Ikke godkjente eller avventer godkjenning",
        "project.time_registration.excluded_section_hint":
          "Timer som ikke er godkjent, inngår ikke i totaler eller timekostnader.",
        "project.time_registration.no_approved_in_range":
          "Ingen godkjente timer i valgt periode.",
        "project.time_registration.total_approved_hours": "Godkjente timer (sum)",
        "project.time_registration.total_excluded_hours": "Utenfor sum",
        "project.time_registration.summary_approved_label":
          "Totalt godkjente timer (summering)",
        "project.time_registration.summary_excluded_note":
          "{{hours}} timer er ikke godkjent og telles ikke med.",
        "project.time_registration.badge_approved": "Godkjent",
        "project.time_registration.badge_rejected": "Ikke godkjent",
        "project.time_registration.badge_pending": "Avventer godkjenning",
        "project.time_registration.approve": "Godkjenn",
        "project.time_registration.reject": "Ikke godkjenn",
        "project.time_registration.open_hour": "Rediger time",
        "project.time_registration.process_dialog": "Behandle time",
  
        "project.hourly_costs": "Timekostnader",
        "project.hourly_costs.calculation": "Beregning av timekostnader",
        "project.hourly_costs.social_expenses": "Sosiale utgifter (28%)",
        "project.hourly_costs.total_cost": "Total timekostnad",
        "project.hourly_costs.missing_rate_warning":
          "Mangler gyldig timekostnad for denne ansatte",
        "project.hourly_costs.warning_title": "Advarsel: Manglende timekostnad",
  
        "project.item_list": "Vareliste",
        "project.item_list.create": "Opprett vareliste",
        "project.item_list.edit": "Rediger vareliste",
        "project.item_list.delete": "Slett vareliste",
        "project.item_list.type": "Type vareliste",
        "project.item_list.type.consumption": "Forbruk",
        "project.item_list.type.return": "Retur",
        "project.item_list.warehouse": "Varelager",
        "project.item_list.select_warehouse": "Velg varelager",
        "project.item_list.save": "Lagre vareliste",
        "project.item_list.deliver": "Levere vareliste",
        "project.item_list.approve": "Godkjenn vareliste",
        "project.item_list.reject": "Avslå vareliste",
        "project.item_list.submit_for_approval": "Send til godkjenning",
        "project.item_list.status": "Status",
        "project.item_list.status.label": "Status",
        "project.item_list.status.draft": "Kladd",
        "project.item_list.status.pending_approval": "Venter på godkjenning",
        "project.item_list.status.delivered": "Levert",
        "project.item_list.status.approved": "Godkjent",
        "project.item_list.status.rejected": "Avslått",
        "project.item_list.status.invoiced_manually": "Fakturert, manuelt",
        "project.item_list.mark_invoiced_manually": "Merk som fakturert (manuelt)",
        "project.item_list.print": "Skriv ut",
        "project.item_list.total_purchase": "Totalt innkjøp",
        "project.item_list.merge.select": "Velg",
        "project.item_list.merge.select_list": "Velg liste {{title}}",
        "project.item_list.merge.select_all_eligible": "Velg alle",
        "project.item_list.merge.deselect_all": "Nullstill utvalg",
        "project.item_list.merge.create_order": "Opprett ordre fra lister",
        "project.item_list.merge.dialog_title": "Opprett ordre fra varelister",
        "project.item_list.merge.dialog_hint": "{{count}} liste(r) valgt. Velg hvordan ordrelinjer bygges og eventuelle pristilpasninger.",
        "project.item_list.merge.mode_label": "Linjeoppsett",
        "project.item_list.merge.mode.grouped_by_list": "Én gruppe per vareliste (navn = gruppetittel), alle produktlinjer",
        "project.item_list.merge.mode.one_line_per_list": "Én samlet linje per vareliste (vektet enhetspris)",
        "project.item_list.merge.mode.flat_by_product": "Samlet oversikt: én linje per produkt (samlet mengde)",
        "project.item_list.merge.purchase_markup": "Innkjøp + %",
        "project.item_list.merge.sales_discount": "Rabatt på salgspris (%)",
        "project.item_list.merge.sales_surcharge": "Påslag på salgspris (%)",
        "project.item_list.merge.mark_invoiced_after": "Merk valgte varelister som fakturert manuelt etter at ordren er opprettet",
        "project.item_list.merge.submit": "Opprett ordre",
        "project.item_list.merge.submitting": "Oppretter ordre…",
        "project.item_list.merge.error_generic": "Kunne ikke opprette ordre. Sjekk tilgang og at listene har varer.",
        "project.item_list.add_product": "Legg til produkt",
        "project.item_list.products": "Varer",
        "project.item_list.product": "Produkt",
        "project.item_list.quantity": "Mengde",
        "project.item_list.price": "Pris",
        "project.item_list.total": "Total",
        "project.item_list.actions": "Handlinger",
        "project.item_list.remove": "Fjern",
        "project.item_list.no_items": "Ingen varer",
        "project.item_list.no_items_description": "Denne varelisten har ingen varer ennå.",
        "project.item_list.scan_qr": "Skann QR-kode",
        "project.item_list.manual_search": "Søk manuelt",
        "project.item_list.scan_or_enter": "Skann QR-kode eller skriv inn produktnummer",
        "project.item_list.selected_product": "Valgt produkt",
        "project.item_list.add": "Legg til",
        "project.item_list.back": "Tilbake",
        "project.item_list.cancel": "Avbryt",
        "project.item_list.created_by": "Opprettet av",
        "project.item_list.approved_by": "Godkjent av",
        "project.item_list.approval_comment": "Godkjenningskommentar",
        "project.item_list.total_items": "Antall varer",
        "project.item_list.total_quantity": "Total mengde",
        "project.item_list.total_value": "Total verdi",
        "project.item_list.summary_title": "Varelister — oppsummering",
        "project.item_list.summary_total_quantity": "Total mengde (netto)",
        "project.item_list.summary_total_purchase": "Totalt innkjøp",
        "project.item_list.summary_total_sales": "Totalt salg",
        "project.item_list.view_items_summary": "Se vareoppsummering",
        "project.item_list.items_summary_page_title": "Varelister — oppsummering",
        "project.item_list.items_summary_subtitle": "Mengder og priser på tvers av alle lister i prosjektet",
        "project.item_list.items_summary_intro":
          "Rader slås sammen etter produktets varenummer (produkter uten nummer grupperes per produkt). Returlister reduserer netto mengde og beløp.",
        "project.item_list.items_summary_table_item_number": "Varenr.",
  
        "project.invoices": "Fakturaer",
        "project.invoices.overview": "Oversikt over fakturaer",
        "project.invoices.create": "Opprett faktura",
        "project.invoices.edit": "Rediger faktura",
        "project.invoices.delete": "Slett faktura",
        "project.invoices.status": "Fakturastatus",
        "project.invoices.status.paid": "Betalt",
        "project.invoices.status.pending": "Venter",
        "project.invoices.status.overdue": "Forfalt",
        "project.invoices.amount": "Beløp",
        "project.invoices.due_date": "Forfallsdato",
        "project.invoices.totals.invoiced_ex_vat": "Totalt fakturert (eks. mva)",
        "project.invoices.pagination.showing": "Viser {{from}}–{{to}} av {{total}}",
        "project.invoices.pagination.load_more": "Last inn flere fakturaer",
        "project.invoices.pagination.loading_more": "Laster…",
        "project.invoices.pagination.loaded_of_total": "{{loaded}} av {{total}} fakturaer vist",
        "project.invoices.pagination.all_loaded": "Alle {{total}} fakturaer er innlastet",
        "project.invoices.create_disabled_hint": "Opprett faktura er ikke tilgjengelig her ennå",
        "project.invoices.pagination.prev": "Forrige",
        "project.invoices.pagination.next": "Neste",
        "project.invoices.error.title": "Feil ved lasting",
        "project.invoices.no_invoices.title": "Ingen fakturaer",
        "project.invoices.no_invoices.description": "Ingen fakturaer er opprettet for dette prosjektet ennå",
  
        "project.supplier_invoices": "Leverandørfakturaer",
        "project.supplier_invoices.overview": "Oversikt over leverandørfakturaer",
        "project.supplier_invoices.create": "Opprett leverandørfaktura",
        "project.supplier_invoices.edit": "Rediger leverandørfaktura",
        "project.supplier_invoices.delete": "Slett leverandørfaktura",
  
        "project.billing_plan": "Faktureringsplan",
        "project.billing_plan.overview": "Oversikt levert/utført",
        "project.billing_plan.create_invoice": "Opprett A-konto faktura",
        "project.billing_plan.final_invoice": "Sluttfaktura",
        "project.billing_plan.progress": "Fremdrift",
        "project.billing_plan.completed": "Utført",
        "project.billing_plan.remaining": "Innestående",
        "project.billing_plan.contract_sum": "Kontraktsum",
        "project.billing_plan.completed_amount": "Utført beløp",
        "project.billing_plan.billed_amount": "Fakturert beløp",
        "project.billing_plan.remaining_amount": "Innestående beløp",
        "project.billing_plan.completed_sum": "Utført beløp",
        "project.billing_plan.billable_sum": "Fakturerbart beløp",
        "project.billing_plan.items.title": "Faktureringsplan",
        "project.billing_plan.items.empty": "Ingen faktureringsplaner opprettet ennå",
        "project.billing_plan.type": "Type",
        "project.billing_plan.planned_date": "Planlagt dato",
        "project.billing_plan.amount": "Beløp",
        "project.billing_plan.status.title": "Status",
        "project.billing_plan.status.planned": "Planlagt",
        "project.billing_plan.status.billed": "Fakturert",
        "project.billing_plan.status.cancelled": "Avbrutt",
        "project.billing_plan.actions": "Handlinger",
        "project.billing_plan.edit": "Rediger",
        "project.billing_plan.delete": "Slett",
        "project.billing_plan.edit_item": "Rediger faktureringsplan",
        "project.billing_plan.no_description": "Ingen beskrivelse",
        "project.billing_plan.deleting": "Sletter faktureringsplan...",
        "project.billing_plan.updating": "Oppdaterer faktureringsplan...",
        "project.billing_plan.creating": "Oppretter faktureringsplan...",
        "project.billing_plan.delete_confirmation": "Er du sikker på at du vil slette denne faktureringsplanen?",
        "project.billing_plan.invoice_selected": "Fakturer valgte",
        "project.billing_plan.invoicing": "Fakturerer...",
        "project.billing_plan.a_account": "A-konto",
        "project.billing_plan.invoice_number": "Fakturanr",
        "project.billing_plan.settings": "Innstillinger",
        "project.billing_plan.remaining_settings_title": "Innstillinger for innestående beløp",
        "project.billing_plan.amount_to_invoice": "Beløp til fakturering",
        "project.billing_plan.amount_to_invoice_hint": "Forslag: utført for denne raden/periode minus innestående når dette er aktivert på prosjektet. Samme som utført når innestående ikke er aktivert. Tidligere fakturaer påvirker ikke beløpet. Oppdateres automatisk.",
        "project.billing_plan.retention_helper_disabled": "Innestående er 0 når prosjektinnstilling for withhold ikke er aktivert.",
        "project.billing_plan.retention_helper_enabled": "Innestående beregnes som {{pct}} % av {{base}}.",
        "project.billing_plan.retention_base_contract": "kontraktsum",
        "project.billing_plan.retention_base_completed": "utført beløp",
        "project.billing_plan.completed_helper": "Utført for denne perioden eller denne faktureringsraden (f.eks. faktureringsutkast). Sum fra kontraktslinjer, kun referanse: {{suggested}}.",
        "project.billing_plan.footer_suggested_line": "Foreslått beløp til fakturering: {{amount}} kr. Aktiv innestående: {{pct}} % av {{base}}. Tidligere fakturaer reduserer ikke forslaget.",
        "project.billing_plan.summary_title": "Beløpsoversikt",
        "project.billing_plan.summary_contract_lines_completed": "Sum kontraktslinjer (kun referanse)",
        "project.billing_plan.summary_billed_to_date": "Fakturert via plan til nå",
        "project.billing_plan.summary_retention_for_period": "Innestående (forslag for utført i skjema)",
        "project.billing_plan.invoice_edit_hint": "Endringer må gjøres i faktureringsplan før fakturering.",
        "project.billing_plan.invoice_type_label": "Faktureringstype",
        "project.billing_plan.invoice_auto": "Automatisk fakturering (opprett ny faktura og ordre for synk)",
        "project.billing_plan.invoice_manual": "Manuell/ekstern fakturering",
        "project.billing_plan.external_invoice_checkbox": "Ekstern faktura (fakturert utenfor systemet)",
        "project.billing_plan.link_invoice": "Knytt til eksisterende faktura (valgfritt)",
        "project.billing_plan.link_invoice_none": "Ingen knytning",
        "project.billing_plan.invoice_a_account_title": "Fakturer A-konto",
        "project.billing_plan.invoice_confirm": "Fakturer",
        "project.billing_plan.invoice_loading": "Fakturerer...",
        "project.billing_plan.invoice_created": "Faktura opprettet",
        "project.billing_plan.invoice_created_tripletex_ok": "Faktura opprettet og ordre bekreftet mot Tripletex.",
        "project.billing_plan.tripletex_queued_hint": "Tripletex-sesjon ikke tilgjengelig — ordre er satt i kø for synk (sjekk integrasjon og jobber om noe mangler).",
        "project.billing_plan.invoice_failed": "Kunne ikke fakturere",

        "project.contract_line": "Kontraktslinje",
        "project.contract_line.title": "Tittel",
        "project.contract_line.description": "Beskrivelse",
        "project.contract_line.contract_quantity": "Kontraktsmengde",
        "project.contract_line.completed_quantity": "Utført mengde",
        "project.contract_line.remaining_quantity": "Gjenstående mengde",
        "project.contract_line.unit_price": "Enhetspris",
        "project.contract_line.total_price": "Totalpris",
        "project.contract_line.create": "Ny kontraktslinje",
        "project.contract_line.edit": "Rediger kontraktslinje",
        "project.contract_line.delete": "Slett kontraktslinje",
  
        "project.contract_line_group": "Kontraktslinjegruppe",
        "project.contract_line_group.create": "Ny gruppe",
        "project.contract_line_group.edit": "Rediger gruppe",
  
        "project.delivery_progress": "Leveransefremdrift",
        "project.delivery_progress.register": "Registrer utført mengde",
        "project.delivery_progress.completed": "Utført",
        "project.delivery_progress.remaining": "Gjenstående",
  
        "project.settings": "Prosjektinnstillinger",
        "project.settings.retention_percentage": "Innestående (%)",
        "project.settings.final_invoice_due_days":
          "Sluttfaktura innestående forfallsdato (dager)",
        "project.settings.default_due_days": "Standard 60 dager",
  
        "project.website_settings": "Website innstillinger",
        "project.show_on_website": "Vis prosjekt på hjemmesiden",
        "project.show_on_website_description": "Aktiver for å vise prosjektet offentlig på hjemmesiden",
        "project.public_title": "Synlig tittel",
        "project.public_title_placeholder": "Tittel som vises på hjemmesiden",
        "project.public_description": "Synlig beskrivelse",
        "project.public_description_placeholder": "Beskrivelse som vises på hjemmesiden",
        "project.public_contract_sum": "Offentlig kontraktsum",
        "project.public_contract_sum_placeholder": "F.eks. 2 500 000 NOK",
        "project.public_contract_sum_description": "Kontraktsum som vises offentlig på hjemmesiden",
        "project.public_main_image": "Offentlig hovedbilde",
        "project.public_main_image_description": "Bilde som vises på hjemmesiden",
        "project.select_image": "Velg bilde",
        "project.change_image": "Bytt bilde",
        "project.search_images": "Søk etter bilder...",
        "project.searching": "Søker...",
        "project.search": "Søk",
        "project.no_images_found": "Ingen bilder funnet",
        "project.website_content_lines": "Innhold (statistikk/info)",
        "project.content_line_title": "Tittel",
        "project.content_line_value": "Verdi",
        "project.line_type_info": "Info",
        "project.line_type_statistics": "Statistikk",
        "project.add_line": "Legg til",
        "project.update_line": "Oppdater",
        "project.cancel": "Avbryt",
        "project.no_content_lines": "Ingen innholdslinjer lagt til",
        "project.saving": "Lagrer...",
        "project.save_settings": "Lagre innstillinger",
  
        "project.summary": "Prosjektsummering",
        "project.summary.overview": "Oversiktlig regnskap",
        "project.summary.labor_costs": "Lønnskostnader",
        "project.summary.material_costs": "Vareforbruk",
        "project.summary.invoiced_amount": "Fakturert beløp",
        "project.summary.supplier_invoices": "Leverandørfakturaer",
        "project.summary.total_costs": "Totale kostnader",
        "project.summary.profit": "Resultat",
        "project.summary.margin": "Margin",
        "project.summary.provisional_result": "Foreløpig resultat",
        "project.summary.module_breakdown": "Moduloversikt",
        "project.summary.module_breakdown_description": "Oversikt over alle moduler som påvirker prosjektsummeringen",
        "project.summary.module_type.report": "Rapport",
        "project.summary.module_type.work_order": "Arbeidsordre",
        "project.summary.module_type.item_list": "Vareliste",
        "project.summary.invoiced": "Fakturert",
        "project.summary.has_order": "Har ordre",
        "project.summary.costs": "Kostnader",
        "project.summary.income": "Inntekter",
        "project.summary.hours": "Timer",
        "project.summary.hours_short": "t",
        "project.summary.material": "Materialer",
        "project.summary.agreed_price": "Avtalt pris",
        "project.summary.price_lines": "prislinjer",
        "project.summary.expected_module_income": "Forventet inntekt fra moduler",
        "project.summary.expected_module_costs": "Forventet modulkostnader",
        "project.summary.invoiced_ex_vat_basis": "fakturert (eks. mva)",
        "project.summary.margin_on_invoiced_hint": "Beregnet av fakturert beløp eks. mva",
        "project.summary.of": "av",
        "project.summary.invoicing_rate_no_contract": "Ikke definert uten kontraktsum",
        "project.summary.cost_rate_on_invoiced_hint": "mot fakturert eks. mva",
        "project.summary.invoicing_rate": "Faktureringsgrad",
        "project.summary.cost_rate": "Kostnadsgrad",
        "project.summary.contract_sum": "Kontraktsum",
        "project.summary.remaining": "Gjenstående",
        "project.summary.cost_breakdown": "Kostnadsfordeling",
        "project.summary.no_costs": "Ingen kostnader registrert ennå",
        "project.summary.last_updated": "Sist oppdatert",
        "project.summary.export_pdf": "Eksporter PDF",
        "project.summary.error.title": "Feil ved lasting",
        "project.summary.no_data.title": "Ingen data tilgjengelig",
        "project.summary.no_data.description": "Prosjektsummering vil bli generert når data er tilgjengelig",
  
        "project.order_line": "Ordrelinje",
        "project.order_line.a_account": "A-konto",
        "project.order_line.description": "Beskrivelse",
        "project.order_line.completed_amount": "Utført beløp",
        "project.order_line.remaining_amount": "Innestående beløp",
        "project.order_line.final_invoice": "Sluttfaktura",
  
        "project.tripletex_sync": "Tripletex synkronisering",
        "project.tripletex_sync.disabled":
          "Synkronisering deaktivert for prosjekter med flere fakturaer",
        "project.tripletex_sync.reason":
          "Prosjektet har flere enn 1 faktura og er synkronisert med Tripletex",
  
        // Project Participants translations
        "project.participants.title": "Deltagere",
        "project.participants.description": "Prosjektdeltagere og deres roller",
        "project.participants.add": "Legg til deltager",
        "project.participants.add_first": "Legg til første deltager",
        "project.participants.edit": "Rediger deltager",
        "project.participants.delete": "Slett deltager",
        "project.participants.delete_confirm": "Er du sikker på at du vil fjerne denne deltageren?",
        "project.participants.none": "Ingen deltagere lagt til ennå.",
        "project.participants.user": "Bruker",
        "project.participants.role": "Rolle",
        "project.participants.status": "Status",
        "project.participants.admin": "Admin",
        "project.participants.error_loading": "Feil ved lasting av deltagere",
  
        // Project Activities translations
        "project.activities.tab_title": "Aktiviteter",
        "project.activities.tab_hint":
          "Når du forlater tittelfeltet (Tab eller klikk utenfor), lagres en ny linje. Neste nummer settes automatisk; Tripletex-linjer håndteres i bakgrunnen.",
        "project.activities.search_label": "Søk",
        "project.activities.search_placeholder": "Søk i tittel, nummer, beskrivelse …",
        "project.activities.filter_label": "Filter",
        "project.activities.filter_all": "Alle",
        "project.activities.filter_standard": "Kun standard",
        "project.activities.filter_additional": "Kun tilleggsarbeid",
        "project.activities.add_quick": "Ny rad",
        "project.activities.draft_title_placeholder": "Tittel — Tab for å lagre og neste rad",
        "project.activities.deleted": "Aktivitet slettet",
        "project.activities.title": "Aktiviteter",
        "project.activities.description":
          "Linjer som brukes for timer og pristilbud. Administrer dem under fanen Aktiviteter på prosjektet.",
        "project.activities.description_field": "Beskrivelse",
        "project.activities.activity_line": "Tripletex-aktivitetslinje",
        "project.activities.activity_line_hint":
          "Valgfritt. Kobler raden til en prosjektaktivitetslinje for Tripletex.",
        "project.activities.is_additional": "Tillegg",
        "project.activities.title_required": "Tittel er påkrevd",
        "project.activities.delete_error": "Kunne ikke slette aktivitet",
        "project.activities.add": "Legg til aktivitet",
        "project.activities.add_first": "Legg til første aktivitet",
        "project.activities.edit": "Rediger aktivitet",
        "project.activities.delete": "Slett aktivitet",
        "project.activities.delete_confirm": "Er du sikker på at du vil fjerne denne aktiviteten?",
        "project.activities.none": "Ingen aktiviteter lagt til ennå.",
        "project.activities.activity": "Aktivitet",
        "project.activities.number": "Nummer",
        "project.activities.budget_hours": "Budsjetterte timer",
        "project.activities.budget_fee": "Budsjettert avgift",
        "project.activities.invoiceable": "Fakturerbar",
        "project.activities.error_loading": "Feil ved lasting av aktiviteter",
  
        // Project sync status
        "project.synced": "Synkronisert",
        "project.not_synced": "Ikke synkronisert",
        
        // Additional project translations
        "project.participants.updated": "Deltager oppdatert",
        "project.participants.created": "Deltager lagt til",
        "project.participants.save_error": "Kunne ikke lagre deltager",
        "project.participants.user_required": "Bruker er påkrevd",
        "project.participants.role_required": "Rolle er påkrevd",
        "project.participants.admin_access": "Admin-tilgang",
        "project.participants.updating": "Oppdaterer...",
        "project.participants.adding": "Legger til...",
        
        "project.activities.updated": "Aktivitet oppdatert",
        "project.activities.created": "Aktivitet lagt til",
        "project.activities.save_error": "Kunne ikke lagre aktivitet",
        "project.activities.activity_required": "Aktivitet er påkrevd",
        "project.activities.title_field": "Tittel",
        "project.activities.start_date": "Startdato",
        "project.activities.end_date": "Sluttdato",
        "project.activities.budget_fee_rate": "Budsjettert timepris",
        "project.activities.inactive": "Inaktiv",
        "project.activities.updating": "Oppdaterer...",
        "project.activities.adding": "Legger til...",
        "project.activities.summary_title": "Oversikt",
        "project.activities.summary_hours": "Timer (ført / budsjett)",
        "project.activities.summary_activities_done": "Fullførte aktiviteter",
        "project.activities.summary_budget_fee": "Sum budsjettert avgift",
        "project.activities.summary_budget_fee_hint": "Sum av budsjettert avgift på alle aktiviteter (referanse).",
        "project.activities.hours_unit": "t",
        "project.activities.hours_unit_short": "t",
        "project.activities.of_total_budget_hours": "av budsjetterte timer (prosjekt)",
        "project.activities.completed_label": "fullført",
        "project.activities.currency_nok": "kr",
        "project.activities.mode_view": "Lesemodus",
        "project.activities.mode_edit": "Redigeringsmodus",
        "project.activities.status_label": "Status",
        "project.activities.status.open": "Åpen",
        "project.activities.status.in_progress": "Pågår",
        "project.activities.status.completed": "Fullført",
        "project.activities.status.on_hold": "På vent",
        "project.activities.edit_dialog_title": "Aktivitet",
        "project.activities.progress_section": "Fremdrift",
        "project.activities.logged_vs_budget": "{{logged}} t ført · {{budget}} t budsjett",
        "project.activities.of_budget_hours": "av aktivitetens budsjettimer",
        "project.activities.linked_work_orders": "{{count}} tilknyttet(e) arbeidsordre(r)",
        "project.activities.linked_work_orders_label": "Arbeidsordrer på aktiviteten",
        "project.activities.no_description": "Ingen beskrivelse.",
        "project.activities.period": "Periode",
        "project.activities.new_work_order": "Ny arbeidsordre",
        "project.activities.open_work_orders_tab": "Åpne fanen Arbeidsordre",
        "project.activities.open_time_tab": "Åpne timeregistrering",
        "project.activities.logged_short": "Ført",
        "project.activities.status_progress_title": "Status og fremdrift",
        
        // Project Plan translations (Norwegian)
        "project.plan.title": "Prosjektplan",
        "project.plan.subtitle": "Planlegg og administrer prosjekthendelser",
        "project.plan.select_project": "Velg Prosjekt",
        "project.plan.select_project_first": "Vennligst velg et prosjekt først",
        "project.plan.project": "Prosjekt",
        "project.plan.no_events": "Ingen hendelser i denne perioden",
        "project.plan.total": "Totalt",
        "project.plan.loading": "Laster hendelser...",
        "project.plan.week": "Uke",
        "project.plan.resource_capacity": "Ressurskapasitet",
        "project.plan.resource_capacity_subtitle":
          "Sammenligner ressursplanen fra Timer med planlagte prosjekt-eventer og arbeidsordre i valgt periode.",
        "project.plan.loading_resource_plan": "Laster ressursplan...",
        "project.plan.capacity.events": "Eventer",
        "project.plan.capacity.available": "Tilgjengelige",
        "project.plan.capacity.assigned": "Allokert",
        "project.plan.capacity.scheduled_hours": "Arbeidsplantimer",
        "project.plan.capacity.free_hours": "Ledige timer",
        "project.plan.capacity.assigned_of_available": "{{assigned}} av {{available}} ressurser brukt",
        "project.plan.capacity.free_hours_value": "{{hours}} t ledig",
        "project.plan.capacity.events_value": "{{count}} event(er)",
        "No project": "Ingen prosjekt",
        "No activity": "Ingen aktivitet",
        
        // Project Plan Preview translations (Norwegian)
        "project.plan.preview.title": "Prosjektplan",
        "project.plan.preview.subtitle": "Kommende hendelser og plan",
        "project.plan.preview.go_to_full_plan": "Gå til Full Plan",
        "project.plan.preview.loading": "Laster hendelser...",
        "project.plan.preview.error": "Feil ved lasting av hendelser",
        "project.plan.preview.no_events": "Ingen kommende hendelser",
        "project.plan.preview.untitled_event": "Hendelse uten tittel",
        "project.plan.preview.resource": "ressurs",
        "project.plan.preview.resources": "ressurser",
        "project.plan.preview.view_all": "Vis alle {{count}} hendelser",

        "crew.panel.title": "Mannskap og vakt",
        "crew.panel.subtitle": "Dagens plan, fravær og stempling (krever modul «Mannskap og vaktplan» i firmaet)",
        "crew.panel.loading": "Laster mannskap…",
        "crew.panel.error": "Kunne ikke laste mannskap",
        "crew.panel.no_project": "Velg prosjekt for å se mannskap",
        "crew.panel.shifts": "Vakter",
        "crew.panel.absences": "Fravær i dag",
        "crew.panel.open_punches": "Stempling pågår",
        "crew.panel.clock_in": "Stemple inn",
        "crew.panel.clock_out": "Stemple ut",
        "crew.panel.checklists": "Sjekklister",
        "crew.panel.seed_checklists": "Opprett standard sjekklistetyper",
        "crew.panel.hours": "Timeliste",
        "crew.panel.open_full": "Åpne modul",
        "crew.page.kicker": "Planlegging",
        "crew.page.title": "Mannskap og vaktplan",
        "crew.page.subtitle": "Planlegg vakter, håndter tilgjengelighet, stempling, kiosk og lederoversikt",
        "crew.tabs.shifts": "Vaktplan",
        "crew.tabs.mine": "Mine vakter",
        "crew.tabs.availability": "Tilgjengelighet",
        "crew.tabs.punch": "Stempling",
        "crew.tabs.kiosk": "Kiosk",
        "crew.tabs.leader": "Leder",
        "crew.tabs.leader_alerts": "Etterlevelse og varsler",
        "crew.tabs.payroll": "Lønnsgrunnlag",
        "crew.stats.shifts": "Vakter",
        "crew.stats.assignments": "Oppdrag",
        "crew.stats.open_punches": "Åpne stemplinger",
        "crew.stats.alerts": "Varsler",
        "crew.filters.title": "Planfilter",
        "crew.filters.subtitle": "Velg prosjekt, periode og aktiv dag for ukevisningen.",
        "crew.filters.project": "Prosjekt",
        "crew.filters.date": "Dato",
        "crew.filters.period": "Periode",
        "crew.filters.period_from": "Periode fra",
        "crew.filters.period_to": "Periode til",
        "crew.filters.active_day": "Aktiv dag",
        "crew.filters.density": "Visning",
        "crew.filters.days": "dager",
        "crew.filters.this_week": "Denne uken",
        "crew.filters.next_week": "Neste uke",
        "crew.filters.this_month": "Denne måneden",
        "crew.density.cozy": "Luftig",
        "crew.density.compact": "Kompakt",
        "crew.shift.new": "Ny vakt",
        "crew.shift.edit": "Rediger vakt",
        "crew.shift.copy": "Kopier vakt",
        "crew.shift.copy_short": "Kopier",
        "crew.shift.new_short": "Ny vakt",
        "crew.shift.step_info": "Info",
        "crew.shift.step_days_time": "Dager og tid",
        "crew.shift.next_days_time": "Neste: dager og tid",
        "crew.shift.back_info": "Tilbake til info",
        "crew.shift.title": "Tittel",
        "crew.shift.title_hint": "Kort navn som gjør vakten lett å kjenne igjen, f.eks. «Lørdag kveld foodtruck».",
        "crew.shift.title_placeholder": "F.eks. Lørdag kveld foodtruck",
        "crew.shift.role": "Rolle",
        "crew.shift.role_hint": "Hva personen skal gjøre på vakten, f.eks. vaktleder, kjøkken, kasse, servering eller opprydding. Bruk «vaktleder» når personen også skal følge opp sjekklister ved start/slutt.",
        "crew.shift.role_placeholder": "F.eks. Vaktleder",
        "crew.shift.role_suggestions": "Velg rolleforslag eller skriv manuelt",
        "crew.shift.roles.shift_lead": "Vaktleder",
        "crew.shift.roles.cashier": "Kasse",
        "crew.shift.roles.kitchen": "Kjøkken",
        "crew.shift.roles.service": "Servering",
        "crew.shift.roles.runner": "Runner",
        "crew.shift.roles.cleanup": "Opprydding",
        "crew.shift.roles.closing": "Stenging",
        "crew.shift.starts_at": "Start",
        "crew.shift.ends_at": "Slutt",
        "crew.shift.project": "Prosjekt",
        "crew.shift.project_hint": "Knytter vakten til riktig prosjekt. Dette brukes videre ved stempling og timeregistrering slik at timer havner på riktig prosjekt.",
        "crew.shift.location": "Sted",
        "crew.shift.location_hint": "Hvor vakten utføres, f.eks. foodtruck-navn, adresse, arrangement eller avdeling.",
        "crew.shift.location_placeholder": "F.eks. Foodtruck Sentrum",
        "crew.shift.break_minutes": "Pause (min)",
        "crew.shift.break_minutes_hint": "Planlagt pause som trekkes fra planlagte timer.",
        "crew.shift.slots": "Plasser",
        "crew.shift.slots_hint": "Hvor mange personer som trengs på denne vakten.",
        "crew.shift.assignment_mode": "Tildeling",
        "crew.shift.assignment_mode_hint": "Direkte tildeling gir vakten til valgt ansatt. Åpent vakttilbud lar ansatte svare på tilbud.",
        "crew.shift.assignment_direct": "Direkte tildeling",
        "crew.shift.assignment_open": "Åpent vakttilbud",
        "crew.shift.response_deadline": "Svarfrist",
        "crew.shift.response_deadline_hint": "Valgfritt. Etter fristen skjules ubesvarte tilbud for ansatte.",
        "crew.shift.leader_checklist_required": "Krev leder-sjekklister",
        "crew.shift.leader_checklist_required_hint": "Oppretter påkrevde oppstarts- og avslutningssjekklister for vakten. Nyttig for vaktleder i foodtruck, serveringsenhet og serviceteam.",
        "crew.shift.handover_note": "Overleveringsnotat",
        "crew.shift.handover_note_hint": "Viktig informasjon neste leder eller vakt bør se.",
        "crew.shift.assigned_employee": "Ansatt på vakten",
        "crew.shift.assigned_employee_hint": "Valgfritt. Velg ansatt her for å legge personen direkte på alle valgte dager.",
        "crew.shift.month": "Måned",
        "crew.shift.month_hint": "Velg måneden du vil planlegge. Kryss av dagene i kalenderen under.",
        "crew.shift.from_time": "Fra kl.",
        "crew.shift.from_time_hint": "Starttid som brukes på alle valgte dager.",
        "crew.shift.to_time": "Til kl.",
        "crew.shift.to_time_hint": "Sluttid som brukes på alle valgte dager. Hvis slutt er før start, regnes det som nattvakt til neste dag.",
        "crew.shift.single_day": "Én dag",
        "crew.shift.period_days": "Flere dager",
        "crew.shift.period_from": "Periode fra",
        "crew.shift.period_to": "Periode til",
        "crew.shift.weekdays": "Velg ukedager",
        "crew.shift.create_plan": "Opprett vaktplan",
        "crew.shift.copy_plan": "Kopier vaktplan",
        "crew.shift.copy_assignments_hint": "{{count}} mannskap kopieres fra originalvakten hvis du ikke velger en annen ansatt.",
        "crew.shift.overview_month": "Måned",
        "crew.shift.overview_period": "Periode",
        "crew.shift.days_with_shifts": "Dager med vakter",
        "crew.shift.missing_days": "Dager uten plan",
        "crew.shift.planned_hours": "Planlagte timer",
        "crew.shift.month_overview": "Månedsoversikt",
        "crew.shift.month_overview_hint": "Grønne dager har vaktplan. Lyse dager mangler plan.",
        "crew.shift.day_has_shifts": "{{count}} vakt(er)",
        "crew.shift.day_missing": "Mangler plan",
        "crew.shift.day_by_day": "Dag for dag",
        "crew.shift.day_shift_count": "{{count}} vakt(er)",
        "crew.shift.selected_day_timeline": "Tidslinje for valgt dag",
        "crew.shift.no_shifts_selected_day": "Ingen vakter på valgt dag.",
        "crew.shift.add_shift_hint": "Velg en dag i uken eller opprett ny vakt for å fylle planen.",
        "crew.shift.no_role": "Ingen rolle",
        "crew.shift.no_days_selected": "Ingen dager valgt i perioden",
        "crew.shift.ends_after_start": "Slutt må være etter start",
        "crew.shift.no_crew_added": "Ingen mannskap lagt til / sendt vakttilbud",
        "crew.shift.publish": "Publiser",
        "crew.shift.cancel": "Kanseller",
        "crew.shift.cancel_reason": "Årsak til kansellering",
        "crew.assignment.add": "Legg til mannskap",
        "crew.assignment.add_short": "Legg til mannskap",
        "crew.assignment.accept": "Aksepter",
        "crew.assignment.decline": "Avslå",
        "crew.availability.starts_at": "Fra",
        "crew.availability.ends_at": "Til",
        "crew.availability.add_day": "Velg dag",
        "crew.availability.add_day_button": "Legg til dag",
        "crew.availability.add_weekdays": "Legg til ukedager",
        "crew.availability.month": "Måned",
        "crew.availability.remove_day": "Fjern dag",
        "crew.availability.no_days_selected": "Ingen dager valgt",
        "crew.availability.selected_days": "Valgte dager",
        "crew.availability.selected_short": "Valgt",
        "crew.availability.saved_short": "Lagret",
        "crew.availability.from_time": "Fra kl.",
        "crew.availability.to_time": "Til kl.",
        "crew.availability.status": "Status",
        "crew.availability.available": "Tilgjengelig",
        "crew.availability.unavailable": "Ikke tilgjengelig",
        "crew.availability.monthly_overview": "Tilgjengelighet per måned",
        "crew.availability.month_stats": "{{days}} dager · {{hours}} timer tilgjengelig",
        "crew.availability.loading": "Laster…",
        "crew.availability.no_entries": "Ingen tilgjengelighet lagret for valgt periode.",
        "crew.punch.clocked_in": "Du er stemplet inn",
        "crew.punch.choose_shift": "Velg vakt for innstempling, eller stemple inn uten vakt.",
        "crew.punch.clock_in_without_shift": "Stemple inn uten vakt",
        "crew.punch.history": "Stemplingshistorikk",
        "crew.punch.history_date": "Dato",
        "crew.punch.history_in": "Inn",
        "crew.punch.history_out": "Ut",
        "crew.punch.history_hours": "Timer",
        "crew.punch.history_status": "Status",
        "crew.punch.deviation_note": "Avvik / notat",
        "crew.punch.deviation_note_placeholder": "Avvik, manglende sjekklistepunkt eller notat til neste leder...",
        "crew.punch.open": "Åpen",
        "crew.punch.closed": "Lukket",
        "crew.punch.no_history": "Ingen stemplinger i perioden.",
        "crew.kiosk.title": "Kiosk / PIN",
        "crew.kiosk.help": "Bruk felles innlogget enhet og personlig PIN for ansatte.",
        "crew.kiosk.open": "Åpne PIN-verifisering",
        "crew.kiosk.employee_number": "Ansattnummer",
        "crew.kiosk.pin": "PIN",
        "crew.kiosk.verify": "Verifiser",
        "crew.kiosk.verify_title": "Verifiser PIN",
        "crew.kiosk.pin_admin_title": "Administrer ansatt-PIN",
        "crew.kiosk.save_pin": "Lagre PIN",
        "crew.kiosk.clear_pin": "Slett PIN",
        "crew.payroll.planned": "Planlagt",
        "crew.payroll.actual": "Faktisk",
        "crew.empty.shifts": "Ingen vakter i valgt periode.",
        "crew.empty.assignments": "Ingen vakttilbud eller tildelinger.",
        "crew.empty.alerts": "Ingen varsler.",
        "crew.empty.payroll": "Ingen lønnsgrunnlag i perioden.",
        "crew.checklists.handover_title": "Sjekkliste-overlevering",
        "crew.checklists.mark_completed": "Marker fullført",
        "crew.checklists.no_runs": "Ingen påkrevde vaktsjekklister i perioden.",
        "crew.checklists.kind.start": "Oppstart",
        "crew.checklists.kind.end": "Avslutning",
        "crew.checklists.status.pending": "Venter",
        "crew.checklists.status.in_progress": "Pågår",
        "crew.checklists.status.completed": "Fullført",
        "crew.alerts.time_punch_deviation_note": "Avvik/notat fra stempling",
        "crew.alerts.required_shift_checklist_pending": "Påkrevd sjekkliste er ikke fullført",
        "crew.alerts.long_open_punch": "Lang åpen stempling",
        "crew.alerts.planned_shift_missing_break": "Planlagt vakt mangler pause",
        "crew.alerts.high_hours_last_12_months": "Høye faktiske timer siste 12 måneder",
        "crew.toast.saved": "Lagret",
        "crew.toast.assignment_saved": "Mannskap lagt til",
        "crew.toast.pin_verified": "PIN verifisert",
        "crew.toast.pin_saved": "PIN lagret",
        "crew.toast.pin_cleared": "PIN slettet",
        "crew.toast.published": "Vakt publisert",
        "crew.toast.cancelled": "Vakt kansellert",
        "crew.toast.accepted": "Vakt akseptert",
        "crew.toast.declined": "Vakt avslått",
        "crew.toast.availability_saved": "Tilgjengelighet lagret",
        "crew.toast.clocked_in": "Stemplet inn",
        "crew.toast.clocked_out": "Stemplet ut",
        "crew.toast.checklists_seeded": "Sjekklistetyper opprettet",
        "crew.toast.checklist_completed": "Sjekkliste markert fullført",
        "crew.weekdays.monday": "Man",
        "crew.weekdays.tuesday": "Tir",
        "crew.weekdays.wednesday": "Ons",
        "crew.weekdays.thursday": "Tor",
        "crew.weekdays.friday": "Fre",
        "crew.weekdays.saturday": "Lør",
        "crew.weekdays.sunday": "Søn",
        
        // Project Event translations (Norwegian)
        "project.event.create": "Opprett Hendelse",
        "project.event.edit": "Rediger Hendelse",
        "project.event.title": "Tittel",
        "project.event.title_required": "Tittel er påkrevd",
        "project.event.title_placeholder": "Angi hendelsestittel",
        "project.event.description": "Beskrivelse",
        "project.event.description_placeholder": "Angi hendelsesbeskrivelse",
        "project.event.start_date": "Startdato",
        "project.event.start_date_required": "Startdato er påkrevd",
        "project.event.end_date": "Sluttdato",
        "project.event.end_date_invalid": "Sluttdato må være etter startdato",
        "project.event.days": "Dager",
        "project.event.days_placeholder": "Antall dager",
        "project.event.project": "Prosjekt",
        "project.event.work_order": "Arbeidsordre",
        "project.event.resources": "Ressurser (Ansatte)",
        "project.event.add_resource": "Legg til ressurs",
        "project.event.no_resources": "Ingen ressurser lagt til. Legg til ansatte som skal jobbe med denne hendelsen.",
        "project.event.resource": "Ressurs",
        "project.event.resource_employee": "Ansatt",
        "project.event.resource_start_time": "Starttid",
        "project.event.resource_end_time": "Sluttid",
        "project.event.save_error": "En feil oppstod ved lagring av hendelsen. Vennligst prøv igjen.",
        
        // Meeting Minutes translations (Norwegian)
        "meeting_minutes": "Møtereferat",
        "meeting_minutes.list": "Møtereferat",
        "meeting_minutes.new": "Nytt Møtereferat",
        "meeting_minutes.edit": "Rediger Møtereferat",
        "meeting_minutes.create": "Opprett Møtereferat",
        "meeting_minutes.update": "Oppdater Møtereferat",
        "meeting_minutes.delete": "Slett Møtereferat",
        "meeting_minutes.search": "Søk i møtereferat...",
        "meeting_minutes.no_results": "Ingen møtereferat funnet",
        "meeting_minutes.meeting_date": "Møtedato",
        "meeting_minutes.meeting_type": "Møtetype",
        "meeting_minutes.select_type": "Velg møtetype",
        "meeting_minutes.type.employee_interview": "Medarbeidersamtale",
        "meeting_minutes.type.project_meeting": "Prosjektmøte",
        "meeting_minutes.type.other": "Annet møte",
        "meeting_minutes.employee": "Ansatt",
        "meeting_minutes.select_employee": "Velg ansatt",
        "meeting_minutes.participants": "Deltakere",
        "meeting_minutes.select_participants": "Velg deltakere",
        "meeting_minutes.manual_participants": "Manuelle deltakere",
        "meeting_minutes.manual_participants.description": "Legg inn deltakere manuelt (kommaseparert)",
        "meeting_minutes.project": "Prosjekt",
        "meeting_minutes.select_project": "Velg prosjekt",
        "meeting_minutes.title": "Tittel",
        "meeting_minutes.title.required": "Tittel er påkrevd",
        "meeting_minutes.description": "Beskrivelse",
        "meeting_minutes.groups": "Grupper",
        "meeting_minutes.add_group": "Legg til Gruppe",
        "meeting_minutes.group.title": "Gruppetittel",
        "meeting_minutes.group.title.required": "Gruppetittel er påkrevd",
        "meeting_minutes.group.description": "Gruppebeskrivelse",
        "meeting_minutes.group.entries": "Innlegg",
        "meeting_minutes.group.add_entry": "Legg til Innlegg",
        "meeting_minutes.entry.description": "Beskrivelse",
        "meeting_minutes.entry.description.required": "Beskrivelse er påkrevd",
        "meeting_minutes.entry.deadline": "Frist",
        "meeting_minutes.entry.responsible": "Ansvarlig",
        "meeting_minutes.entry.select_responsible": "Velg ansvarlig person",
        "meeting_minutes.meeting_number": "Møte #",
        "meeting_minutes.continue_meeting": "Fortsett Møte",
        "meeting_minutes.continue_meeting.description": "Fortsett på samme møtereferat (oppretter nytt møte-innlegg)",
        "meeting_minutes.continue_success": "Møte fortsatt vellykket",
        "meeting_minutes.continue_error": "Kunne ikke fortsette møte",
        "meeting_minutes.basic_info": "Grunnleggende informasjon",
        "meeting_minutes.templates": "Maler",
        "meeting_minutes.templates.list": "Maler",
        "meeting_minutes.templates.new": "Ny Mal",
        "meeting_minutes.templates.edit": "Rediger Mal",
        "meeting_minutes.templates.create": "Opprett Mal",
        "meeting_minutes.templates.update": "Oppdater Mal",
        "meeting_minutes.templates.delete": "Slett Mal",
        "meeting_minutes.templates.search": "Søk i maler...",
        "meeting_minutes.templates.no_results": "Ingen maler funnet",
        "meeting_minutes.templates.use_template": "Bruk Mal",
        "meeting_minutes.templates.copy_from": "Kopier fra tidligere møte",
        "meeting_minutes.templates.select_template": "Velg Mal",
        "meeting_minutes.created": "Møtereferat opprettet",
        "meeting_minutes.updated": "Møtereferat oppdatert",
        "meeting_minutes.deleted": "Møtereferat slettet",
        "meeting_minutes.delete_confirm": "Er du sikker på at du vil slette dette møtereferatet?",
        "meeting_minutes.meetings": "Møter",
        "meeting_minutes.create_error": "Kunne ikke opprette møtereferat",
        "meeting_minutes.update_error": "Kunne ikke oppdatere møtereferat",
        "meeting_minutes.delete_error": "Kunne ikke slette møtereferat",
        "meeting_minutes.load_error": "Kunne ikke laste møtereferat",
        "meeting_minutes.template.created": "Mal opprettet",
        "meeting_minutes.template.updated": "Mal oppdatert",
        "meeting_minutes.template.deleted": "Mal slettet",
        "meeting_minutes.template.create_error": "Kunne ikke opprette mal",
        "meeting_minutes.template.update_error": "Kunne ikke oppdatere mal",
        "meeting_minutes.template.delete_error": "Kunne ikke slette mal",
        "meeting_minutes.template.delete_confirm": "Er du sikker på at du vil slette denne malen?",
        "meeting_minutes.template.load_error": "Kunne ikke laste mal",
        "meeting_minutes.add_meeting": "Legg til Møte",
        "meeting_minutes.add_first_meeting": "Legg til Første Møte",
        "meeting_minutes.no_meetings": "Ingen møter ennå",
        "meeting_minutes.points": "punkter",
        "meeting_minutes.add_point": "Legg til Punkt",
        "meeting_minutes.point.title": "Punktittel",
        "meeting_minutes.point.description": "Punktbeskrivelse",
        "meeting_minutes.point.untitled": "Uten tittel",
        "meeting_minutes.point.create_error": "Kunne ikke opprette punkt",
        "meeting_minutes.point.update_error": "Kunne ikke oppdatere punkt",
        "meeting_minutes.point.delete_error": "Kunne ikke slette punkt",
        "meeting_minutes.point.delete_confirm": "Er du sikker på at du vil slette dette punktet?",
        "meeting_minutes.entry.add": "Legg til Innlegg",
        "meeting_minutes.entry.remove": "Fjern",
        "meeting_minutes.entry.create_error": "Kunne ikke opprette innlegg",
        "meeting_minutes.entry.update_error": "Kunne ikke oppdatere innlegg",
        "meeting_minutes.entry.delete_error": "Kunne ikke slette innlegg",
        "meeting_minutes.entry.delete_confirm": "Er du sikker på at du vil slette dette innlegget?",
        "meeting_minutes.meeting.created": "Møte opprettet",
        "meeting_minutes.meeting.create_error": "Kunne ikke opprette møte",
        "meeting_minutes.meeting.load_error": "Kunne ikke laste møte",
        "meeting_minutes.meeting.finished": "Ferdig",
        "meeting_minutes.meeting.mark_finished": "Merk som Ferdig",
        "meeting_minutes.meeting.marked_finished": "Møte merket som ferdig",
        "meeting_minutes.meeting.mark_finished_error": "Kunne ikke merke møte som ferdig",
        "meeting_minutes.meeting.no_points": "Ingen punkter lagt til ennå",
        "meeting_minutes.meeting.no_points_add_first": "Ingen punkter lagt til ennå. Legg til ditt første punkt for å komme i gang.",
        "meeting_minutes.meeting.copy_options": "Kopieringsalternativer",
        "meeting_minutes.meeting.copy_from_previous": "Kopier fra Forrige Møte",
        "meeting_minutes.meeting.no_copy": "Ikke kopier",
        "meeting_minutes.meeting.or": "ELLER",
        "meeting_minutes.meeting.no_template": "Ikke bruk mal",
        "meeting_minutes.employee.add_manual": "Legg til Manuell Deltaker",
        "meeting_minutes.employee.manual_name": "Navn",
        "meeting_minutes.employee.manual_email": "E-post",
        "meeting_minutes.employee.manual_mobile": "Mobil",
        "meeting_minutes.employee.remove": "Fjern",
        "meeting_minutes.meetings_created_separately": "Møter opprettes separat. Gå til møtelisten for å legge til nye møter.",
        "meeting_minutes.group.update_error": "Kunne ikke oppdatere gruppe",
        "meeting_minutes.group.delete_confirm": "Er du sikker på at du vil slette denne gruppen?",
        "meeting_minutes.group.deleted": "Gruppe slettet",
        "meeting_minutes.group.delete_error": "Kunne ikke slette gruppe",
        "meeting_minutes.group.delete": "Slett Gruppe",
        "meeting_minutes.group.documents": "Gruppedokumenter",
        "meeting_minutes.entry.documents": "Innleggsdokumenter",
        "meeting_minutes.changes_saved": "Endringer lagret",
        "meeting_minutes.from_previous_meeting": "Fra Forrige Møte",
        "meeting_minutes.read_only_reference": "Skrivebeskyttet referanse",
        "meeting_minutes.collapse": "Skjul",
        "meeting_minutes.expand": "Vis",
        "meeting_minutes.entry.singular": "punkt",
        "meeting_minutes.entry.plural": "punkter",
        "meeting_minutes.image.uploaded": "{{count}} bilde(r) lastet opp",
        "meeting_minutes.others_editing": "Andre redigerer dette møtet. Endringer kan bli overskrevet.",
        "meeting_minutes.point.edit": "Rediger Punkt",
        "meeting_minutes.group.created": "Gruppe opprettet",
        "meeting_minutes.group.updated": "Gruppe oppdatert",
        "Saving...": "Lagrer...",
        "Update": "Oppdater",
        "Create": "Opprett",
        
        // Drawings translations (Norwegian)
        "drawings": "Tegninger",
        "drawings.list": "Tegninger",
        "drawings.new": "Ny Tegning",
        "drawings.edit": "Rediger Tegning",
        "drawings.create": "Opprett Tegning",
        "drawings.update": "Oppdater Tegning",
        "drawings.delete": "Slett Tegning",
        "drawings.search": "Søk i tegninger...",
        "drawings.no_results": "Ingen tegninger funnet",
        "drawings.title": "Tittel",
        "drawings.title.required": "Tittel er påkrevd",
        "drawings.description": "Beskrivelse",
        "drawings.project": "Prosjekt",
        "drawings.select_project": "Velg prosjekt",
        "drawings.floor": "Etasje",
        "drawings.floor.placeholder": "Angi etasjenummer eller navn",
        "drawings.house": "Hus",
        "drawings.house.placeholder": "Angi husnummer eller identifikator",
        "drawings.document": "Tegningsdokument",
        "drawings.document.required": "Tegningsdokument er påkrevd",
        "drawings.created": "Tegning opprettet",
        "drawings.updated": "Tegning oppdatert",
        "drawings.save_changes": "Lagre endringer",
        "drawings.no_changes": "Ingen endringer å lagre",
        "drawings.deleted": "Tegning slettet",
        "drawings.delete_confirm": "Er du sikker på at du vil slette denne tegningen?",
        "drawings.create_error": "Kunne ikke opprette tegning",
        "drawings.update_error": "Kunne ikke oppdatere tegning",
        "drawings.delete_error": "Kunne ikke slette tegning",
        "drawings.load_error": "Kunne ikke laste tegning",
        "drawings.module.add": "Legg til Modul",
        "drawings.module.arrow": "Pil",
        "drawings.module.circle": "Sirkel",
        "drawings.module.rectangular": "Rektangel",
        "drawings.module.delete": "Slett Modul",
        "drawings.module.delete_confirm": "Er du sikker på at du vil slette denne modulen?",
        "drawings.module.color": "Farge",
        "drawings.module.filled": "Fylt",
        "drawings.module.not_filled": "Ikke fylt",
        "drawings.module.move": "Flytt Modul",
        "Bruker som håndterer egenmelding": "Bruker som håndterer fravær",
        "Velg administrator": "Velg administrator",
        "Velg en administrator som skal håndtere egenmeldinger": "Velg en administrator som skal håndtere fravær",

        // Microsoft / Outlook
        "microsoft.explain.title": "Hva betyr tilkoblingen?",
        "microsoft.explain.company.1":
          "Kobler firmas hoved e-post (f.eks. post@firma.no) til Microsoft slik at Promang kan lese og håndtere innkommende e-post for saker.",
        "microsoft.explain.company.2": "Gir grunnlag for å opprette og oppdatere saker fra e-posttråder.",
        "microsoft.explain.company.3":
          "Krever admin-rettigheter og samtykke i Microsoft for den valgte postkassen.",
        "microsoft.explain.company.4":
          "Hemmeligheter og token-utveksling skjer kun i Promang API — ikke i nettleseren.",
        "microsoft.explain.company.5":
          "Sende e-post og AI-funksjoner mot firmamail kommer når lagring av tokens er ferdig på server.",
        "microsoft.explain.user.1":
          "Kobler din egen Microsoft / Outlook-konto til Promang-brukeren du er innlogget som.",
        "microsoft.explain.user.2":
          "Gjør det mulig å sende e-post fra din adresse der det er aktivert i Promang, og å bruke AI/kontekst fra din mail.",
        "microsoft.explain.user.3": "Du må være innlogget i Promang før du trykker «Koble til Microsoft».",
        "microsoft.explain.user.4": "E-postadressen i Microsoft bør samsvare med brukeren din der det er praktisk mulig.",
        "microsoft.explain.user.5":
          "Du kan når som helst koble fra under Innstillinger eller på siden Microsoft / Outlook.",
        "microsoft.company.page_title": "Microsoft — firmamail",
        "microsoft.company.page_subtitle": "Koble hoved e-post for selskapet (admin).",
        "microsoft.company.card_title": "Firmamail (Microsoft 365)",
        "microsoft.company.subtitle": "For felles innboks og saker på vegne av bedriften.",
        "microsoft.user.page_title": "Microsoft / Outlook",
        "microsoft.user.page_subtitle": "Koble din Microsoft-konto til denne Promang-brukeren.",
        "microsoft.user.card_title": "Din Outlook-konto",
        "microsoft.user.subtitle":
          "E-post sendes fra din konto når dette er støttet; gir også kontekst til AI og saker.",
        "microsoft.user.settings_section_title": "Microsoft / Outlook",
        "microsoft.user.settings_section_intro":
          "Koble Microsoft til kontoen du er innlogget med. Dette er ikke det samme som «Logg inn med Microsoft» på innloggingssiden — her forblir du i Promang og gir tilgang til e-post for funksjoner i dashbordet.",
        "microsoft.user.open_full_page": "Åpne egen side for tilkobling",
        "microsoft.user.calendar_heading": "Kalender for hendelser",
        "microsoft.user.calendar_intro":
          "Alle kalendere du har tilgang til i Outlook for denne kontoen vises (egne og delte). Velg hvor Promang skal opprette hendelser. Bruk søk hvis du har mange kalendere.",
        "microsoft.user.calendar_refresh": "Hent kalendere",
        "microsoft.user.calendar_need_refresh":
          "Koble til Microsoft med refresh-token (full tilkobling) for å hente kalendere.",
        "microsoft.user.calendar_select_label": "Kalender",
        "microsoft.user.calendar_none": "Ingen valgt",
        "microsoft.user.calendar_choose": "Søk …",
        "microsoft.user.calendar_modal_title": "Velg kalender",
        "microsoft.user.calendar_modal_close": "Lukk",
        "microsoft.user.calendar_modal_hint":
          "Søk på navn eller eiers e-post. Delte kalendere merkes; skrivebeskyttede kan ikke lagres for hendelsessynk.",
        "microsoft.user.calendar_search_placeholder": "Søk i kalendere …",
        "microsoft.user.calendar_search_empty": "Ingen kalendere matcher søket.",
        "microsoft.user.calendar_modal_empty": "Microsoft returnerte ingen kalendere.",
        "microsoft.user.calendar_badge_own": "Din",
        "microsoft.user.calendar_badge_shared": "Delt",
        "microsoft.user.calendar_badge_readonly": "Skrivebeskyttet",
        "microsoft.user.calendar_readonly_hint":
          "Denne kalenderen er skrivebeskyttet i Microsoft. Velg en du kan redigere for å synke hendelser.",
        "microsoft.user.calendar_readonly_save":
          "Kan ikke lagre en skrivebeskyttet kalender for hendelser. Velg en kalender du kan redigere.",
        "microsoft.user.calendar_current": "Tidligere valgt: {{name}}{{email}}",
        "microsoft.user.calendar_save": "Lagre kalender",
        "microsoft.user.calendar_saved": "Kalender lagret.",
        "microsoft.user.calendar_save_failed": "Kunne ikke lagre kalender.",
        "microsoft.user.calendar_load_failed": "Kunne ikke hente kalendere.",
        "microsoft.user.personal_mail_ai.title": "Din postkasse — AI-regler og behandling",
        "microsoft.user.personal_mail_ai.intro":
          "Sett sortering, manuelle regler, AI-ruting og kjør behandling på den koblede Microsoft-postkassen din — samme valg som delte firmainnbokser. Saker og kunder opprettes i gjeldende firma.",
        "microsoft.user.personal_mail_ai.no_permission":
          "Rollen din inkluderer ikke personleg innboks-AI. Be administrator tildele rollen «microsoft_personal_mail_ai» for dette firmaet eller gi deg admin-tilgang.",
        "microsoft.user.personal_mail_ai.forbidden_toast": "Du har ikke tilgang til disse innstillingene.",
        "microsoft.user.personal_mail_ai.load_failed": "Kunne ikke hente innstillinger for e-post-AI.",
        "microsoft.user.personal_mail_ai.no_refresh":
          "Koble Microsoft med refresh-token (full e-posttilkobling) for å hente meldinger og kjøre behandling.",
        "microsoft.user.personal_mail_ai.connect_first":
          "Koble Microsoft over for å sette opp regler, AI-ruting og behandling for din egen postkasse.",
        "microsoft.status.loading": "Laster status…",
        "microsoft.status.api_pending":
          "API for lagring av tokens er under utrulling. Du kan fortsatt fullføre innlogging hos Microsoft; kontakt admin hvis noe feiler.",
        "microsoft.status.connected": "Tilkoblet",
        "microsoft.action.disconnect": "Koble fra",
        "microsoft.action.connect_microsoft": "Koble til Microsoft",
        "microsoft.action.redirect_hint":
          "Du sendes til Microsoft for å godkjenne tilgang, deretter tilbake til Promang.",
        "microsoft.toast.login_required": "Du må være innlogget i Promang for å koble til.",
        "microsoft.toast.missing_env": "Microsoft er ikke konfigurert på serveren.",
        "microsoft.toast.start_failed": "Kunne ikke starte Microsoft-tilkobling.",
        "microsoft.toast.disconnected": "Frakoblet.",
        "microsoft.toast.disconnect_failed": "Kunne ikke koble fra.",
        "microsoft.callback.working": "Fullfører tilkobling…",
        "microsoft.callback.error_microsoft": "Microsoft avbrøt eller feilet.",
        "microsoft.callback.missing_params": "Mangler code eller state fra Microsoft.",
        "microsoft.callback.success_login": "Innlogget med Microsoft.",
        "microsoft.callback.success_link": "Microsoft-konto er koblet.",
        "microsoft.callback.api_not_ready": "API er ikke klar for dette steget ennå.",
        "microsoft.callback.exchange_failed": "Kunne ikke fullføre tilkoblingen.",
        "microsoft.callback.unknown_intent": "Ukjent tilkoblingstype.",
        "microsoft.callback.title": "Microsoft og Promang",
        "microsoft.callback.subtitle_loading":
          "Fullfører sikker tilkobling. Dette tar vanligvis noen sekunder.",
        "microsoft.callback.success_title": "Tilkobling fullført",
        "microsoft.callback.error_title": "Noe gikk galt",
        "microsoft.callback.redirecting_note": "Sender deg tilbake til Promang …",
        "microsoft.callback.continue_now": "Gå til Promang nå",
        "microsoft.callback.back_to_promang": "Tilbake til Promang",
        "microsoft.callback.back_to_login": "Tilbake til innlogging",
        "microsoft.callback.debug_heading": "Teknisk detalj (feilsøking)",
        "microsoft.callback.wait_hint": "Lukk ikke denne fanen mens vi fullfører.",
        "microsoft.login.or": "eller",
        "microsoft.login.redirecting": "Omdirigerer…",
        "microsoft.login.with_microsoft": "Logg inn med Microsoft",
        "microsoft.test_mail.button": "Send test-e-post til meg selv",
        "microsoft.test_mail.hint":
          "Sender én melding fra den koblede postkassen til samme adresse, for å verifisere Mail.Send og token.",
        "microsoft.test_mail.success": "Test-e-post er sendt. Sjekk innboksen.",
        "microsoft.test_mail.failed": "Kunne ikke sende test-e-post.",
        "microsoft.ai_mailboxes.title": "Delte innbokser for AI",
        "microsoft.ai_mailboxes.admin_page_title": "Delte innbokser (Microsoft 365)",
        "microsoft.ai_mailboxes.admin_page_subtitle":
          "Registrer delte adresser, koble Microsoft, vis innboks og sett hvordan e-post skal behandles (sortering, saker, arkiv, autosvar, signatur og regler). Behandling og valgfri arkivering til Archive/Arkiv kjører når du slår på jobben eller «Kjør behandling» (ikke simulering).",
        "microsoft.ai_mailboxes.intro":
          "Registrer delte adresser (f.eks. post@, service@). Hver postkasse må kobles mot Microsoft slik at Promang kan lese innboks og sende test via Graph.",
        "microsoft.ai_mailboxes.how_link_works":
          "Du logger inn som deg selv (f.eks. cs@airon.no) — ikke som den delte adressen. Delt postkasse (f.eks. post@airon.no) har vanligvis ikke eget passord. Bruk en konto som allerede kan åpne post@ i Outlook (full tilgang / delegat). Promang lagrer refresh-token for innloggingen; Graph henter/sender for adressen du registrerte på raden.",
        "microsoft.ai_mailboxes.mail_safety_dev_notice":
          "Med **Arkiver etter behandling** på flytter Promang behandlede meldinger til mappen **Archive** eller **Arkiv** (Graph), også i utvikling — bare når behandling kjøres med ekte handlinger (ikke simulering). Ellers leser vi innboks til visning. «Kjør behandling», planlagt jobb og test kan sende e-post (f.eks. videresending) via Graph — bruk «Simuler jobb» for å teste uten sending og uten flytting.",
        "microsoft.ai_mailboxes.linked_as": "Microsoft koblet som {{email}}",
        "microsoft.ai_mailboxes.not_linked": "Ikke koblet til Microsoft — koble til for å laste innboks og sende test.",
        "microsoft.ai_mailboxes.connect_microsoft": "Koble Microsoft",
        "microsoft.ai_mailboxes.disconnect_microsoft": "Koble fra Microsoft",
        "microsoft.ai_mailboxes.send_test": "Send test-e-post",
        "microsoft.ai_mailboxes.go_to_mailbox": "Gå til postkasse",
        "microsoft.ai_mailboxes.go_to_mailbox_hint":
          "Åpner Outlook på nett for denne adressen i ny fane (mapper: innboks, arkiv, osv.). Du må være innlogget i Microsoft i nettleseren med en konto som har tilgang til postkassen.",
        "microsoft.ai_mailboxes.go_to_mailbox_missing_email": "Ingen postadresse å åpne.",
        "microsoft.ai_mailboxes.multi_inbox_hint":
          "Du kan ha flere innbokser utvidet samtidig. Åpne en melding i Promang for å lese innhold og se behandlingslogg i faner.",
        "microsoft.ai_mailboxes.reader.title": "Melding (Promang)",
        "microsoft.ai_mailboxes.reader.close": "Lukk",
        "microsoft.ai_mailboxes.reader.tab_message": "Innhold",
        "microsoft.ai_mailboxes.reader.tab_reply_draft": "AI svarutkast",
        "microsoft.ai_mailboxes.reader.tab_logs": "Behandlingslogg",
        "microsoft.ai_mailboxes.reader.reply_draft_hint":
          "Redigerer utkastet i Outlook (HTML). Når du sender derfra, blir tråden under teksten din bevart.",
        "microsoft.ai_mailboxes.reader.reply_draft_load_failed": "Kunne ikke laste svarutkast.",
        "microsoft.ai_mailboxes.reader.reply_draft_saved": "Utkast lagret.",
        "microsoft.ai_mailboxes.reader.reply_draft_save": "Lagre utkast",
        "microsoft.ai_mailboxes.reader.reply_draft_saving": "Lagrar…",
        "microsoft.ai_mailboxes.reader.reply_draft_none": "Ingen AI svarutkast for denne meldinga.",
        "microsoft.ai_mailboxes.reader.field_from": "Fra",
        "microsoft.ai_mailboxes.reader.field_to": "Til",
        "microsoft.ai_mailboxes.reader.field_cc": "Kopi",
        "microsoft.ai_mailboxes.reader.field_date": "Mottatt",
        "microsoft.ai_mailboxes.reader.attachments_notice":
          "Meldingen har vedlegg. Filer vises ikke her — bruk Outlook på nett hvis du må laste ned.",
        "microsoft.ai_mailboxes.reader.body_iframe_title": "E-postinnhold",
        "microsoft.ai_mailboxes.reader.no_body": "Ingen brødtekst.",
        "microsoft.ai_mailboxes.reader.load_failed": "Kunne ikke laste melding.",
        "microsoft.ai_mailboxes.reader.inbox_only_hint":
          "Listen over viser bare innboks. For arkiv, søppelpost og andre mapper, bruk Outlook på nett (lenke under) ved behov.",
        "microsoft.ai_mailboxes.reader.folder_hint":
          "Du kan velge Arkiv, Sendt og andre mapper i postkasselisten over. Bruk Outlook på nett (lenke under) for full mappehåndtering ved behov.",
        "microsoft.ai_mailboxes.reader.open_in_owa": "Åpne postkasse i Outlook på nett…",
        "microsoft.ai_mailboxes.reader.open_short": "Åpne",
        "microsoft.ai_mailboxes.reader.open_tooltip":
          "Åpne i Promang: les e-post og se behandlingslogg (faner).",
        "microsoft.ai_mailboxes.show_inbox": "E-postmapper",
        "microsoft.ai_mailboxes.inbox_requires_link": "Koble Microsoft for denne adressen først.",
        "microsoft.ai_mailboxes.no_messages": "Ingen meldinger i denne mappen (eller mappen er tom).",
        "microsoft.ai_mailboxes.messages_failed": "Kunne ikke laste meldinger for denne mappen.",
        "microsoft.ai_mailboxes.process_folder_hint":
          "Velg meldinger under, og simuler eller kjør behandling. Den planlagte jobben behandler fortsatt bare innboksen med mindre det endres separat.",
        "microsoft.ai_mailboxes.folder.select_label": "Mappe",
        "microsoft.ai_mailboxes.folder.group_shortcuts": "Snarveier",
        "microsoft.ai_mailboxes.folder.group_tree": "Alle mapper",
        "microsoft.ai_mailboxes.folder.loading_tree": "Laster mappeliste…",
        "microsoft.ai_mailboxes.folder.folders_failed": "Kunne ikke laste mappeliste.",
        "microsoft.ai_mailboxes.folder.seg_inbox": "Innboks",
        "microsoft.ai_mailboxes.folder.seg_archive": "Arkiv",
        "microsoft.ai_mailboxes.folder.seg_sentitems": "Sendt",
        "microsoft.ai_mailboxes.folder.seg_deleteditems": "Slettet",
        "microsoft.ai_mailboxes.folder.seg_junkemail": "Søppelpost",
        "microsoft.ai_mailboxes.folder.seg_drafts": "Kladd",
        "microsoft.ai_mailboxes.folder.seg_outbox": "Utboks",
        "microsoft.ai_mailboxes.col.received": "Mottatt",
        "microsoft.ai_mailboxes.col.from": "Fra",
        "microsoft.ai_mailboxes.col.subject": "Emne",
        "microsoft.ai_mailboxes.microsoft_disconnected": "Microsoft er frakoblet for denne postkassen.",
        "microsoft.ai_mailboxes.microsoft_disconnect_failed": "Kunne ikke koble fra Microsoft.",
        "microsoft.ai_mailboxes.shared_test_ok": "Test-e-post er sendt.",
        "microsoft.ai_mailboxes.shared_test_failed": "Kunne ikke sende test-e-post.",
        "microsoft.ai_mailboxes.email_label": "E-postadresse",
        "microsoft.ai_mailboxes.email_placeholder": "post@firma.no",
        "microsoft.ai_mailboxes.add": "Legg til",
        "microsoft.ai_mailboxes.empty": "Ingen adresser er lagt til ennå.",
        "microsoft.ai_mailboxes.remove": "Fjern",
        "microsoft.ai_mailboxes.added": "Adressen er lagt til.",
        "microsoft.ai_mailboxes.add_failed": "Kunne ikke legge til adressen.",
        "microsoft.ai_mailboxes.removed": "Adressen er fjernet.",
        "microsoft.ai_mailboxes.remove_failed": "Kunne ikke fjerne adressen.",
        "microsoft.ai_mailboxes.load_failed": "Kunne ikke laste adresser.",
        "microsoft.ai_mailboxes.email_required": "Skriv inn en e-postadresse.",
        "microsoft.ai_mailboxes.settings.toggle": "Innstillinger",
        "microsoft.ai_mailboxes.settings.heading": "Behandling av e-post",
        "microsoft.ai_mailboxes.settings.intro":
          "Disse valgene gjelder kun denne postkassen. Innbokslisten bruker sortering fra Graph med én gang.",
        "microsoft.ai_mailboxes.settings.processing_job_title": "Jobb: behandle innboks",
        "microsoft.ai_mailboxes.settings.processing_job_hint":
          "Når «På» er valgt og lagret, kan planlagt jobb (f.eks. Heroku Scheduler + `rake microsoft:enqueue_ai_mailbox_processing`) behandle opptil 50 siste meldinger og kjøre regler (inkl. videresending som tekstvarsel). Test uten risiko med «Simuler jobb» i innbokslisten.",
        "microsoft.ai_mailboxes.settings.processing_job_off": "Av",
        "microsoft.ai_mailboxes.settings.processing_job_on": "På",
        "microsoft.ai_mailboxes.settings.mail_sort": "Sortering i innboks",
        "microsoft.ai_mailboxes.settings.sort_received_desc": "Nyeste først",
        "microsoft.ai_mailboxes.settings.sort_received_asc": "Eldste først",
        "microsoft.ai_mailboxes.settings.sort_subject_asc": "Emne A–Å",
        "microsoft.ai_mailboxes.settings.auto_create_case": "Opprett sak for nye e-poster (når aktivert i Promang)",
        "microsoft.ai_mailboxes.settings.auto_create_case_hint":
          "Når funksjonen rulleres ut, brukes unntakene under for å unngå saker fra reklame, nyhetsbrev osv.",
        "microsoft.ai_mailboxes.settings.skip_promotional_hint": "Marker e-poster som sannsynlig reklame/nyhetsbrev som ikke skal bli sak (anbefalt)",
        "microsoft.ai_mailboxes.settings.ignore_subject_keywords": "Ikke opprett sak hvis emne inneholder (komma eller ny linje)",
        "microsoft.ai_mailboxes.settings.ignore_subject_placeholder": "f.eks. reklame, unsubscribe, newsletter",
        "microsoft.ai_mailboxes.settings.ignore_from_domains": "Ikke opprett sak hvis avsenderdomene er (komma eller ny linje)",
        "microsoft.ai_mailboxes.settings.ignore_domains_placeholder": "f.eks. mailchimp.com, sendgrid.net",
        "microsoft.ai_mailboxes.settings.archive_after_processing": "Arkiver etter behandling",
        "microsoft.ai_mailboxes.settings.archive_hint":
          "Flytter behandlet e-post fra innboks til **Archive** eller **Arkiv** via Microsoft Graph etter vellykket behandling (manuell regel eller AI). Gjelder også utvikling — krever at du kjører behandling med ekte handlinger, ikke «Simuler jobb».",
        "microsoft.ai_mailboxes.settings.auto_reply_enabled": "Automatisk svar etter ny sak (kundehenvendelse)",
        "microsoft.ai_mailboxes.settings.auto_reply_body_ph":
          "HTML-innhold (valgfritt). Plassholdere: %{case_number}, %{sak}. Tomt felt gir standardtekst med saksnummer.",
        "microsoft.ai_mailboxes.settings.auto_reply_note":
          "Når autosvar er på, svarer Promang i samme e-posttråd (Graph reply), ikke som ny melding. Emnelinjen på svaret får [SAK-<nummer>]. Signatur HTML legges ved om satt.",
        "microsoft.ai_mailboxes.settings.signature_html": "Signatur (HTML)",
        "microsoft.ai_mailboxes.settings.signature_ph": "<p>Med vennlig hilsen<br/>…</p>",
        "microsoft.ai_mailboxes.settings.rules_heading": "Regler",
        "microsoft.ai_mailboxes.settings.rules_intro":
          "Ekstra regler (f.eks. «hopp over sak» eller «send kopi til adresse») som Promang kan bruke når innboks-jobben er på plass. Match er enkel tekstsjekk.",
        "microsoft.ai_mailboxes.settings.rules_forward_hint":
          "Videresending lagres som innstilling; under utvikling sendes ingen e-post automatisk fra jobben ennå.",
        "microsoft.ai_mailboxes.settings.add_rule": "Legg til regel",
        "microsoft.ai_mailboxes.settings.no_rules": "Ingen egendefinerte regler ennå.",
        "microsoft.ai_mailboxes.settings.rule_name": "Navn",
        "microsoft.ai_mailboxes.settings.rule_match": "Match",
        "microsoft.ai_mailboxes.settings.rule_value": "Verdi",
        "microsoft.ai_mailboxes.settings.rule_action": "Handling",
        "microsoft.ai_mailboxes.settings.rule_on": "På",
        "microsoft.ai_mailboxes.settings.remove_rule": "Fjern regel",
        "microsoft.ai_mailboxes.settings.match_subject_contains": "Emne inneholder",
        "microsoft.ai_mailboxes.settings.match_subject_equals": "Emne er lik (eksakt)",
        "microsoft.ai_mailboxes.settings.match_from_domain": "Fra-domene",
        "microsoft.ai_mailboxes.settings.match_from_contains": "Fra-adresse inneholder",
        "microsoft.ai_mailboxes.settings.action_skip_case": "Ikke opprett sak",
        "microsoft.ai_mailboxes.settings.action_forward_to": "Send kopi / videresend til e-post",
        "microsoft.ai_mailboxes.settings.rule_forward_to_email": "Send til (e-post)",
        "microsoft.ai_mailboxes.settings.rule_forward_to_placeholder": "f.eks. 123@airon.no",
        "microsoft.ai_mailboxes.settings.save": "Lagre innstillinger",
        "microsoft.ai_mailboxes.settings.saved": "Innstillinger lagret.",
        "microsoft.ai_mailboxes.settings.save_failed": "Kunne ikke lagre innstillinger.",
        "microsoft.ai_mailboxes.settings.ai_routing_heading": "AI-ruting",
        "microsoft.ai_mailboxes.settings.ai_routing_hint":
          "Velg hva som skal skje per type e-post. Innstillingene lagres som JSON i bakgrunnen. Når ruting er på, brukes OpenAI/Grok (miljøvariabler) til klassifisering om tilgjengelig — ellers heuristikk. Manuelle regler overstyrrer AI-handlinger.",
        "microsoft.ai_mailboxes.settings.ai_routing_invalid_json": "Ugyldig JSON i AI-ruting.",
        "microsoft.ai_mailboxes.settings.ai_routing_raw_json": "Rediger som rå JSON (avansert)",
        "microsoft.ai_mailboxes.settings.ai_routing_raw_json_hint":
          "Skjema og JSON er det samme. Slår du av rå JSON igjen, leses teksten inn i skjemaet (må være gyldig JSON).",
        "microsoft.ai_mailboxes.ai_routing.master_enable": "Aktiver AI-ruting og automatiske handlinger",
        "microsoft.ai_mailboxes.ai_routing.master_hint":
          "Når av: meldinger klassifiseres fortsatt for visning, men ingen automatiske AI-handlinger kjøres.",
        "microsoft.ai_mailboxes.ai_routing.reply_draft_title": "AI-utkast for svar (Outlook)",
        "microsoft.ai_mailboxes.ai_routing.reply_draft_desc":
          "Etter vellykket kundehenvendelse eller sakssvar opprettes et svarutkast i postkassen din i Microsoft. Du sender selv når du er fornøyd.",
        "microsoft.ai_mailboxes.ai_routing.reply_draft_enable": "Opprett AI-generert svarutkast ved behandling",
        "microsoft.ai_mailboxes.ai_routing.reply_draft_requires_ai":
          "Slå på «Aktiver AI-ruting» over for å bruke denne funksjonen (klassifisering og sak må kjøre først).",
        "microsoft.ai_mailboxes.ai_routing.provider_label": "Klassifiseringsmotor",
        "microsoft.ai_mailboxes.ai_routing.provider_chatgpt": "ChatGPT (OpenAI)",
        "microsoft.ai_mailboxes.ai_routing.provider_grok": "Grok (xAI)",
        "microsoft.ai_mailboxes.ai_routing.model_label": "Modell (valgfritt)",
        "microsoft.ai_mailboxes.ai_routing.model_placeholder": "f.eks. gpt-4o-mini",
        "microsoft.ai_mailboxes.ai_routing.model_hint": "Tom = standard fra server/miljø.",
        "microsoft.ai_mailboxes.ai_routing.action_label": "Handling",
        "microsoft.ai_mailboxes.ai_routing.action_none": "Ingenting (kun klassifiser)",
        "microsoft.ai_mailboxes.ai_routing.action_forward": "Videresend til e-post",
        "microsoft.ai_mailboxes.ai_routing.action_move_archive": "Flytt til arkivmappe",
        "microsoft.ai_mailboxes.ai_routing.action_move_junk": "Flytt til søppelpost",
        "microsoft.ai_mailboxes.ai_routing.action_delete_graph": "Slett i Microsoft (Graph)",
        "microsoft.ai_mailboxes.ai_routing.action_move_folder": "Flytt til valgt mappe",
        "microsoft.ai_mailboxes.ai_routing.action_create_case": "Opprett sak i Promang",
        "microsoft.ai_mailboxes.ai_routing.action_append_case_note": "Legg inn som sakslinje (CAS / saksnummer)",
        "microsoft.ai_mailboxes.ai_routing.action_customer_communication": "Registrer som kundekommunikasjon på sak",
        "microsoft.ai_mailboxes.ai_routing.action_reply_draft_only": "Kun registrer kommunikasjon (og AI svarutkast om aktivert)",
        "microsoft.ai_mailboxes.ai_routing.forward_to_label": "Videresend til (e-post)",
        "microsoft.ai_mailboxes.ai_routing.folder_optional_label": "Mappenavn (valgfritt)",
        "microsoft.ai_mailboxes.ai_routing.folder_optional_hint": "Tomt bruker standard (Archive / Junk Email).",
        "microsoft.ai_mailboxes.ai_routing.folder_placeholder_archive": "Archive",
        "microsoft.ai_mailboxes.ai_routing.folder_placeholder_junk": "Junk Email",
        "microsoft.ai_mailboxes.ai_routing.folder_name_label": "Mappenavn i postkassen",
        "microsoft.ai_mailboxes.ai_routing.folder_placeholder_order": "Ordre",
        "microsoft.ai_mailboxes.ai_routing.folder_order_hint": "Mappen må finnes i Microsoft-postkassen (visningsnavn).",
        "microsoft.ai_mailboxes.ai_routing.cat_promotional_title": "Reklame / nyhetsbrev",
        "microsoft.ai_mailboxes.ai_routing.cat_promotional_desc": "Typisk masseutsendt innhold.",
        "microsoft.ai_mailboxes.ai_routing.cat_order_title": "Ordrebekreftelse",
        "microsoft.ai_mailboxes.ai_routing.cat_order_desc": "Bestillinger og ordredokumenter.",
        "microsoft.ai_mailboxes.ai_routing.cat_inquiry_title": "Ny kundehenvendelse",
        "microsoft.ai_mailboxes.ai_routing.cat_inquiry_desc": "Generell forespørsel uten eksisterende saksnummer i tråden.",
        "microsoft.ai_mailboxes.ai_routing.cat_inquiry_auto_reply_note":
          "Autosvar og signatur stilles inn lenger opp på siden (seksjonene over).",
        "microsoft.ai_mailboxes.ai_routing.cat_supplier_cas_title": "Leverandør (CAS-referanse)",
        "microsoft.ai_mailboxes.ai_routing.cat_supplier_cas_desc":
          "Matcher sak via CAS-token eller Promang saksnummer i innhold. Anbefalt å fylle «ved ingen treff».",
        "microsoft.ai_mailboxes.ai_routing.forward_unmatched_label": "Ved ingen treff — videresend til (e-post)",
        "microsoft.ai_mailboxes.ai_routing.forward_unmatched_hint": "Anbefales så melding ikke blir liggende uten sak.",
        "microsoft.ai_mailboxes.ai_routing.cas_reference_label": "Fast CAS-referanse (valgfritt)",
        "microsoft.ai_mailboxes.ai_routing.cas_reference_hint": "Bare om referansen ikke står i e-posten.",
        "microsoft.ai_mailboxes.ai_routing.case_number_fallback_label": "Fast saksnummer (valgfritt)",
        "microsoft.ai_mailboxes.ai_routing.case_number_fallback_hint": "Talldel av saken, f.eks. 1234, hvis ikke funnet i tekst.",
        "microsoft.ai_mailboxes.ai_routing.cat_case_reply_title": "Svar på eksisterende sak",
        "microsoft.ai_mailboxes.ai_routing.cat_case_reply_desc": "E-post som ser ut til å gjelde en åpen sak (SAK-nummer i tråden).",
        "microsoft.ai_mailboxes.ai_routing.cat_project_title": "Prosjektkorrespondanse",
        "microsoft.ai_mailboxes.ai_routing.cat_project_desc": "E-post fra kjent kunde/part om fremdrift, avvik, byggeledelse osv. — ikke ny generell kundehenvendelse.",
        "microsoft.ai_mailboxes.ai_routing.cat_project_reply_draft_note": "Krever at avsender matcher en kunde i Promang. Aktiver «AI svarutkast» over for utkast i Outlook.",
        "microsoft.ai_mailboxes.ai_routing.json_preview_toggle": "Vis JSON som lagres (kun visning)",
        "microsoft.ai_mailboxes.process_inbox_hint":
          "Velg én eller flere meldinger og kjør behandling (simulering sender ingen e-post; «Kjør» sender videresending når en regel treffer).",
        "microsoft.ai_mailboxes.process_select_all": "Velg alle",
        "microsoft.ai_mailboxes.process_clear_selection": "Fjern valg",
        "microsoft.ai_mailboxes.process_select_column": "Velg",
        "microsoft.ai_mailboxes.process_select_row": "Velg melding",
        "microsoft.ai_mailboxes.process_simulate": "Simuler jobb",
        "microsoft.ai_mailboxes.process_run": "Kjør behandling",
        "microsoft.ai_mailboxes.process_need_selection": "Velg minst én melding i listen.",
        "microsoft.ai_mailboxes.process_run_confirm":
          "Dette kan sende ekte e-post (videresending) for treffende regler. Fortsette?",
        "microsoft.ai_mailboxes.process_ok_simulated":
          "Simulering fullført for {{count}} melding(er). Videresend-regler som ville trigget: {{sim}}. «Ikke sak»-treff: {{skips}}.",
        "microsoft.ai_mailboxes.process_ok_executed":
          "Behandling fullført for {{count}} melding(er). Videresending sendt: {{sent}}. «Ikke sak»-treff: {{skips}}.",
        "microsoft.ai_mailboxes.process_failed": "Kunne ikke behandle valgte meldinger.",
        "microsoft.ai_mailboxes.processing_log.open_tooltip": "Vis behandlingslogg (utvikling)",
        "microsoft.ai_mailboxes.processing_log.title": "Behandlingslogg",
        "microsoft.ai_mailboxes.processing_log.close": "Lukk",
        "microsoft.ai_mailboxes.processing_log.load_failed": "Kunne ikke laste behandlingslogg.",
        "microsoft.ai_mailboxes.processing_log.empty":
          "Ingen lagrede kjøringer for denne meldingen ennå. Bruk Simuler / Kjør behandling, eller vent på planlagt jobb.",
        "microsoft.ai_mailboxes.processing_log.dry_run": "Simulering",
        "microsoft.ai_mailboxes.processing_log.live_run": "Ekte kjøring",
        "microsoft.ai_mailboxes.processing_log.failed": "Feilet",
        "microsoft.ai_mailboxes.processing_log.ok": "OK",
        "microsoft.ai_mailboxes.processing_log.ai_category": "Klassifisering",
        "microsoft.ai_mailboxes.processing_log.confidence": "sikkerhet",
        "microsoft.ai_mailboxes.processing_log.actions": "Handlinger",
        "microsoft.ai_mailboxes.processing_log.raw_json": "Rå data (JSON)",
        "microsoft.ai_mailboxes.processing_log.col_dev": "Logg",
        "microsoft.ai_mailboxes.processing_log.sum.ai_classification":
          "AI: {{category}} ({{source}}, sikkerhet {{confidence}})",
        "microsoft.ai_mailboxes.processing_log.sum.forward_dry": "Videresending (simulert) → {{to}}",
        "microsoft.ai_mailboxes.processing_log.sum.forward_sent": "Videresendt → {{to}}",
        "microsoft.ai_mailboxes.processing_log.sum.forward_failed": "Videresending feilet → {{to}}: {{error}}",
        "microsoft.ai_mailboxes.processing_log.sum.move_dry": "Flytt (simulert){{target}}",
        "microsoft.ai_mailboxes.processing_log.sum.move_ok": "Flyttet → {{folder}}",
        "microsoft.ai_mailboxes.processing_log.sum.move_failed": "Flytt feilet: {{error}}",
        "microsoft.ai_mailboxes.processing_log.sum.skip_case": "Regel: ikke opprett sak",
        "microsoft.ai_mailboxes.processing_log.sum.skip_case_unused": "skip_case (ikke brukt)",
        "microsoft.ai_mailboxes.processing_log.sum.ai_routing_skipped": "AI-ruting hoppet over: {{reason}}",
        "microsoft.ai_mailboxes.processing_log.sum.generic_error": "{{type}}: {{error}}",
        "microsoft.ai_mailboxes.processing_log.sum.generic_not_applied": "{{type}}: ikke utført",
        "subscription.ai_usage.loading": "Laster…",
        "subscription.ai_usage.title": "AI-bruk og estimat",
        "subscription.ai_usage.subtitle":
          "Tokenforbruk, veiledende kostnad og estimert spart tid for selskapet (bare vellykkede AI-kall).",
        "subscription.ai_usage.period.this_month": "Denne måneden",
        "subscription.ai_usage.period.this_year": "Dette året",
        "subscription.ai_usage.period.last_30_days": "Siste 30 dager",
        "subscription.ai_usage.period.last_12_months": "Siste 12 måneder",
        "subscription.ai_usage.load_failed": "Kunne ikke hente AI-bruksstatistikk.",
        "subscription.ai_usage.forbidden": "Du har ikke tilgang til AI-bruk for dette selskapet.",
        "subscription.ai_usage.empty": "Ingen AI-bruk registrert i denne perioden.",
        "subscription.ai_usage.tokens": "Token (totalt)",
        "subscription.ai_usage.calls_ok": "Vellykkede kall",
        "subscription.ai_usage.calls_fail": "Feilede kall",
        "subscription.ai_usage.estimated_cost": "Estimert kostnad (NOK)",
        "subscription.ai_usage.cost_hint":
          "Internt estimat: {{rate}} NOK per 1M token. Ikke faktura — faktisk pris fra leverandør kan avvike.",
        "subscription.ai_usage.time_saved": "Estimert spart tid",
        "subscription.ai_usage.time_hint":
          "Omtrentlige manuelle minutter per vellykket kall, etter funksjonstype. Bare for oversikt.",
        "subscription.ai_usage.minutes_only": "{{minutes}} min",
        "subscription.ai_usage.hours_minutes": "{{hours}} t {{minutes}} min",
        "subscription.ai_usage.by_feature": "Per funksjon",
        "subscription.ai_usage.col_feature": "Funksjon",
        "subscription.ai_usage.col_calls": "Kall",
        "subscription.ai_usage.col_tokens": "Token",
        "subscription.ai_usage.col_cost": "Est. NOK",
        "subscription.ai_usage.col_time": "Est. spart tid",
        "subscription.ai_usage.monthly_overview": "Per måned (i perioden)",
        "subscription.ai_usage.feature.microsoft_ai_mailbox_classify": "AI-innboks — klassifisering",
        "subscription.ai_usage.feature.microsoft_ai_mailbox_case_title": "AI-innboks — sakstittel",
        "subscription.ai_usage.feature.service_report_invoice_description_generate":
          "Servicerapport — fakturapunkt",
        "subscription.ai_usage.feature.service_report_invoice_description_format_report":
          "Servicerapport — HTML-format",
        "subscription.ai_usage.feature.ai_generator_todo": "Oppgaver — AI-assistent",
        "subscription.ai_usage.feature.ai_generator_hse_document": "HMS/KS — AI-felt i dokument",
        "subscription.ai_usage.feature.other": "{{feature}}",

        "Cases": "Saker",
        "Projects": "Prosjekter",
        "Customers": "Kunder",
        "Tasks": "Oppgaver",
        "All modules": "Alle moduler",
        "Label administration": "Etikettadministrasjon",
        "Add label": "Legg til etikett",
        "Scope module": "Modul",
        "Sort order": "Sortering",
        "Statistics": "Statistikk",
        "Cases by label": "Saker per etikett",
        "No labels with cases yet": "Ingen etiketter med saker ennå",
        "No labels defined": "Ingen etiketter definert",
        "Labels": "Etiketter",
        "Are you sure you want to delete this label?":
          "Er du sikker på at du vil slette denne etiketten?",
        "todo.pageTitle": "Arbeidsflate — oppgaver og dagbok",
        "todo.tabTasks": "Oppgaver",
        "todo.loadingMoreTodos": "Laster inn flere oppgaver…",
        "todo.loadMoreError": "Kunne ikke laste flere oppgaver.",
        "todo.filterAll": "Alle",
        "todo.filterActive": "Aktive",
        "todo.filterFinished": "Ferdige",
        "todo.filterMine": "Mine oppgaver",
        "todo.due": "Forfall",
        "todo.todayPlanBadge": "Dagens plan",
        "todo.taskDetails": "Oppgavedetaljer",
        "todo.descriptionPlaceholder": "Legg til beskrivelse…",
        "todo.dueDate": "Forfallsdato",
        "todo.reminder": "Påminnelse",
        "todo.onTodayPlan": "På dagens plan",
        "todo.recurrence": "Gjentakelse ved fullføring",
        "todo.recurrenceNone": "Ingen",
        "todo.recurrenceDaily": "Daglig",
        "todo.recurrenceWeekdays": "Hverdager",
        "todo.recurrenceWeekly": "Ukentlig",
        "todo.recurrenceMonthly": "Månedlig",
        "todo.estimatedHours": "Estimerte timer",
        "todo.labels": "Etiketter",
        "todo.aiAssistant": "AI-assistent",
        "todo.hoursAvailable": "Timer til rådighet i dag (for dagsplan)",
        "todo.aiSuggestions": "Forslag",
        "todo.aiEstimate": "Tidsestimat",
        "todo.aiPlan": "Dagsplan",
        "todo.aiResultTitle": "AI-resultat",
        "todo.aiLoading": "Genererer…",
        "todo.aiError": "Kunne ikke hente forslag fra AI.",
        "todo.hseDocumentTaskManualFinish":
          "HMS/KS-dokumentoppgaver kan ikke ferdigstilles her. Bekreft at du har lest og forstått dokumentet i dokumentvisningen.",
        "todo.hseDocumentOpenLink": "Åpne HMS/KS-dokument",
        "hse.document.acknowledge_read": "Jeg bekrefter at jeg har lest og forstått",
        "hse.document.acknowledge_read_submitting": "Registrerer…",
        "hse.document.acknowledge_read_success": "Registrert som lest/forstått",
        "hse.document.acknowledge_read_error": "Kunne ikke registrere lest/forstått",
        "hse.document.acknowledge_read_hint":
          "Når du har gått gjennom innholdet, bekreft her. Oppgaven i oppgavelisten ferdigstilles automatisk.",
        "hse.document.acknowledge_read_done": "Du er registrert som å ha lest og forstått denne versjonen.",
        "hse.document.approval_stuck_retry_hint":
          "Godkjenningen ser ut til å ha stoppet før versjonen ble publisert. Trykk «Godkjenn versjon» på nytt for å fullføre.",
        "hse.document.file_missing": "Vedlagt fil ble ikke funnet.",
        "hse.document.file_processing": "Filen behandles fortsatt. Prøv igjen om litt.",
        "hse.document.file_failed": "Filopplastingen feilet. Last opp dokumentet på nytt.",
        "hse.document.open_file": "Åpne fil",
        "hse.document.download_file": "Last ned fil",
        "hse.document.attached_file": "Vedlagt fil",
        "todo.journalTitle": "Dagbok / journal",
        "todo.journalDate": "Dato",
        "todo.journalHint": "Notater for valgt dag (HTML). Lagres automatisk.",
        "todo.journalHintRich":
          "Marker tekst for å formatere (som i Notion). Du kan lime inn HTML fra nett og OneNote — uønsket kode fjernes ved lagring.",
        "todo.journalPlaceholder": "Skriv notater for denne dagen…",
        "todo.journalFullscreen": "Fullskjerm",
        "todo.journalExitFullscreen": "Lukk fullskjerm",
        "todo.journalOpenInFullscreen": "Redigering skjer i fullskjermvinduet. Lukk der når du er ferdig.",
        "todo.journalSaveError": "Kunne ikke lagre dagbok.",
        "todo.journalImageTitle": "Bilde",
        "todo.journalImageWidth": "Bredde",
        "todo.journalImageWidthHint": "Piksler (320) eller prosent (50 %).",
        "todo.journalImageHeight": "Høyde",
        "todo.journalImageHeightPlaceholder": "Valgfri (tom = automatisk)",
        "todo.journalImageAlt": "Beskrivelse (alt-tekst)",
        "todo.journalImageSizePresets": "Hurtigstørrelse",
        "todo.journalImageOriginal": "Nullstill størrelse",
        "todo.journalImageAlign": "Justering",
        "todo.journalImageAlignLeft": "Venstre",
        "todo.journalImageAlignCenter": "Senter",
        "todo.journalImageAlignRight": "Høyre",
        "todo.journalImageApply": "Bruk",
        "todo.journalImageRemove": "Fjern bilde",
        "todo.digestTitle": "E-post påminnelser",
        "todo.digestMorning": "Morgen (ca. 07:00, din tidssone)",
        "todo.digestEvening": "Kveld (ca. 17:00)",
        "todo.digestTimezone": "Tidssone",
        "todo.digestSaved": "Innstillinger lagret",
        "todo.digestSaveError": "Kunne ikke lagre e-postinnstillinger.",
        "todo.prevDay": "Forrige dag",
        "todo.nextDay": "Neste dag",
        "todo.today": "I dag",
        "richTextEditor.contextMenu.ariaLabel": "Handlinger for rik tekst",
        "richTextEditor.contextMenu.insertImage": "Sett inn bilde…",
        "richTextEditor.contextMenu.moveSelectionToPage": "Flytt merking til side…",
        "richTextEditor.contextMenu.createPageWithSelection": "Ny side fra merking…",
        "richTextEditor.contextMenu.handlerMissing": "Knytt en behandler i foreldrekomponenten for å bruke denne handlingen.",
        "richTextEditor.table.insert": "Sett inn tabell",
        "richTextEditor.table.hint": "Legger til en redigerbar 3 x 3-tabell.",
        "richTextEditor.table.defaultHeader": "Kolonne",
        "automile.checkoutConfirmTitle": "Sjekke ut av kjøretøy?",
        "automile.checkoutConfirmMessage": "Er du sikker på at du vil sjekke ut? Kjøretøyet blir frigjort for andre sjåfører.",
        "automile.checkoutConfirm": "Ja, sjekk ut",
        "automile.checkoutCancel": "Avbryt",
        "automile.checkInDriver": "Sjekk inn sjåfør",
        "automile.checkOutVehicle": "Sjekk ut sjåfør",
        "automile.linkUser": "Knytt bruker",
        "automile.selectEmployee": "Velg ansatt",
        "automile.noVehiclesAvailable": "Ingen ledige kjøretøy (aktive og uten innlogget sjåfør).",
        "automile.settingsHint": "Fullfør Automile under Firma → Integrasjoner.",
        "automile.driverNeedsSync": "Sjåføren må være synkronisert med Automile før innlogging.",
        "automile.onlyAvailableVehiclesSubtitle": "Bare aktive kjøretøy uten innlogget sjåfør vises.",
        "automile.noDriversFreeForCheckin": "Ingen sjåfører uten innlogget kjøretøy (med tilkoblet bruker).",
        "automile.adminVehiclePickerSubtitle":
          "Alle aktive kjøretøy vises. Er kjøretøyet sjekket inn på noen andre, flyttes det til denne sjåføren når du velger det (for flåteansvarlige).",
        "automile.noActiveVehiclesForFleet": "Ingen aktive kjøretøy funnet.",
        "automile.vehicleOccupiedBadge": "Innlogget — ny tildeling sjekker ut nåværende sjåfør først",

        "platformBroadcast.scheduledLabel": "Planlagt oppdatering",
        "platformBroadcast.countdownPrefix": "Om {{time}}",
        "platformBroadcast.scheduledOverdue": "Starttid er nådd — lagre arbeidet ditt",
        "platformBroadcast.activeNoticesRegion": "Aktive meldinger fra Promang",
        "platformBroadcast.noticeWarningTag": "Advarsel",
        "platformBroadcast.noticeInfoTag": "Info",
        "platformBroadcast.updatingTitle": "Promang oppdateres",
        "platformBroadcast.updatingHint": "Vi er tilbake så snart oppdateringen er ferdig. Takk for tålmodigheten.",
        "platformBroadcast.updatingAdminHint":
          "Administrator: Når du er ferdig med utrullingen, trykk på skiftenøkkelen nede til høyre og velg «Bekreft at Promang er oppdatert».",
        "platformBroadcast.dev.menuAria": "Plattform-dev-meny",
        "platformBroadcast.dev.noActiveUpdate": "Ingen aktiv vedlikeholdssesjon.",
        "platformBroadcast.dev.statusLine": "{{phase}}: {{title}}",
        "platformBroadcast.dev.scheduleUpdate": "Planlegg oppdatering",
        "platformBroadcast.dev.startMaintenance": "Start vedlikehold (oppdatering pågår)",
        "platformBroadcast.dev.confirmComplete": "Bekreft at Promang er oppdatert",
        "platformBroadcast.dev.addNotice": "Legg til melding (info / advarsel)",
        "platformBroadcast.dev.manageNotices": "Håndter meldinger",
        "platformBroadcast.dev.fieldTitle": "Tittel",
        "platformBroadcast.dev.fieldDescription": "Beskrivelse",
        "platformBroadcast.dev.fieldScheduledAt": "Tidspunkt for oppdatering",
        "platformBroadcast.dev.fieldExpectedEnd": "Forventet ferdig ca.",
        "platformBroadcast.dev.fieldKind": "Type",
        "platformBroadcast.dev.kindInfo": "Info",
        "platformBroadcast.dev.kindWarning": "Advarsel",
        "platformBroadcast.dev.cancel": "Avbryt",
        "platformBroadcast.dev.save": "Lagre",
        "platformBroadcast.dev.start": "Start",
        "platformBroadcast.dev.close": "Lukk",
        "platformBroadcast.dev.maintenanceHint": "Brukere ser nå fullskjerms «Promang oppdateres» med nedtelling til forventet slutt.",
        "platformBroadcast.dev.validationTitleTime": "Fyll inn tittel og tidspunkt.",
        "platformBroadcast.dev.validationTitle": "Fyll inn tittel.",
        "platformBroadcast.dev.invalidTime": "Ugyldig tidspunkt.",
        "platformBroadcast.dev.saved": "Planlagt oppdatering er lagret.",
        "platformBroadcast.dev.maintenanceStarted": "Vedlikehold startet.",
        "platformBroadcast.dev.confirmCompletePrompt": "Bekreft at oppdateringen er ferdig og fjern alle vedlikeholdsmeldinger for denne runden?",
        "platformBroadcast.dev.confirmed": "Bekreftet.",
        "platformBroadcast.dev.noticeCreated": "Melding opprettet.",
        "platformBroadcast.dev.noticeHidden": "Melding skjult.",
        "platformBroadcast.dev.noticeShown": "Melding vist igjen.",
        "platformBroadcast.dev.requestFailed": "Forespørsel feilet.",
        "platformBroadcast.dev.historyHint": "Skjul meldinger når problemet er løst. Oppdateringshistorikk lagres i databasen.",
        "platformBroadcast.dev.recentUpdates": "Siste planlagte oppdateringer",
        "platformBroadcast.dev.allNotices": "Alle meldinger",
        "platformBroadcast.dev.hidden": "skjult",
        "platformBroadcast.dev.hide": "Skjul",
        "platformBroadcast.dev.show": "Vis igjen",
        "platformBroadcast.dev.roleViewMenu": "Simuler rollevisning (kun UI)",
        "platformBroadcast.dev.roleViewTitle": "Hvordan Promang ser ut for deg",
        "platformBroadcast.dev.roleViewTabPresets": "Forhåndsvalg",
        "platformBroadcast.dev.roleViewTabCustom": "Tilpasset (som brukeradmin)",
        "platformBroadcast.dev.roleViewHintCustom":
          "Samme brytere som under Selskap → Brukere. Trykk «Bruk simulering» nederst når du er ferdig.",
        "platformBroadcast.dev.roleViewCustomApply": "Bruk simulering",
        "platformBroadcast.dev.roleViewHint":
          "Gjelder bare denne nettleseren: meny, rutetilgang, RoleOnly og tilhørende hooks. API-et bruker fortsatt dine ekte rettigheter.",
        "platformBroadcast.dev.roleViewApply": "Bruk",
        "platformBroadcast.dev.roleViewReset": "Nullstill simulering",
        "platformBroadcast.dev.roleViewResetNow": "Nullstill simulering",
        "platformBroadcast.dev.roleViewActiveBanner":
          "Rolle-simulering er på — grensesnittet viser ikke dine ekte rettigheter.",
        "platformBroadcast.dev.roleViewToastApplied": "Rolle-simulering oppdatert.",
        "platformBroadcast.dev.roleViewToastReset": "Rolle-simulering fjernet.",
        "platformBroadcast.dev.roleViewPreset.off.label": "Ekte rettigheter",
        "platformBroadcast.dev.roleViewPreset.off.description":
          "Bruk roller fra serveren (standard).",
        "platformBroadcast.dev.roleViewPreset.none.label": "Ingen roller",
        "platformBroadcast.dev.roleViewPreset.none.description":
          "Tom rolliste — nesten ingen moduler i menyen.",
        "platformBroadcast.dev.roleViewPreset.hours_time_only.label":
          "Kun timeregistrering",
        "platformBroadcast.dev.roleViewPreset.hours_time_only.description":
          "Timer-modul med registrering/redigering av egne timer — ikke godkjenning, innstillinger eller fravær.",
        "platformBroadcast.dev.roleViewPreset.hours_extended.label":
          "Timer + godkjenning og fravær",
        "platformBroadcast.dev.roleViewPreset.hours_extended.description":
          "Bred timer-profil: lister, godkjenning, lesetilgang til innstillinger, fraværsregistrering.",
        "platformBroadcast.dev.roleViewPreset.service_field.label":
          "Service ute i felt",
        "platformBroadcast.dev.roleViewPreset.service_field.description":
          "Fokus på serviceoversikt og rapporter; begrenset avtaletilgang.",
        "platformBroadcast.dev.roleViewPreset.projects_participant.label":
          "Prosjektdeltaker",
        "platformBroadcast.dev.roleViewPreset.projects_participant.description":
          "Prosjekter og arbeidsordrer med typiske utfører-handlinger.",
        "Send Offer": "Send tilbud",
        "Choose recipient, offer PDF version and customer message before sending.":
          "Velg mottaker, PDF-variant og kundemelding før tilbudet sendes.",
        "Offer sending has been queued. You will be notified when it's complete.":
          "Tilbudssending er lagt i kø. Du får beskjed når den er ferdig.",
        "Something went wrong. Could not send offer.":
          "Noe gikk galt. Kunne ikke sende tilbudet.",
        "Offer Type": "Tilbudstype",
        "Internal offer": "Internt tilbud",
        "Customer offer": "Kundetilbud",
        "Open selected offer PDF": "Åpne valgt tilbuds-PDF",
        "PDF preview will be available when the selected offer type is generated.":
          "PDF-forhåndsvisning blir tilgjengelig når valgt tilbudstype er generert.",
        "Message to customer": "Melding til kunde",
        "Offer sent successfully!": "Tilbudet ble sendt.",
        "Offer sending queued...": "Tilbudssending er lagt i kø...",
        "Generating PDF and sending offer...":
          "Genererer PDF og sender tilbud...",
        "Failed to send offer": "Kunne ikke sende tilbud",
        "Failed to send offer. Please try again.":
          "Kunne ikke sende tilbudet. Prøv igjen.",
        "Request timed out. Please check the offer status manually.":
          "Forespørselen tok for lang tid. Sjekk tilbudsstatus manuelt.",
        "publicAppointment.title": "Bekreft avtalen",
        "publicAppointment.subtitle": "Kontroller detaljene og bekreft at tidspunktet fortsatt passer.",
        "publicAppointment.sectionAppointment": "Avtale",
        "publicAppointment.sectionWork": "Oppdraget",
        "publicAppointment.reportType": "Type oppdrag",
        "publicAppointment.serviceAddress": "Oppdragsadresse",
        "publicAppointment.workDescription": "Oppdragsbeskrivelse",
        "publicAppointment.timeExactHint": "Oppmøte skjer omtrent ved dette tidspunktet.",
        "publicAppointment.timeWindowHint": "Oppmøte skjer innenfor dette tidsrommet.",
        "publicAppointment.reportNumber": "Oppdrag / rapportnr.",
        "publicAppointment.date": "Dato",
        "publicAppointment.time": "Tid",
        "publicAppointment.companyFallback": "Leverandør",
        "publicAppointment.confirmHint":
          "Når du bekrefter, registrerer vi avtalen som akseptert. Trenger du endringer, ta kontakt på telefon eller e-post.",
        "publicAppointment.termsAcceptPlain":
          "Ved å bekrefte avtalen godtar du våre betingelser for bruk av tjenester, salg og serviceavtaler.",
        "publicAppointment.termsAcceptPrefix": "Ved å bekrefte avtalen godtar du våre ",
        "publicAppointment.termsAcceptLink": "betingelser for bruk av tjenester, salg og serviceavtaler",
        "publicAppointment.termsAcceptSuffix": ".",
        "publicAppointment.confirmButton": "Bekreft avtalen",
        "publicAppointment.submitting": "Bekrefter…",
        "publicAppointment.successTitle": "Takk — avtalen er bekreftet",
        "publicAppointment.successBody": "Du kan lukke siden. Ved endringer, kontakt selskapet direkte.",
        "publicAppointment.alreadyConfirmed": "Denne avtalen er allerede bekreftet.",
        "publicAppointment.loadFailed": "Vi fant ikke avtalen. Lenken kan være ugyldig eller utløpt.",
        "publicAppointment.confirmFailed": "Vi kunne ikke registrere bekreftelsen. Prøv igjen eller ta kontakt.",
        "publicAppointment.missingToken": "Bekreftelseslenken mangler nødvendig informasjon.",
      },
}